import React, { Component } from "react";
import { Switch, Route, NavLink } from "react-router-dom";
import {
  Layout,
  Menu,
  Button,
  Spin,
  List,
  Badge,
  message,
  notification,
} from "antd";


import {
  IconAirTable,
  IconArchive,
  IconAutofitLeft,
  IconBuildingWarehouse,
  IconClipBoardHeart,
  IconFriends,
  IconListDetails,
  IconStethoscope,
  IconTagStarred,
  IconAdjustmentsCog,
  IconBed,
  IconLayoutDashboard,
  IconTimeline,
  IconPaw,
  IconDeer,
  IconFeather,
  IconShoppingBag,
  IconShoppingCart,
  IconCoins,
  IconReceiptDollars,
  IconAfiliate,
  IconBriefCase,
  IconLayersIntersect,
  IconChartDots,
  IconReceiptDollar,
  IconInvoice,
  IconListTree,
  IconFileInvoice,
  IconAlarm,
  IconCreditCard,
  IconSupport,
  IconCalculator,
  IconCone,
  IconCalendarRepeat,
  IconAbacus,
  IconChecklist,
  IconShoppingCartConfig,
  IconBuild,
  FileChart,
  IconClockPin,
  IconClockCheck,
  IconCalendarTime,
  IconCalendarCheck,
  IconCalendarClock,
  IconClockCog,
  IconBedFlat,
  IconCalendarClock24,
  IconCalendarMonth,
  IconTruckDelivery,
  IconArrowsSplit,
  IconTiposDeActivo,
  IconActivos,
  IconInventarioActivos,
  IconDepreciaciones,
} from "../../Icons/Icons";
import {
  IconCMMS,
  IconInicioCMMS,
  IconViajesCMMS,
  IconAgendaCMMS,
  IconServiciosCMMS,
  IconTicketsCMMS,
  IconContratosCMMS,
  IconActivosCMMS,
  IconTiposActivoCMMS,
  IconRutinasCMMS,
  IconCertificadosCMMS,
  IconReportesCMMS,
  IconConfiguracionCMMS,
} from "../../Icons/IconosCMMS";
import {
  HomeOutlined,
  ContactsOutlined,
  // TeamOutlined,
  SettingOutlined,
  // UserOutlined,
  ShopOutlined,
  LogoutOutlined,
  //   SolutionOutlined,
  //   BookOutlined,
  BankOutlined,
  BankFilled,
  BookOutlined,
  InteractionOutlined,
  ShoppingCartOutlined,
  ProfileOutlined,
  DollarOutlined,
  ShopFilled,
  FundProjectionScreenOutlined,
  ProjectOutlined,
  EnvironmentOutlined,
  ExpandOutlined,
  DollarCircleFilled,
  ContainerOutlined,
  ReconciliationOutlined,
  //  SolutionOutlined,
  ReconciliationFilled,
  TagsOutlined,
  ReadOutlined,
  BookFilled,
  ClusterOutlined,
  CalendarOutlined,
  LayoutOutlined,
  WalletOutlined,
  FileDoneOutlined,
  DropboxOutlined,
  FileTextOutlined,
  ToolOutlined,
  GroupOutlined,
  IdcardOutlined,
  IdcardFilled,
  ToolFilled,
  SwapOutlined,
  // DropboxCircleFilled,
  // CloudDownloadOutlined,
  OrderedListOutlined,
  NodeIndexOutlined,
  BarsOutlined,
  DropboxSquareFilled,
  DiffOutlined,
  DiffFilled,
  LineChartOutlined,
  FundFilled,
  CloudServerOutlined,
  //TeamOutlined,
  UserOutlined,
  ControlOutlined,
  TagsFilled,
  CalculatorOutlined,
  CalculatorFilled,
  SnippetsOutlined,
  SnippetsFilled,
  CarOutlined,
  MenuOutlined,
  RollbackOutlined,
  BellOutlined,
  DownloadOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  InfoCircleOutlined,
  TeamOutlined,
  InteractionFilled,
  HistoryOutlined,
  AuditOutlined,
  SendOutlined,
  FileProtectOutlined,
  UsergroupAddOutlined,
  ClockCircleOutlined,
  TableOutlined,
  CheckCircleFilled,
  ScheduleOutlined,
  WhatsAppOutlined,
  SearchOutlined,
  AlertOutlined,
  //UsergroupAddOutlined,
  //ClockCircleOutlined,
  //TableOutlined,
  // UsergroupAddOutlined,
  // ClockCircleOutlined
  CustomerServiceOutlined,
} from "@ant-design/icons";

import { connect } from "react-redux";
import logoHorizontal from "../../assets/Biwo_Horizontal.png";
import {
  contarVentasPPendientes,
  contarSugerenciasPendientes,
  contarEvaluacionesProveedorPendientes,
  deseleccionarEmpresa,
} from "../../store/actions/empresa";
import { logout } from "../../store/actions/user";
import BuscadorMenuInput from "../../Components/BuscadorMenuInput";
import Inicio from "./Inicio/Inicio";
import Proveedores from "./Proveedores/Proveedores";
import Insumos from "./Insumos/Insumos";
import ConfiguracionCategoriasInsumos from "./ConfiguracionCategoriasInsumos/ConfiguracionCategoriasInsumos";
import Configuracion from "./Configuracion/Configuracion";
import CuentasContables from "./CuentasContables/CuentasContables";
import ImportarCuentasContables from "./CuentasContables/ImportarCuentasContables/ImportarCuentasContables";
import AgregarProveedor from "./Proveedores/AgregarProveedor/AgregarProveedor";
import EditarProveedor from "./Proveedores/EditarProveedor/EditarProveedor";
import AgregarInsumo from "./Insumos/AgregarInsumo/AgregarInsumo";
import EditarInsumo from "./Insumos/EditarInsumo/EditarInsumo";
import TiposDeProveedores from "./TiposDeProveedores/TiposDeProveedores";
import AgregarTipoDeProveedor from "./TiposDeProveedores/AgregarTipoDeProveedor/AgregarTipoDeProveedor";
import Impuestos from "./Impuestos/Impuestos";
import AgregarImpuesto from "./Impuestos/AgregarImpuesto/AgregarImpuesto";
import TiposDePolizas from "./TiposDePolizas/TiposDePolizas";
import TiposDeFlujos from "./TiposDeFlujos/TiposDeFlujos";
import OrdenesDeCompras from "./OrdenesDeCompras/OrdenesDeCompras";
import AgregarOrdenDeCompra from "./OrdenesDeCompras/AgregarOrdenDeCompra/AgregarOrdenDeCompra";
import ProrratearOrdenDeCompra from "./OrdenesDeCompras/ProrratearOrdenDeCompra/ProrratearOrdenDeCompra";
import InsumosPendientesOrdenDeCompra from "./OrdenesDeCompras/InsumosPendientesOrdenDeCompra/InsumosPendientesOrdenDeCompra";
import Familias from "./Familias/Familias";
import TiposDeActivo from "./TiposDeActivo/TiposDeActivo";
import ActivosFijos from "./ActivosFijos/ActivosFijos";
import InventarioActivos from "./InventarioActivos/InventarioActivos";
import UnidadesActivoFijo from "./InventarioActivos/UnidadesActivoFijo/UnidadesActivoFijo";
import MovimientosActivos from "./InventarioActivos/MovimientosActivos/MovimientosActivos";
import CorrerDepreciacion from "./InventarioActivos/CorrerDepreciacion/CorrerDepreciacion";
// Modulo CMMS (Mantenimiento de Equipo Medico)
import ActivosCMMS from "./CMMS/Activos/Activos";
import FichaActivoCMMS from "./CMMS/Activos/FichaActivo/FichaActivo";
import TiposActivoCMMS from "./CMMS/TiposActivo/TiposActivo";
import ConfiguracionCMMS from "./CMMS/Configuracion/ConfiguracionCMMS";
import ImportarActivosCMMS from "./CMMS/Activos/ImportarActivos";
import ServiciosCMMS from "./CMMS/Servicios/Servicios";
import ServicioCMMS from "./CMMS/Servicios/Servicio";
import TicketsCMMS from "./CMMS/Tickets/Tickets";
import RutinasCMMS from "./CMMS/Rutinas/Rutinas";
import ContratosCMMS from "./CMMS/Contratos/Contratos";
import ContratoCMMS from "./CMMS/Contratos/Contrato";
import ImportarProgramaContratoCMMS from "./CMMS/Contratos/ImportarProgramaContrato";
import AgendaCMMS from "./CMMS/Agenda/Agenda";
import InicioCMMS from "./CMMS/Inicio/InicioCMMS";
import ViajesCMMS from "./CMMS/Viajes/Viajes";
import ReportesCMMS from "./CMMS/Reportes/ReportesCMMS";
import ReporteCMMS from "./CMMS/Reportes/ReporteCMMS";
import CertificadosCMMS from "./CMMS/Certificados/Certificados";
import PlantillaCertificadoCMMS from "./CMMS/Certificados/PlantillaCertificado";
import UnidadesDeNegocio from "./UnidadesDeNegocio/UnidadesDeNegocio";
import Proyectos from "./Proyectos/Proyectos";
import Ubicaciones from "./Ubicaciones/Ubicaciones";
import ImportarUbicaciones from "./Ubicaciones/ImportarUbicaciones/ImportarUbicaciones";
import MapaWms from "./Ubicaciones/MapaWms/MapaWms";
import MapaAlmacenEditor from "./Ubicaciones/MapaAlmacenEditor/MapaAlmacenEditor";
import MapaHotel from "./Hoteleria/MapaHotel/MapaHotel";
import MapaHotelEditor from "./Hoteleria/MapaHotelEditor/MapaHotelEditor";
import OcupacionFuturo from "./Hoteleria/OcupacionFuturo/OcupacionFuturo";
import AgendaHotel from "./Hoteleria/AgendaHotel/AgendaHotel";
import AcomodoRackPagina from "./Ubicaciones/MapaWms/AcomodoRackPagina";
import Bancos from "./Bancos/Bancos";
import Creditos from "./Creditos/Creditos";
import VerCredito from "./Creditos/VerCredito/VerCredito";
import RecibirInsumos from "./OrdenesDeCompras/RecibirInsumos/RecibirInsumos";
import CargosAbonos from "./CargosAbonos/CargosAbonos";
import ReclasificacionCargosAbonos from "./ReclasificacionCargosAbonos/ReclasificacionCargosAbonos";
import RecibirFactura from "./OrdenesDeCompras/RecibirFactura/RecibirFactura";
import RecibirFacturaMultiple from "./OrdenesDeCompras/RecibirFacturaMultiple/RecibirFacturaMultiple";
import FacturasSinOrdenDeCompra from "./FacturasSinOrdenDeCompra/FacturasSinOrdenDeCompra";
import Remisiones from "./Remisiones/Remisiones";
import AgregarRemision from "./Remisiones/AgregarRemision/AgregarRemision";
import VerRemision from "./Remisiones/VerRemision/VerRemision";
import RecibirInsumosRemision from "./Remisiones/RecibirInsumosRemision/RecibirInsumosRemision";
import AgregarFactura from "./FacturasSinOrdenDeCompra/AgregarFactura/AgregarFactura";
import ImportarFacturasXmlMasivo from "./FacturasSinOrdenDeCompra/ImportarFacturasXmlMasivo/ImportarFacturasXmlMasivo";
import ImportarGastosXml from "./FacturasSinOrdenDeCompra/ImportarGastosXml/ImportarGastosXml";
import AgregarFacturaCajaChica from "./FacturasCajaChica/AgregarFactura/AgregarFactura";
import RecibirInsumosFactura from "./FacturasSinOrdenDeCompra/RecibirInsumosFactura/RecibirInsumosFactura";
import ProrratearFactura from "./FacturasSinOrdenDeCompra/ProrratearFactura/ProrratearFactura";
import Prorrateos from "./Prorrateos/Prorrateos";
import VerProrrateo from "./Prorrateos/VerProrrateo/VerProrrateo";
import CuentasPorPagar from "./CuentasPorPagar/CuentasPorPagar";
import PagarFactura from "./CuentasPorPagar/PagarFactura/PagarFactura";
import VerFacturasProveedor from "./CuentasPorPagar/VerFacturasProveedor/VerFacturasProveedor";
import Clientes from "./Clientes/Clientes";
import Escuela from "./Escuela/Escuela";
import AgregarCliente from "./Clientes/AgregarCliente/AgregarCliente";
import TiposDeClientes from "./TiposDeClientes/TiposDeClientes";
import AgregarTipoDeCliente from "./TiposDeClientes/AgregarTipoDeCliente/AgregarTipoDeCliente";
import Ventas from "./Ventas/Ventas";
import AgregarVenta from "./Ventas/AgregarVenta/AgregarVenta";
import EntregarInsumosVenta from "./Ventas/EntregarInsumosVenta/EntregarInsumosVenta";
import EntregarInsumosEmbarque from "./Embarques/EntregarInsumosEmbarque/EntregarInsumosEmbarque";
import GenerarFactura from "./Ventas/GenerarFactura/GenerarFactura";
import CuentasPorCobrar from "./CuentasPorCobrar/CuentasPorCobrar";
import CobrarVenta from "./CuentasPorCobrar/CobrarVenta/CobrarVenta";
import VerVentasCliente from "./CuentasPorCobrar/VerVentasCliente/VerVentasCliente";
import Polizas from "./Polizas/Polizas";
import VerPoliza from "./Polizas/VerPoliza/VerPoliza";
import VerPolizasFactura from "./Polizas/VerPolizasFactura/VerPolizasFactura";
import EditarCliente from "./Clientes/EditarCliente/EditarCliente";
import EditarTipoDeCliente from "./TiposDeClientes/EditarTipoDeCliente/EditarTipoDeCliente";
import Retenciones from "./Retenciones/Retenciones";
import AgregarRetencion from "./Retenciones/AgregarRetencion/AgregarRetencion";
import EditarImpuesto from "./Impuestos/EditarImpuesto/EditarImpuesto";
import EditarRetencion from "./Retenciones/EditarRetencion/EditarRetencion";
import EditarTipoDeProveedor from "./TiposDeProveedores/EditarTipoDeProveedor/EditarTipoDeProveedor";
import CajaEfectivo from "./CajaEfectivo/CajaEfectivo";
import FacturasCajaChica from "./FacturasCajaChica/FacturasCajaChica";
import ReponerCajaChica from "./CajaEfectivo/ReponerCajaChica/ReponerCajaChica";
import PagarCxpCajaChica from "./CajaEfectivo/PagarCxpCajaChica/PagarCxpCajaChica";
import TraspasoEntreCuentas from "./Bancos/TraspasoEntreCuentas/TraspasoEntreCuentas";
import PolizaManual from "./Polizas/PolizaManual/PolizaManual";
import ImportarPolizas from "./Polizas/ImportarPolizas/ImportarPolizas";
import Inventario from "./Inventario/Inventario";
import Almacen from "./Almacen/Almacen";
import DetalleOrdenAlmacen from "./Almacen/DetalleOrdenAlmacen/DetalleOrdenAlmacen";
import RequerirMaterialOrden from "./Almacen/RequerirMaterialOrden/RequerirMaterialOrden";
import RequerirMaterialOrdenes from "./Almacen/RequerirMaterialOrdenes/RequerirMaterialOrdenes";
import MovimientosInventario from "./MovimientosInventario/MovimientosInventario";
import VerMovimientoInventario from "./MovimientosInventario/VerMovimientoInventario/VerMovimientoInventario";
import ImportarClientes from "./Clientes/ImportarClientes/ImportarClientes";
import ConfiguracionClientes from "./Clientes/ConfiguracionClientes/ConfiguracionClientes";
import ImportarProveedores from "./Proveedores/ImportarProveedores/ImportarProveedores";
import LeerXml from "./LeerXml/LeerXml";
import Servicios from "./Servicios/Servicios";
import AgregarServicio from "./Servicios/AgregarServicio/AgregarServicio";
import EditarServicio from "./Servicios/EditarServicio/EditarServicio";
import InsumosCompuestos from "./InsumosCompuestos/InsumosCompuestos";
import AgregarInsumoCompuesto from "./InsumosCompuestos/AgregarInsumoCompuesto/AgregarInsumoCompuesto";
import EditarInsumoCompuesto from "./InsumosCompuestos/EditarInsumoCompuesto/EditarInsumoCompuesto";
import CostearVenta from "./Ventas/CostearVenta/CostearVenta";
import VerVenta from "./Ventas/VerVenta/VerVenta";
import VerFacturaSinOrdenDeCompra from "./FacturasSinOrdenDeCompra/VerFacturaSinOrdenDeCompra/VerFacturaSinOrdenDeCompra";
import VerFacturaCajaChica from "./FacturasCajaChica/VerFacturaCajaChica/VerFacturaCajaChica";
import PuntoDeVenta from "./Ventas/PuntoDeVenta/PuntoDeVenta";
import Produccion from "./Produccion/Produccion";
import AgregarOrdenDeProduccion from "./Produccion/AgregarOrdenDeProduccion/AgregarOrdenDeProduccion";
import TraspasoEntreAlmacenes from "./TraspasoEntreAlmacenes/TraspasoEntreAlmacenes";
import AgregarTraspasoEntreAlmacenes from "./TraspasoEntreAlmacenes/AgregarTraspasoEntreAlmacenes/AgregarTraspasoEntreAlmacenes";
import ScrollToTopItem from "../../Components/ScrollToTopItem";
import ReporteVentas from "./Reportes/ReporteVentas/ReporteVentas";
import ReporteNotasDeCreditoVenta from "./Reportes/ReporteNotasDeCreditoVenta/ReporteNotasDeCreditoVenta";
import EditarPolizaManual from "./Polizas/EditarPolizaManual/EditarPolizaManual";
import ConciliacionesCuenta from "./Bancos/ConciliacionesCuenta/ConciliacionesCuenta";
import Conciliacion from "./Bancos/ConciliacionesCuenta/Conciliacion/Conciliacion";
import DescargaMasiva from "./DescargaMasiva/DescargaMasiva";
import ListaDeMateriales from "./ListaDeMateriales/ListaDeMateriales";
import AgregarListaDeMateriales from "./ListaDeMateriales/AgregarListaDeMateriales/AgregarListaDeMateriales";
import EditarListaDeMateriales from "./ListaDeMateriales/EditarListaDeMateriales/EditarListaDeMateriales";
import AgregarOrdenDeProduccionConLista from "./Produccion/AgregarOrdenDeProduccionConLista/AgregarOrdenDeProduccionConLista";
import Requisiciones from "./Requisiciones/Requisiciones";
import AgregarRequisicion from "./Requisiciones/AgregarRequisicion/AgregarRequisicion";
import EditarRequisicion from "./Requisiciones/EditarRequisicion/EditarRequisicion";
import GenerarOrdenDeCompra from "./Requisiciones/GenerarOrdenDeCompra/GenerarOrdenDeCompra";
import SugerenciasRequisicion from "./SugerenciasRequisicion/SugerenciasRequisicion";
import EditarOrdenDeCompra from "./OrdenesDeCompras/EditarOrdenDeCompra/EditarOrdenDeCompra";
import AgregarInventario from "./AgregarInventario/AgregarInventario";
import AgregarOrdenAgregarInventario from "./AgregarInventario/AgregarOrdenAgregarInventario/AgregarOrdenAgregarInventario";
import VerOrdenAgregarInventario from "./AgregarInventario/VerOrdenAgregarInventario/VerOrdenAgregarInventario";
import EditarOrdenAgregarInventario from "./AgregarInventario/EditarOrdenAgregarInventario/EditarOrdenAgregarInventario";
import AgregarOrdenProductosAlCosto from "./ProductosAlCosto/AgregarOrdenProductosAlCosto/AgregarOrdenProductosAlCosto";
import ProductosAlCosto from "./ProductosAlCosto/ProductosAlCosto";
import VerOrdenProductosAlCosto from "./ProductosAlCosto/VerOrdenProductosAlCosto/VerOrdenProductosAlCosto";
import EditarOrdenProductosAlCosto from "./ProductosAlCosto/EditarOrdenProductosAlCosto/EditarOrdenProductosAlCosto";
import VerOrdenDeCompra from "./OrdenesDeCompras/VerOrdenDeCompra/VerOrdenDeCompra";
import VerFacturaOrdenDeCompra from "./OrdenesDeCompras/VerFacturaOrdenDeCompra/VerFacturaOrdenDeCompra";
import Reportes from "./Reportes/Reportes";
import CreadorDeReportes from "./CreadorDeReportes/CreadorDeReportes";
import ReporteCompras from "./Reportes/ReporteCompras/ReporteCompras";
import InventarioProducto from "./Inventario/InventarioProducto/InventarioProducto";
import ReporteInventario from "./Reportes/ReporteInventario/ReporteInventario";
import ReporteCostoInventario from "./Reportes/ReporteCostoInventario/ReporteCostoInventario";
import ReporteCostoVsUltimaCompra from "./Reportes/ReporteCostoVsUltimaCompra/ReporteCostoVsUltimaCompra";
import ReporteCostosPorInsumo from "./Reportes/ReporteCostosPorInsumo/ReporteCostosPorInsumo";
import ReporteInsumosYProveedores from "./Reportes/ReporteInsumosYProveedores/ReporteInsumosYProveedores";
import ReporteInsumosYEquivalencias from "./Reportes/ReporteInsumosYEquivalencias/ReporteInsumosYEquivalencias";
import ReporteCuentasPorCobrar from "./Reportes/ReporteCuentasPorCobrar/ReporteCuentasPorCobrar";
import ReporteCuentasPorPagar from "./Reportes/ReporteCuentasPorPagar/ReporteCuentasPorPagar";
import ReporteEstadoDePosicionFinanciera from "./Reportes/ReporteEstadoDePosicionFinanciera/ReporteEstadoDePosicionFinanciera";
import ReporteEstadoDeResultados from "./Reportes/ReporteEstadoDeResultados/ReporteEstadoDeResultados";
import ReporteEstadoDeResultadosPorPeriodo from "./Reportes/ReporteEstadoDeResultadosPorPeriodo/ReporteEstadoDeResultadosPorPeriodo";
import ReporteEstadoDeCuenta from "./Reportes/ReporteEstadoDeCuenta/ReporteEstadoDeCuenta";
import ReporteBalanzaDeComprobacion from "./Reportes/ReporteBalanzaDeComprobacion/ReporteBalanzaDeComprobacion";
import ReporteFlujoDeEfectivo from "./Reportes/ReporteFlujoDeEfectivo/ReporteFlujoDeEfectivo";
import Presupuestos from "./Presupuestos/Presupuestos";
import AgregarPresupuesto from "./Presupuestos/AgregarPresupuesto/AgregarPresupuesto";
import EditarPresupuesto from "./Presupuestos/EditarPresupuesto/EditarPresupuesto";
import ReporteFlujoDeEfectivoPresupuestado from "./Reportes/ReporteFlujoDeEfectivoPresupuestado/ReporteFlujoDeEfectivoPresupuestado";
import ReporteFlujoDeTesorefia from "./Reportes/ReporteFlujoDeTesorefia/ReporteFlujoDeTesorefia";
import ReporteFlujoDeEfectivoDiario from "./Reportes/ReporteFlujoDeEfectivoDiario/ReporteFlujoDeEfectivoDiario";
import AgregarNotaDeCredito from "./NotasDeCredito/AgregarNotaDeCredito/AgregarNotaDeCredito";
import ImportarNotasDeCreditoXml from "./NotasDeCredito/ImportarNotasDeCreditoXml/ImportarNotasDeCreditoXml";
import VerNotaDeCredito from "./NotasDeCredito/VerNotaDeCredito/VerNotaDeCredito";
import ReportePagos from "./Reportes/ReportePagos/ReportePagos";
import ReporteCobranzaPorSemana from "./Reportes/ReporteCobranzaPorSemana/ReporteCobranzaPorSemana";
import ReporteCobranzaRealizada from "./Reportes/ReporteCobranzaPorSemana/ReporteCobranzaRealizada";
import ReporteCobranzaProyectada from "./Reportes/ReporteCobranzaPorSemana/ReporteCobranzaProyectada";
import ReporteCobranzaProyectadoVsReal from "./Reportes/ReporteCobranzaPorSemana/ReporteCobranzaProyectadoVsReal";
import ReporteInsumosPendientes from "./Reportes/ReporteInsumosPendientes/ReporteInsumosPendientes";
import ReporteVentasPendientesEntregar from "./Reportes/ReporteInsumosPendientes/ReporteVentasPendientesEntregar";
import ReportePedidosPendientesApartar from "./Reportes/ReporteInsumosPendientes/ReportePedidosPendientesApartar";
import ReporteIngresos from "./Reportes/ReporteIngresos/ReporteIngresos";
import ArchivosXml from "./ArchivosXml/ArchivosXml";
import VerConciliacion from "./Bancos/ConciliacionesCuenta/VerConciliacion/VerConciliacion";
import VerOrdenDeProduccion from "./Produccion/VerOrdenDeProduccion/VerOrdenDeProduccion";
import ReporteLibroDiario from "./Reportes/ReporteLibroDiario/ReporteLibroDiario";
import ReporteLibroMayor from "./Reportes/ReporteLibroMayor/ReporteLibroMayor";
import ReportePresupuestos from "./Reportes/ReportePresupuestos/ReportePresupuestos";
import ReporteReposicionCajaChica from "./Reportes/ReporteReposicionCajaChica/ReporteReposicionCajaChica";
import ControlInventario from "./ControlInventario/ControlInventario";
import ImportarControlInventario from "./ControlInventario/ImportarControlInventario/ImportarControlInventario";
import ReporteCostoProduccion from "./Reportes/ReporteCostoProduccion/ReporteCostoProduccion";
import GenerarEnvio from "./Ventas/GenerarEnvio/GenerarEnvio";
import Empleados from "./Empleados/Empleados";
import AgregarEmpleado from "./Empleados/AgregarEmpleado/AgregarEmpleado";
import EditarEmpleado from "./Empleados/EditarEmpleado/EditarEmpleado";
import AltaEmpleadoPorPasos from "./Empleados/AltaPorPasos/AltaEmpleadoPorPasos";
import ImportarEmpleados from "./Empleados/ImportarEmpleados/ImportarEmpleados";
import ImportarEmpleadosExterno from "./Empleados/ImportarEmpleadosExterno/ImportarEmpleadosExterno";
import EdicionMasivaEmpleados from "./Empleados/EdicionMasivaEmpleados/EdicionMasivaEmpleados";
import EdicionMasivaEmpleadosExterno from "./Empleados/EdicionMasivaEmpleadosExterno/EdicionMasivaEmpleadosExterno";
import VerEnvio from "./Ventas/VerEnvio/VerEnvio";
import VerPagosCajaChica from "./CajaEfectivo/VerPagosCajaChica/VerPagosCajaChica";
import Cotizaciones from "./Cotizaciones/Cotizaciones";
import AgregarCotizacion from "./Cotizaciones/AgregarCotizacion/AgregarCotizacion"; /*
import RegistroDeLotes from "./RegistroDeLotes/RegistroDeLotes"
import CorteDePiñas from "./CorteDePiñas/CorteDePiñas";
import Horneado from "./Horneado/Horneado";
import Fermentacion from "./Fermentacion/Fermentacion";
import PrimeraDestilacion from "./PrimeraDestilacion/PrimeraDestilacion";
import SegundaDestilacion from "./SegundaDestilacion/SegundaDestilacion";
import TerceraDestilacion from "./TerceraDestilacion/TerceraDestilacion";
import TanquesLlenado from "./TanquesLLenado/TanquesLlenado";*/
import Departamentos from "./Departamentos/Departamentos";
import Puestos from "./Puestos/Puestos";
import Turnos from "./Turnos/Turnos";
import TiposAcumulados from "./TiposAcumulados/TiposAcumulados";
import TiposIncidencias from "./TiposIncidencias/TiposIncidencias";
import TipoPeriodo from "./TipoPeriodo/TipoPeriodo";
import Periodos from "./Periodos/Periodos";
import Conceptos from "./Conceptos/Conceptos";
import RegistroPatronal from "./RegistroPatronal/RegistroPatronal";

import VerCotizacion from "./Cotizaciones/VerCotizacion/VerCotizacion";
import Matrices from "./Matrices/Matrices";
import MatrizForm from "./Matrices/MatrizForm/MatrizForm";
import ImportarMatrices from "./Matrices/ImportarMatrices/ImportarMatrices";
import FacturaGlobal from "./Ventas/FacturaGlobal/FacturaGlobal";
import AgregarConsignacion from "./InventarioConsignaciones/AgregarConsignacion/AgregarConsignacion";
import InventarioConsignaciones from "./InventarioConsignaciones/InventarioConsignaciones";
import Consignaciones from "./Consignaciones/Consignaciones";
import VentasConsignacion from "./VentasConsignacion/VentasConsignacion";
import VerVentaConsignacion from "./VentasConsignacion/VerVentaConsignacion/VerVentaConsignacion";
import FacturaGlobalConsignacion from "./VentasConsignacion/FacturaGlobalConsignacion/FacturaGlobalConsignacion";
import EntregarInsumosVentaConsignacion from "./VentasConsignacion/EntregarInsumosVentaConsignacion/EntregarInsumosVentaConsignacion";
import GenerarFacturaConsignacion from "./VentasConsignacion/GenerarFacturaConsignacion/GenerarFacturaConsignacion";
import AgregarVentaConsignacion from "./VentasConsignacion/AgregarVentaConsignacion/AgregarVentaConsignacion";
import BajasConsignaciones from "./BajasConsignaciones/BajasConsignaciones";
import BajaConsignacion from "./BajasConsignaciones/BajaConsignacion/BajaConsignacion";
import PresupuestosPU from "./PresupuestosPU/PresupuestosPU";
import PresupuestoPU from "./PresupuestosPU/PresupuestoPU/PresupuestoPU";
import OrdenesDeProduccionPU from "./PresupuestosPU/OrdenesDeProduccionPU/OrdenesDeProduccionPU";
import ConfiguracionOrdenesDeProduccionPU from "./PresupuestosPU/ConfiguracionOrdenesDeProduccionPU/ConfiguracionOrdenesDeProduccionPU";
import VistaOrdenDeProduccionPU from "./PresupuestosPU/VistaOrdenDeProduccionPU/VistaOrdenDeProduccionPU";
import OrdenDeProduccionPU from "./PresupuestosPU/OrdenDeProduccionPU/OrdenDeProduccionPU";
import Remolques from "./Remolques/Remolques";
import ImportarInsumos from "./Insumos/ImportarInsumos/ImportarInsumos";
import SubirImagenesInsumos from "./Insumos/SubirImagenesInsumos/SubirImagenesInsumos";
import SubirFichasTecnicasInsumos from "./Insumos/SubirFichasTecnicasInsumos/SubirFichasTecnicasInsumos";
import EdicionMasivaInsumos from "./Insumos/EdicionMasivaInsumos/EdicionMasivaInsumos";
import EdicionMasivaEquivalencias from "./Insumos/EdicionMasivaEquivalencias/EdicionMasivaEquivalencias";
import EdicionMasivaInsumosCliente from "./Clientes/EdicionMasivaInsumosCliente/EdicionMasivaInsumosCliente";
import EdicionMasivaClientes from "./Clientes/EdicionMasivaClientes/EdicionMasivaClientes";
import EdicionMasivaProveedores from "./Proveedores/EdicionMasivaProveedores/EdicionMasivaProveedores";
import CapturaInsumosCliente from "./Clientes/CapturaInsumosCliente/CapturaInsumosCliente";
import ImportarNivelesEducativos from "./Escuela/Importar/ImportarNivelesEducativos/ImportarNivelesEducativos";
import ImportarProgramasEducativos from "./Escuela/Importar/ImportarProgramasEducativos/ImportarProgramasEducativos";
import ImportarEscuelas from "./Escuela/Importar/ImportarEscuelas/ImportarEscuelas";
import ImportarListas from "./Escuela/Importar/ImportarListas/ImportarListas";
import ExportarListas from "./Escuela/ExportarListas/ExportarListas";
import ImportarGrupos from "./Escuela/Importar/ImportarGrupos/ImportarGrupos";
import ImportarAlumnos from "./Escuela/Importar/ImportarAlumnos/ImportarAlumnos";
import ImportarVentasLibros from "./Escuela/Importar/ImportarVentasLibros/ImportarVentasLibros";
import ImportarVentasLibrosDigitales from "./Escuela/Importar/ImportarVentasLibrosDigitales/ImportarVentasLibrosDigitales";
import GenerarFichasPago from "./Escuela/Importar/GenerarFichasPago/GenerarFichasPago";
import TiposDeInsumos from "./TiposDeInsumos/TiposDeInsumos";
import ImportarTiposDeInsumo from "./TiposDeInsumos/ImportarTiposDeInsumo/ImportarTiposDeInsumo";
import AgregarNotaDeCreditoVenta from "./NotasDeCreditoVenta/AgregarNotaDeCreditoVenta/AgregarNotaDeCreditoVenta";
import VerNotaDeCreditoVenta from "./NotasDeCreditoVenta/VerNotaDeCreditoVenta/VerNotaDeCreditoVenta";
import AgregarDevolucion from "./Devoluciones/AgregarDevolucion/AgregarDevolucion";
import VerDevolucion from "./Devoluciones/VerDevolucion/VerDevolucion";
import Indirectos from "./Indirectos/Indirectos";
import AgregarIndirecto from "./Indirectos/AgregarIndirecto/AgregarIndirecto";
import EditarIndirecto from "./Indirectos/EditarIndirecto/EditarIndirecto";
import { Drawer, Tabs as Tabs5 } from "antd5";
import EditarCotizacion from "./Cotizaciones/EditarCotizacion/EditarCotizacion";
import PreCotizacionIngenieria from "./PreCotizacionIngenieria/PreCotizacionIngenieria";
import VistaPreCotizacionIngenieria from "./PreCotizacionIngenieria/VistaPreCotizacionIngenieria/VistaPreCotizacionIngenieria";
import OrdenesDeMaquila from "./Produccion/OrdenesDeMaquila/OrdenesDeMaquila";
import VistaOrdenDeMaquila from "./Produccion/OrdenesDeMaquila/VistaOrdenDeMaquila/VistaOrdenDeMaquila";
import Doctores from "./Doctores/Doctores";
import Pacientes from "./Pacientes/Pacientes";
import Emergencias from "./Emergencias/Emergencias";
import LlenarFormulario from "./Emergencias/LlenarFormulario/LlenarFormulario";
import EditarFormulario from "./Emergencias/EditarFormulario/EditarFormulario";
import VerConsignacion from "./InventarioConsignaciones/VerConsignacion/VerConsignacion";
import ButtonItem from "../../Components/ButtonItem";
import ModalItem from "../../Components/ModalItem";
import moment from "moment";
import RequerirInsumosVenta from "./Ventas/RequerirInsumosVenta/RequerirInsumosVenta";
import RemisionesCompra from "./RemisionesCompra/RemisionesCompra";
import VentasProgramadas from "./VentasProgramadas/VentasProgramadas";
import AgregarVentaProgramada from "./VentasProgramadas/AgregarVentaProgramada/AgregarVentaProgramada";
import EditarVentaProgramada from "./VentasProgramadas/EditarVentaProgramada/EditarVentaProgramada";
import PendientesVentasProgramadas from "./VentasProgramadas/PendientesVentasProgramadas/PendientesVentasProgramadas";
import ListasDePrecios from "./ListasDePrecios/ListasDePrecios";
import Marcas from "./Marcas/Marcas";
import ImportarMarcas from "./Marcas/ImportarMarcas/ImportarMarcas";
//import ChatbotWidget from "./ChatBot/ChatBot";
import Etapas from "./Etapas/Etapas";
import Dashboard from "./DashboardTaxidermia/DashboardTaxidermia";
import ModificarPrecios from "./ListasDePrecios/ModificarPrecios/ModificarPrecios";
import ReporteCuentasPorCobrarAgrupado from "./Reportes/ReporteCuentasPorCobrarAgrupado/ReporteCuentasPorCobrarAgrupado";
import ReporteDIOT from "./Reportes/ReporteDIOT/ReporteDIOT";
import ReporteIVA from "./Reportes/ReporteIVA/ReporteIVA";
import ReporteRetencionesCompras from "./Reportes/ReporteRetencionesCompras/ReporteRetencionesCompras";
import ReporteRetencionesVentas from "./Reportes/ReporteRetencionesVentas/ReporteRetencionesVentas";
import ReporteConciliacionFacturasPagos from "./Reportes/ReporteConciliacionFacturasPagos/ReporteConciliacionFacturasPagos";
import ReporteFacturasGlobales from "./Reportes/ReporteFacturasGlobales/ReporteFacturasGlobales";
import ReporteXml from "./Reportes/ReporteXml/ReporteXml";
import Tablas from "./Tablas/Tablas";
import Cirugias from "./Cirugias/Cirugias";
import Lotes from "./Lotes/Lotes";
import LotesProducto from "./Lotes/LotesProducto/LotesProducto";
import ArchivosLotes from "./Lotes/ArchivosLotes/ArchivosLotes";
import Comodato from "./Comodato/Comodato";
import AgregarOrdenComodato from "./Comodato/AgregarOrdenComodato/AgregarOrdenComodato";
import VerOrdenComodato from "./Comodato/VerOrdenComodato/VerOrdenComodato";
import ImportarComodato from "./Comodato/ImportarComodato/ImportarComodato";
import Cajas from "./Cajas/Cajas";
import Sesiones from "./Sesiones/Sesiones";
import AgregarDevolucionCompra from "./DevolucionesCompra/AgregarDevolucionCompra/AgregarDevolucionCompra";
import VerDevolucionCompra from "./DevolucionesCompra/VerDevolucionCompra/VerDevolucionCompra";
import AgregarCotizacionConLotes from "./Cotizaciones/AgregarCotizacionConLotes/AgregarCotizacionConLotes";
import Agrupaciones from "./Agrupaciones/Agrupaciones";
import IconAmbulance from "../../Icons/IconAmbulance";
import IconBrand from "../../Icons/IconBrand";
import VerSesion from "./Sesiones/VerSesion/VerSesion";
import ModalAdvertenciaPago from "./ModalAdvertenciaPago/ModalAdvertenciaPago";
import ModalNotificacionMovimientosInventarioGlobal from "../../Components/ModalNotificacionMovimientosInventarioGlobal";
import ModalNotificacionesOrdenPU from "../../Components/ModalNotificacionesOrdenPU";
import ModalPolizasDocumento from "../../Components/ModalPolizasDocumento";
import axios from "axios";
import Pedidos from "./Pedidos/Pedidos";
import EditarPedido from "./Pedidos/EditarPedido/EditarPedido";
import VerPedido from "./Pedidos/VerPedido/VerPedido";
import AgregarPedido from "./Pedidos/AgregarPedido/AgregarPedido";
import ImportarPedidosIMSS from "./Pedidos/ImportarPedidosIMSS/ImportarPedidosIMSS";
import RequerirInsumosPedido from "./Pedidos/RequerirInsumosPedido/RequerirInsumosPedido";
import ApartarInsumosPedido from "./Pedidos/ApartarInsumosPedido/ApartarInsumosPedido";
import EntregarInsumosPedido from "./Pedidos/EntregarInsumosPedido/EntregarInsumosPedido";
import Embarques from "./Embarques/Embarques";
import AgregarEmbarque from "./Embarques/AgregarEmbarque/AgregarEmbarque";
import EditarEmbarque from "./Embarques/EditarEmbarque/EditarEmbarque";
import VerEmbarque from "./Embarques/VerEmbarque/VerEmbarque";
import ReporteOrdenesDeCompra from "./Reportes/ReporteOrdenesDeCompra/ReporteOrdenesDeCompra";
import ReporteRecepcionesOrdenDeCompra from "./Reportes/ReporteRecepcionesOrdenDeCompra/ReporteRecepcionesOrdenDeCompra";
import ReporteLotes from "./Reportes/ReporteLotes/ReporteLotes";
import ApartarInsumosVenta from "./Ventas/ApartarInsumosVenta/ApartarInsumosVenta";
import ReporteCompras2 from "./Reportes/ReporteCompras2/ReporteCompras2";
import ReporteCostosInternos from "./Reportes/ReporteCostosInternos/ReporteCostosInternos";
import ReporteConciliacionCostosInternos from "./Reportes/ReporteConciliacionCostosInternos/ReporteConciliacionCostosInternos";
import ReporteComodatos from "./Reportes/ReporteComodatos/ReporteComodatos";
import ReporteNotasDeCreditoCompra from "./Reportes/ReporteNotasDeCreditoCompra/ReporteNotasDeCreditoCompra";
import CanalesVenta from "./CanalesVenta/CanalesVenta";
import ReportePedidos from "./Reportes/ReportePedidos/ReportePedidos";
import ReporteCotizaciones from "./Reportes/ReporteCotizaciones/ReporteCotizaciones";
import Facturas from "./Facturas/Facturas";
import ReporteVentasFiscales from "./Reportes/ReporteVentasFiscales/ReporteVentasFiscales";
import FacturarVariasRemisiones from "./Ventas/FacturarVariasRemisiones/FacturarVariasRemisiones";
import FacturasGlobales from "./FacturasGlobales/FacturasGlobales";
import NotasDeCreditoVenta from "./NotasDeCreditoVenta/NotasDeCreditoVenta";
import Devoluciones from "./Devoluciones/Devoluciones";
import RMAs from "./RMA/RMAs";
import VistaRMA from "./RMA/VistaRMA/VistaRMA";
import ConfiguracionRMA from "./RMA/ConfiguracionRMA/ConfiguracionRMA";
import RMAsCompra from "./RMACompra/RMAsCompra";
import VistaRMACompra from "./RMACompra/VistaRMACompra/VistaRMACompra";
import ConfiguracionRMACompra from "./RMACompra/ConfiguracionRMACompra/ConfiguracionRMACompra";
import PagosVentas from "./PagosVentas/PagosVentas";
import PagosCompras from "./PagosCompras/PagosCompras";
import ReporteEstadoCuentaCliente from "./Reportes/ReporteEstadoCuentaCliente/ReporteEstadoCuentaCliente";
import ReporteFacturacion from "./Reportes/ReporteFacturacion/ReporteFacturacion";
import ReporteIntegracionClientes from "./Reportes/ReporteFacturacion/ReporteIntegracionClientes";
import ReporteConsecutivoFacturacion from "./Reportes/ReporteFacturacion/ReporteConsecutivoFacturacion";
import ReporteAlumnosYVentas from "./Reportes/ReporteAlumnosYVentas/ReporteAlumnosYVentas";
import ReporteReferenciasPago from "./Reportes/ReporteReferenciasPago/ReporteReferenciasPago";
import Activos from "./Activos/Activos";
import ReporteActividadEtapas from "./Reportes/ReporteActividadEtapas/ReporteActividadEtapas";
import SubProyectos from "./SubProyectos/SubProyectos";
import ReporteResumenEntradasSalidas from "./Reportes/ReporteResumenEntradasSalidas/ReporteResumenEntradasSalidas";
import ReporteEntradasSalidas from "./Reportes/ReporteEntradasSalidas/ReporteEntradasSalidas";
import ReporteEntradasSalidasDetallado from "./Reportes/ReporteEntradasSalidasDetallado/ReporteEntradasSalidasDetallado";
import ReporteInsumosNoInventariables from "./Reportes/ReporteInsumosNoInventariables/ReporteInsumosNoInventariables";
import AbonosClientes from "./AbonosClientes/AbonosClientes";
import AgregarAbonoCliente from "./AbonosClientes/AgregarAbonoCliente/AgregarAbonoCliente";
import AbonosProveedores from "./AbonosProveedores/AbonosProveedores";
import AgregarAbonoProveedor from "./AbonosProveedores/AgregarAbonoProveedor/AgregarAbonoProveedor";
import WorkBenchRequisiciones from "./WorkBenchRequisiciones/WorkBenchRequisiciones";
import VerRequisicion from "./Requisiciones/VerRequisicion/VerRequisicion";
import MandarWorkBench from "./Requisiciones/MandarWorkBench/MandarWorkBench";
import CotizacionesRequisicion from "./Requisiciones/CotizacionesRequisicion/CotizacionesRequisicion";
import ReporteRequisiciones from "./Reportes/ReporteRequisiciones/ReporteRequisiciones";
import ReporteEmpleados from "./Reportes/ReporteEmpleados/ReporteEmpleados";
import ReporteRegistroEmpleados from "./Reportes/ReporteRegistroEmpleados/ReporteRegistroEmpleados";
import InsumoProveedor from "./InsumoProveedor/InsumoProveedor";
import FijarPorcentajes from "./ListasDePrecios/FijarPorcentajes/FijarPorcentajes";
import AnalizarDiferenciasPrecios from "./ListasDePrecios/AnalizarDiferenciasPrecios/AnalizarDiferenciasPrecios";
import ReglasListasDePrecios from "./ListasDePrecios/ReglasListasDePrecios/ReglasListasDePrecios";
import CotizadorPorInsumo from "./CotizadorPorInsumo/CotizadorPorInsumo";
import "../../Components/Styles.css"
import Soporte from "./Soporte/Soporte";
import TicketsSoporte from "./Soporte/Tickets/Tickets";
import ReporteSoporteEmpresa from "./Soporte/Tickets/ReporteSoporteEmpresa";
import ProgramarRecordatorios from "./ProgramarRecordatorios/ProgramarRecordatorios";
import EditarAbonoCliente from "./AbonosClientes/EditarAbonoCliente/EditarAbonoCliente";
import EditarAbonoProveedor from "./AbonosProveedores/EditarAbonoProveedor/EditarAbonoProveedor";
import Bitacora from "./Bitacora/Bitacora";
import Autorizaciones from "./Autorizaciones/Autorizaciones";
import ReporteBalanzaDeComprobacionContabilidadElectronica from "./Reportes/ReporteBalanzaDeComprobacionContabilidadElectronica/ReporteBalanzaDeComprobacionContabilidadElectronica";
import ReporteTraspasoEntreAlmacenes from "./Reportes/ReporteTraspasoEntreAlmacenes/ReporteTraspasoEntreAlmacenes";
import PlantillasPolizas from "./PlantillasPolizas/PlantillasPolizas";
import AgregarPlantillaPoliza from "./PlantillasPolizas/AgregarPlantillaPoliza/AgregarPlantillaPoliza";
import EditarPlantillaPoliza from "./PlantillasPolizas/EditarPlantillaPoliza/EditarPlantillaPoliza";
import ReporteCostoTotalProyecto from "./Reportes/ReporteCostoTotalProyecto/ReporteCostoTotalProyecto";
import ReportePagosAProveedores from "./Reportes/ReportePagosAProvedoores/ReportePagosAProveedores";
import RegularizarInventarioVentas from "./Ventas/RegularizarInventarioVentas/RegularizarInventarioVentas";
import HistorialCorreos from "./HistorialCorreos/HistorialCorreos"
import ReporteCuentasPorPagarAgrupado from "./Reportes/ReporteCuentasPorPagarAgrupado/ReporteCuentasPorPagarAgrupado";
import ConteosCiclicos from "./ConteosCiclicos/ConteosCiclicos";
import AgregarConteoCiclico from "./ConteosCiclicos/AgregarConteoCiclico/AgregarConteoCiclico";
import EditarConteoCiclico from "./ConteosCiclicos/EditarConteoCiclico/EditarConteoCiclico";
import Conteos from "./Conteos/Conteos";
import DetalleConteo from "./Conteos/DetalleConteo/DetalleConteo";
import VerConteo from "./Conteos/VerConteo/VerConteo";
import VerConfigConteo from "./Conteos/VerConfigConteo/VerConfigConteo";
import ReporteTaxidermia from "./Reportes/ReporteTaxidermia/ReporteTaxidermia";
import NotasDeCreditoCompra from "./NotasDeCredito/NotasDeCreditoCompra";
import DevolucionesCompra from "./DevolucionesCompra/DevolucionesCompra";
import AgregarNotaDeCreditoVentaGeneral from "./NotasDeCreditoVenta/AgregarNotaDeCreditoVentaGeneral/AgregarNotaDeCreditoVentaGeneral";
import AgregarConteo from "./Conteos/AgregarConteo/AgregarConteo";
import OrdenesDeConteo from "./OrdenesDeConteo/OrdenesDeConteo";
import ConfiguracionEcommerce from "./ConfiguracionEcommerce/ConfiguracionEcommerce"
import ConfiguracionClaude from "./ConfiguracionClaude/ConfiguracionClaude"
import Whatsapp from "./Whatsapp/Whatsapp";
import BurbujaWhatsappGlobal from "./Whatsapp/Components/Burbuja/BurbujaWhatsappGlobal";
import BurbujaSoporteGlobal from "./Soporte/Chat/BurbujaSoporteGlobal";
import ModalSubidosSoporte from "./Soporte/Chat/ModalSubidosSoporte";
import { consultarAccesoSoporte } from "./Soporte/Chat/accesoSoporte";
import { abrirWsSoporte } from "./Soporte/Chat/conexionWsSoporte";
import { responderSubido } from "./Soporte/Chat/respuestaSubido";
import ContarOrdenDeConteo from "./OrdenesDeConteo/ContarOrdenDeConteo/ContarOrdenDeConteo";
import VerOrdenDeConteo from "./OrdenesDeConteo/VerOrdenDeConteo/VerOrdenDeConteo";
import IconWWW from "../../Icons/IconWWW";
import PortalClientes from "./PortalClientes/PortalClientes";
import Unidades from "./Unidades/Unidades";
import ImportarUnidades from "./Unidades/ImportarUnidades/ImportarUnidades";
import IconWeight from "../../Icons/IconWeight";
import IconCartGarage from "../../Icons/IconCartGarage";
import IconCartCrane from "../../Icons/IconCartCrane";
import Vehiculos from "./Vehiculos/Vehiculos";
import ConsumoCombustible from "./Vehiculos/ConsumoCombustible/ConsumoCombustible";
import PolizasSeguro from "./PolizasSeguro/PolizasSeguro";
import RelojesChecadores from "./RelojesChecadores/RelojesChecadores";
import AsignacionRelojes from "./AsignacionRelojes/AsignacionRelojes";
import ImportarAsignacionRelojes from "./AsignacionRelojes/ImportarAsignacionRelojes/ImportarAsignacionRelojes";
import Asistencia from "./Asistencia/Asistencia";
import PerimetrosChecada from "./PerimetrosChecada/PerimetrosChecada";
import IntentosChecadaRechazados from "./IntentosChecadaRechazados/IntentosChecadaRechazados";
import ConfiguracionAsistencia from "./ConfiguracionAsistencia/ConfiguracionAsistencia";
import Descansos from "./Descansos/Descansos";
import Horarios from "./Horarios/Horarios";
import AsignacionTurnos from "./AsignacionTurnos/AsignacionTurnos";
import ImportarAsignacionTurnos from "./AsignacionTurnos/ImportarAsignacionTurnos/ImportarAsignacionTurnos";
import CalendarioEmpleado from "./CalendarioEmpleado/CalendarioEmpleado";
import EmpleadosEnSitio from "./EmpleadosEnSitio/EmpleadosEnSitio";
import PrimeroUltimo from "./PrimeroUltimo/PrimeroUltimo";
import TotalAsistencia from "./TotalAsistencia/TotalAsistencia";
import VentasEcommerce from "./VentasEcommerce/VentasEcommerce";
import AsistenciaDiaria from "./AsistenciaDiaria/AsistenciaDiaria";
import TipoPrestaciones from "./TipoPrestaciones/TipoPrestaciones";
import ReporteInsumosMasVendidos from "./Reportes/ReporteInsumosMasVendidos/ReporteInsumosMasVendidos";
import ReporteMargenVentas from "./Reportes/ReporteMargenVentas/ReporteMargenVentas";
import ReporteVentasPorLote from "./Reportes/ReporteVentasPorLote/ReporteVentasPorLote";
import ReporteCotizacionVsVentas from "./Reportes/ReporteConversionVentas/ReporteCotizacionVsVentas";
import ReportePedidoVsVentas from "./Reportes/ReporteConversionVentas/ReportePedidoVsVentas";
import ReporteInsumosMasComprados from "./Reportes/ReporteInsumosMasComprados/ReporteInsumosMasComprados";
import PreNomina from "./PreNomina/PreNomina";
import Recibos from "./Recibos/Recibos";
import ConfiguracionNomina from "./ConfiguracionNomina/ConfiguracionNomina";
import Vacaciones from "./Vacaciones/Vacaciones";
import CreditosMovimientos from "./CreditosMovimientos/CreditosMovimientos";
import ReportesNomina from "./ReportesNomina/ReportesNomina";
import ReporteRepse from "./ReportesNomina/ReporteRepse";
import ReporteXmlEmitidos from "./ReportesNomina/ReporteXmlEmitidos";
import ReporteListaRaya from "./ReportesNomina/ReporteListaRaya";
import ReporteComparativoPeriodos from "./ReportesNomina/ReporteComparativoPeriodos";
import ReporteAcumulados from "./ReportesNomina/ReporteAcumulados";
import ReporteLayoutEmpleados from "./ReportesNomina/ReporteLayoutEmpleados";
import ReportePersonal from "./ReportesNomina/ReportePersonal";
import ReportePercepcionesPorPeriodo from "./ReportesNomina/ReportePercepcionesPorPeriodo";
import ReporteIncidencias from "./ReportesNomina/ReporteIncidencias";
import GenerarAguinaldo from "./PreNomina/GenerarAguinaldo/GenerarAguinaldo";
import Finiquito from "./Empleados/Finiquito/Finiquito";
import AumentoSueldo from "./Empleados/AumentoSueldo/AumentoSueldo";
import Calidad from "./Calidad/Calidad";
import VistaPrograma from "./Calidad/VistaPrograma/VistaPrograma";
import VistaProceso from "./Calidad/VistaProceso/VistaProceso";
import ReporteCalidad from "./Calidad/ReporteCalidad/ReporteCalidad";
import CRMDashboard from "./CRM/CRM";
import ContactosCRM from "./CRM/ContactosCRM/ContactosCRM";
import ConfiguracionCRM from "./CRM/ConfiguracionCRM/ConfiguracionCRM";
import VistaEmbudo from "./CRM/ConfiguracionCRM/VistaEmbudo";
import CalendarioRecordatorios from "./CRM/CalendarioRecordatorios/CalendarioRecordatorios";
import ReportesCRM from "./CRM/ReportesCRM/ReportesCRM";
import ReporteEmbudo from "./CRM/ReportesCRM/ReporteEmbudo";
import ReporteOportunidadesGanadas from "./CRM/ReportesCRM/ReporteOportunidadesGanadas";
import ReportePipelineCRM from "./CRM/ReportesCRM/ReportePipelineCRM";
import ReporteLeadsCRM from "./CRM/ReportesCRM/ReporteLeadsCRM";
import ReporteEquipoCRM from "./CRM/ReportesCRM/ReporteEquipoCRM";
import EvaluacionProveedores from "./EvaluacionProveedores/EvaluacionProveedores";
import ConfiguracionEvaluacionProveedores from "./EvaluacionProveedores/ConfiguracionEvaluacionProveedores/ConfiguracionEvaluacionProveedores";
import VistaPlantillaEvaluacion from "./EvaluacionProveedores/ConfiguracionEvaluacionProveedores/VistaPlantillaEvaluacion";
import ReporteEvaluacionProveedores from "./EvaluacionProveedores/ReporteEvaluacionProveedores/ReporteEvaluacionProveedores";
// import PreNomina from "./PreNomina/PreNomina";
// import AgregarPreNomina from "./PreNomina/AgregarPreNomina/AgregarPreNomina";
// import RegistroDeLotes from "./RegistroDeLotes/RegistroDeLotes"
// import CorteDePiñas from "./CorteDePiñas/CorteDePiñas";
// import Horneado from "./Horneado/Horneado";
// import Fermentacion from "./Fermentacion/Fermentacion";
// import PrimeraDestilacion from "./PrimeraDestilacion/PrimeraDestilacion";
// import SegundaDestilacion from "./SegundaDestilacion/SegundaDestilacion";
// import TerceraDestilacion from "./TerceraDestilacion/TerceraDestilacion";
// import TanquesLlenado from "./TanquesLLenado/TanquesLlenado";

const { Header, Content, Sider } = Layout;
const { SubMenu } = Menu;

class Panel extends Component {
  state = {
    collapsed: false,
    openKeys: [],
    esAutorizadorRapidas: false,
    isMobile: window.innerWidth <= 1000,
    openNotificaciones: false,
    whatsappBurbujaAbierta: false,
    soporteBurbujaAbierta: false,
    soporteNoLeidos: 0,
    notifications: [],
    unreadCount: 0,
    notificacionesOrdenPU: [],
    modalNotificacionesOrdenPUVisible: false,
    movimientos: [],
    unreadMovimientosCount: 0,
    tabActiva: 'notificaciones',
    button: true,
    loading: true,
    loadingTodas: false,
    socket: null,
    pendientes: 0,
    colapsado: false,
    chatVisible: false,
    modalAdvertenciaPago: false,
    diasAdvertencia: null,
    modalLogout: false,
    permisoSoporte: false,
    puedeRevisarSoporte: false,
    soporteSubidos: [],
    soporteRespondiendoId: null,
    // Pólizas que acaba de emitir un movimiento, para abrirlas solas cuando la empresa lo
    // tiene configurado (lo dispara NotificacionPolizas vía window.abrirPolizasMovimiento).
    polizasMovimientoIds: null,
  };

  componentDidMount() {
    if (this.props.empresa === null) {
      this.props.history.replace("/panelPrincipal");
    } else {
      this.abrirModalAdvertenciaPago();
      this.abrirWebSocket();
      if (this.props.whatsapp && this.props.permisoAccesoWhatsapp) {
        this.abrirWebSocketWhatsapp();
      }
      consultarAccesoSoporte({
        tipo: this.props.tipoUsuario,
        usuarioId: this.props.usuarioId,
        headersToken: this.props.headersToken,
        forzar: true,
      }).then(({ puede, puedeRevisar }) => {
        if (this._desmontado) return;
      this.setState({ permisoSoporte: puede || puedeRevisar, puedeRevisarSoporte: puedeRevisar });
        if (!puede && !puedeRevisar) return;
        this.cerrarWsSoporte = abrirWsSoporte({ empresaId: this.props.empresaId, usuarioId: this.props.usuarioId });
        if (puede) this.consultarSubidosSoporte();
      });
      this.consultarVentasProgramadasPendientes();
      this.consultarEstatusAutorizador();
      if (this.props.mostrarSugerenciasRequisicion) {
        this.consultarSugerenciasPendientes();
      }
      if (this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores) {
        this.consultarEvaluacionesProveedorPendientes();
      }

      window.registrarMovimiento = this.agregarMovimiento;

      // NotificacionPolizas es una función plana (no un componente), así que no puede montar el
      // modal por sí misma: lo abre por aquí, igual que registrarMovimiento.
      window.abrirPolizasMovimiento = (polizasId) =>
        this.setState({ polizasMovimientoIds: polizasId });
    }
    window.addEventListener('resize', this.handleResize);
  }

  consultarSubidosSoporte = async () => {
    try {
      const res = await axios.post("soporte/subidosPendientes", {}, { headers: this.props.headersToken });
      if (res.data?.success === 2 && res.data.tickets?.length) {
        this.setState({ soporteSubidos: res.data.tickets });
      }
    } catch (error) {
    }
  };

  cerrarModalSubidosSoporte = async () => {
    const ticketIds = this.state.soporteSubidos.map((t) => t._id);
    this.setState({ soporteSubidos: [] });
    try {
      await axios.post("soporte/marcarSubidosVistos", { ticketIds }, { headers: this.props.headersToken });
    } catch (error) {
    }
  };

  // Sí/no del cliente desde el modal de avisos: ¿se cumplió bien el reporte? El
  // ticket respondido sale de la lista y, al vaciarse, el modal se cierra solo.
  responderSubidoSoporte = async (ticket, respuesta) => {
    this.setState({ soporteRespondiendoId: ticket._id });
    const { ok, message } = await responderSubido(ticket._id, respuesta, this.props.headersToken);
    this.setState({ soporteRespondiendoId: null });

    if (!ok) {
      notification.error({ message: message || "No se pudo registrar tu respuesta." });
      return;
    }

    const restantes = this.state.soporteSubidos.filter((t) => t._id !== ticket._id);
    this.setState({ soporteSubidos: restantes });
    if (restantes.length === 0) {
      notification.success({ message: "Gracias, registramos tu respuesta." });
    }
  };

  consultarEstatusAutorizador = async () => {
    try {
      const res = await axios.post(
        "/autorizaciones/estatusPin",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data?.success === 2) {
        this.setState({ esAutorizadorRapidas: !!res.data.esAutorizador });
      }
    } catch (error) {
    }
  };

  cargarMovimientosGuardados = () => {
    try {
      const key = `movimientos_empresa_${this.props.empresaId}`;
      const movimientosGuardados = localStorage.getItem(key);

      if (movimientosGuardados) {
        const movimientos = JSON.parse(movimientosGuardados);
        const unreadCount = movimientos.filter(m => !m.read).length;

        this.setState({
          movimientos,
          unreadMovimientosCount: unreadCount,
        });
      }
    } catch (error) {
      console.error('Error al cargar movimientos:', error);
    }
  };

  abrirModalAdvertenciaPago() {
    try {
      const key = `empresa_${this.props.empresaId}_visitada`;
      const visitada = sessionStorage.getItem(key);

      // Si ya la visitaste en esta sesión, no muestres modal
      if (visitada) return;
      axios
        .post(
          "empresas/advertenciaPago",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          // Aquí deberías regresar success: 1 y advertencia: true cuando aplica
          if (res.data.success === 2 && res.data.advertencia === true) {
            this.setState({ diasAdvertencia: res.data.diasFaltantes });
            this.setState({ modalAdvertenciaPago: true });
            sessionStorage.setItem(key, "true");
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  cerrarModalAdvertenciaPago = () => {
    this.setState({ modalAdvertenciaPago: false });
  };

  consultarVentasProgramadasPendientes() {
    this.props
      .contarVentasPPendientes({ empresaId: this.props.empresaId })
      .then((response) => {
        if (response.success === 2) {
        } else {
          message.warning(response.err);
        }
      });
  }

  consultarSugerenciasPendientes() {
    this.props
      .contarSugerenciasPendientes({ empresaId: this.props.empresaId })
      .then((response) => {
        if (response.success === 2) {
        } else {
          message.warning(response.err);
        }
      });
  }

  consultarEvaluacionesProveedorPendientes() {
    this.props
      .contarEvaluacionesProveedorPendientes({ empresaId: this.props.empresaId })
      .then((response) => {
        if (response.success === 2) {
        } else {
          message.warning(response.err);
        }
      });
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 1000 });
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  abrirModalLogout = () => {
    this.setState({ modalLogout: true });
  };

  cerrarModalLogout = () => {
    this.setState({ modalLogout: false });
  };

  mostrarBotonSoporte = () =>
    this.state.permisoSoporte && !this.props.history.location.pathname.endsWith("/ticketsSoporte");

  alternarBurbujaSoporte = () =>
    this.setState((prev) => ({ soporteBurbujaAbierta: !prev.soporteBurbujaAbierta }));

  actualizarNoLeidosSoporte = (soporteNoLeidos) => this.setState({ soporteNoLeidos });

  logout = () => {
    this.props.logout().then((response) => {
      if (response.success === 1) {
        this.setState({ modalLogout: false });
        this.props.history.push("/login");

        notification.info({
          message: 'Se ha cerrado la sesión',
          duration: 0.7,
        });

      } else {
        message.warning(response.err, 2);
      }
    });
  };

  // toggleChat = () => {
  //   this.setState((prevState) => ({ chatVisible: !prevState.chatVisible }));
  // };

  deseleccionarEmpresa() {
    this.props.deseleccionarEmpresa().then(() => {
      this.props.history.push("/panelPrincipal");
    });
  }

  onOpenChange(keys) {
    const latestOpenKey = keys.find(
      (key) => this.state.openKeys.indexOf(key) === -1
    );
    this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
  }

  toggleDrawer = () => {
    this.setState((prevState) => ({ drawerVisible: !prevState.drawerVisible }));
  };

  noLeidasaLeidas(id) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(
        JSON.stringify({ type: "noLeidaALeida", notificacionId: id })
      );
    }
  }

  async consultaTodasNotificaciones() {
    this.setState({ loadingTodas: true });
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify({ type: "mostrarTodas" }));
    }
  }

  todasNoLeidasaLeidas() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify({ type: "todasNoLeidasALeidas" }));
    }
  }

  getIconByNumber = (iconNumber) => {
    switch (iconNumber) {
      case 1:
        return <SettingOutlined />;
      case 2:
        return <DownloadOutlined />;
      case 3:
        return <CloudServerOutlined />;
      case 4:
        return <CloseCircleOutlined />;
      case 5:
        return <WarningOutlined />;
      case 6:
        return <InfoCircleOutlined />;
      case 7:
        return <ReadOutlined />;
      case 8:
        return <ShopOutlined />;
      case 9:
        return <TagsOutlined />;
      case 35:
        return <UserOutlined />;
      default:
        return <BellOutlined />;
    }
  };

  formatNotificacionOrdenPU = (notification) => ({
    id: notification._id,
    title: notification.titulo || "Sin título",
    message: notification.descripcion || "No hay detalles disponibles",
    fecha: moment(notification.fechaDespliegue ? notification.fechaDespliegue : notification.createdAt).fromNow(),
    icon: this.getIconByNumber(notification.icono),
    ruta: notification.ruta || null,
    estadoRuta: notification.estadoRuta || null,
  });

  marcarLeidaNotifOrdenPU = (id) => {
    this.noLeidasaLeidas(id);
    this.setState((prev) => {
      const notifications = [...prev.notifications];
      const index = notifications.findIndex((n) => n.id === id);
      const yaEstabaLeida = index === -1 ? true : notifications[index].read;
      if (index !== -1) notifications[index] = { ...notifications[index], read: true };

      return {
        notificacionesOrdenPU: prev.notificacionesOrdenPU.filter((n) => n.id !== id),
        notifications,
        unreadCount: yaEstabaLeida ? prev.unreadCount : Math.max(0, prev.unreadCount - 1),
      };
    });
  };

  cerrarModalNotificacionesOrdenPU = () => {
    this.setState({ modalNotificacionesOrdenPUVisible: false });
  };

  verNotifOrdenPU = (id, ruta, estadoRuta) => {
    this.marcarLeidaNotifOrdenPU(id);
    if (ruta) {
      this.props.history.push(ruta, estadoRuta ? estadoRuta : null);
      this.setState({ modalNotificacionesOrdenPUVisible: false });
    }
  };

  formatNotifications = (notifications) => {
    return notifications.map((notification, index) => ({
      id: notification._id,
      title: notification.titulo || "Sin título",
      message: notification.descripcion || "No hay detalles disponibles",
      icon: this.getIconByNumber(notification.icono),
      fecha: moment(
        notification.fechaDespliegue
          ? notification.fechaDespliegue
          : notification.createdAt
      ).fromNow(),
      read: notification.leido || false,
      ruta: notification.ruta || null,
      estadoRuta: notification.estadoRuta || null,
    }));
  };

  onMarkAsRead = (id, ruta, estadoRuta) => {
    let notifications = [...this.state.notifications];
    let unreadCount = this.state.unreadCount;
    let index = notifications.findIndex(
      (notification) => notification.id === id
    );

    if (index !== -1 && !notifications[index].read) {
      notifications[index].read = true;
      unreadCount--;
    }

    this.setState(() => ({
      notifications: notifications,
      unreadCount: unreadCount,
    }));
    if (ruta) {
      this.props.history.push(ruta, estadoRuta ? estadoRuta : null);
      this.abrirNotificaciones(false);
    }
  };

  onMarkAllAsRead = () => {
    this.setState((prevState) => ({
      notifications: prevState.notifications.map((notification) => ({
        ...notification,
        read: true,
      })),
      unreadCount: 0,
    }));
    this.todasNoLeidasaLeidas();
  };

  abrirNotificaciones = (value) => {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.setState({ openNotificaciones: value });
    } else if (!value) {
      this.setState({ openNotificaciones: value });
    }
  };

  // Métodos para gestionar movimientos registrados
  agregarMovimiento = (movimiento) => {
    const nuevoMovimiento = {
      id: Date.now() + Math.random(),
      titulo: movimiento.titulo || 'Movimiento registrado',
      mensaje: movimiento.mensaje || movimiento.descripcion || '',
      icono: movimiento.icono || 8,
      fecha: moment().fromNow(),
      read: false,
      onClick: movimiento.onClick || null,
    };

    this.setState((prevState) => {
      const nuevosMovimientos = [nuevoMovimiento, ...prevState.movimientos];

      // Guardar en localStorage (sin las funciones onClick)
      try {
        const key = `movimientos_empresa_${this.props.empresaId}`;
        const movimientosParaGuardar = nuevosMovimientos.map(({ onClick, ...rest }) => rest);
        localStorage.setItem(key, JSON.stringify(movimientosParaGuardar));
      } catch (error) {
        console.error('Error al guardar movimientos:', error);
      }

      return {
        movimientos: nuevosMovimientos,
        unreadMovimientosCount: prevState.unreadMovimientosCount + 1,
      };
    });

    // Programar eliminación automática después de 5 minutos (300000 ms)
    setTimeout(() => {
      this.eliminarMovimiento(nuevoMovimiento.id);
    }, 180000);

    return nuevoMovimiento;
  };

  marcarMovimientoComoLeido = (id) => {
    this.setState((prevState) => {
      const movimientos = prevState.movimientos.map((mov) =>
        mov.id === id && !mov.read ? { ...mov, read: true } : mov
      );
      const unreadMovimientosCount = movimientos.filter((m) => !m.read).length;

      // Guardar en localStorage (sin las funciones onClick)
      try {
        const key = `movimientos_empresa_${this.props.empresaId}`;
        const movimientosParaGuardar = movimientos.map(({ onClick, ...rest }) => rest);
        localStorage.setItem(key, JSON.stringify(movimientosParaGuardar));
      } catch (error) {
        console.error('Error al guardar movimientos:', error);
      }

      return { movimientos, unreadMovimientosCount };
    });
  };

  marcarTodosMovimientosComoLeidos = () => {
    this.setState((prevState) => {
      const movimientos = prevState.movimientos.map((mov) => ({ ...mov, read: true }));

      // Guardar en localStorage (sin las funciones onClick)
      try {
        const key = `movimientos_empresa_${this.props.empresaId}`;
        const movimientosParaGuardar = movimientos.map(({ onClick, ...rest }) => rest);
        localStorage.setItem(key, JSON.stringify(movimientosParaGuardar));
      } catch (error) {
        console.error('Error al guardar movimientos:', error);
      }

      return {
        movimientos,
        unreadMovimientosCount: 0,
      };
    });
  };

  eliminarMovimiento = (id) => {
    this.setState((prevState) => {

      // Filtrar el movimiento a eliminar
      const movimientos = prevState.movimientos.filter((mov) => mov.id !== id);
      const unreadMovimientosCount = movimientos.filter((m) => !m.read).length;

      // Actualizar caché 
      try {
        const key = `movimientos_empresa_${this.props.empresaId}`;
        const movimientosParaGuardar = movimientos.map(({ onClick, ...rest }) => rest);
        localStorage.setItem(key, JSON.stringify(movimientosParaGuardar));
      } catch (error) {
        console.error('Error al eliminar movimiento del cache:', error);
      }

      return { movimientos, unreadMovimientosCount };
    });
  };

  cambiarTab = (tab) => {
    this.setState({ tabActiva: tab });
  };

  abrirWebSocket() {
    const WS_URL =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_WS_URL_DEV
        : process.env.REACT_APP_WS_URL_PROD;

    // evita duplicados
    if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
      return;
    }

    let reconnectDelay = 1000; // 1s
    const maxDelay = 15000;    // 15s
    let shouldReconnect = true;

    const connect = () => {
      this.socket = new WebSocket(WS_URL);
      window.appSocket = this.socket;

      this.socket.onopen = () => {
        reconnectDelay = 1000; // reset backoff
        this.setState({ wsDisconnected: false });
        this.socket.send(JSON.stringify({
          type: "datos",
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          tipoUsuario: this.props.tipoUsuario,
        }));
        this.socket.send(JSON.stringify({ type: "noLeidasPorModulo", modulo: "ordenProduccionPU" }));
      };

      this.socket.onmessage = (event) => {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          console.error("WS mensaje inválido:", event.data);
          return;
        }

        // Eventos de módulos internos — despachar a quien los escuche y salir
        if (data.type === "calculo_nomina") {
          window.dispatchEvent(new CustomEvent("calculo_nomina", { detail: data }));
          return;
        }
        if (data.type === "cierre_nomina") {
          window.dispatchEvent(new CustomEvent("cierre_nomina", { detail: data }));
          return;
        }
        // Operaciones masivas de catálogo (edición masiva de insumos,
        // actualización de precios, importaciones). Lo escucha la pantalla que
        // las lanzó, vía Components/seguirProcesoMasivo.
        if (data.type === "proceso_masivo") {
          window.dispatchEvent(new CustomEvent("proceso_masivo", { detail: data }));
          return;
        }
        // Autorizaciones rápidas: respuesta en vivo al solicitante y refresco
        // de pendientes para los autorizadores (ModalAutorizacion / Autorizaciones)
        if (data.type === "autorizacion_update" || data.type === "autorizacion_refresh") {
          window.dispatchEvent(new CustomEvent(data.type, { detail: data }));
          return;
        }
        if (data.type === "solicitud_material_produccion") {
          window.dispatchEvent(new CustomEvent(data.type, { detail: data }));
          return;
        }
        if (data.type === "material_orden_actualizado") {
          window.dispatchEvent(new CustomEvent(data.type, { detail: data }));
          return;
        }

        if (data.type === "noLeidasPorModulo" && data.modulo === "ordenProduccionPU") {
          if (data.success === 2) {
            const notificacionesOrdenPU = (data.notificaciones || []).map((n) => this.formatNotificacionOrdenPU(n));
            this.setState({
              notificacionesOrdenPU,
              modalNotificacionesOrdenPUVisible: notificacionesOrdenPU.length > 0,
            });
          }
          return;
        }

        if (data.success === 2) {
          if (data.type === "new_notification") {
            if (data.notification.modulo === "ordenProduccionPU") {
              this.setState((prev) => ({
                notificacionesOrdenPU: [this.formatNotificacionOrdenPU(data.notification), ...prev.notificacionesOrdenPU],
                modalNotificacionesOrdenPUVisible: true,
              }));
            }
            this.setState((prev) => ({
              notifications: [{
                id: data.notification._id,
                title: data.notification.titulo || "Sin título",
                message: data.notification.descripcion || "No hay detalles disponibles",
                fecha: moment(data.notification.fechaDespliegue ? data.notification.fechaDespliegue : data.notification.createdAt).fromNow(),
                icon: this.getIconByNumber(data.notification.icono),
                read: data.notification.leido || false,
                ruta: data.notification.ruta || null,
                estadoRuta: data.notification.estadoRuta || null,
              }, ...prev.notifications],
              unreadCount: prev.unreadCount + 1,
            }));
          } else {
            this.setState({
              notifications: this.formatNotifications(data.notificaciones),
              unreadCount: data.unreadCount,
              loadingTodas: false,
              loading: false,
              button: !data.mostrarTodas,
            });
          }
        } else {
          this.setState({ notifications: [], unreadCount: 0, loadingTodas: false, loading: false });
        }
      };

      this.socket.onerror = (err) => {
        console.error("WS error:", err);
        // muchos browsers disparan onclose después; no cierres aquí forzoso
      };

      this.socket.onclose = (evt) => {
        console.warn("WS closed:", evt.code, evt.reason);

        // NO borres notificaciones aquí
        // this.setState({ notifications: [], unreadCount: 0 });

        this.setState({ wsDisconnected: true });

        if (shouldReconnect) {
          setTimeout(connect, reconnectDelay);
          reconnectDelay = Math.min(maxDelay, reconnectDelay * 1.6);
        }
      };
    };

    this._wsShouldReconnect = () => { shouldReconnect = false; };
    connect();
  }

  abrirWebSocketWhatsapp() {
    const WS_URL =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_WS_WHATSAPP_URL_DEV
        : process.env.REACT_APP_WS_WHATSAPP_URL_PROD;

    if (!WS_URL) return;

    // evita duplicados
    if (this.socketWhatsapp && (this.socketWhatsapp.readyState === WebSocket.OPEN || this.socketWhatsapp.readyState === WebSocket.CONNECTING)) {
      return;
    }

    let reconnectDelay = 1000; // 1s
    const maxDelay = 15000;    // 15s
    let shouldReconnect = true;

    const connect = () => {
      this.socketWhatsapp = new WebSocket(WS_URL);

      this.socketWhatsapp.onopen = () => {
        reconnectDelay = 1000; // reset backoff
        this.socketWhatsapp.send(JSON.stringify({
          type: "datos",
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          tipoUsuario: this.props.tipoUsuario,
        }));
      };

      this.socketWhatsapp.onmessage = (event) => {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          console.error("WS WhatsApp mensaje inválido:", event.data);
          return;
        }

        if (data.success === 2 && data.type === "whatsapp_event") {
          window.dispatchEvent(new CustomEvent("whatsapp_event", { detail: data }));
        }
      };

      this.socketWhatsapp.onerror = (err) => {
        console.error("WS WhatsApp error:", err);
      };

      this.socketWhatsapp.onclose = (evt) => {
        if (shouldReconnect) {
          setTimeout(connect, reconnectDelay);
          reconnectDelay = Math.min(maxDelay, reconnectDelay * 1.6);
        }
      };
    };

    this._wsWhatsappShouldReconnect = () => { shouldReconnect = false; };
    connect();
  }

  componentWillUnmount() {
    if (this._wsShouldReconnect) this._wsShouldReconnect();
    if (this.socket) this.socket.close();
    if (window.appSocket) window.appSocket = null;
    if (this._wsWhatsappShouldReconnect) this._wsWhatsappShouldReconnect();
    if (this.socketWhatsapp) this.socketWhatsapp.close();
    this._desmontado = true;
    if (this.cerrarWsSoporte) this.cerrarWsSoporte();
    window.removeEventListener('resize', this.handleResize);
    // El modal se va con el Panel: dejar el hook apuntando a un componente desmontado haría
    // que NotificacionPolizas llamara a setState sobre él.
    window.abrirPolizasMovimiento = null;
  }

  render() {
    const current = this.props.history.location.pathname;

    const menuItems = (
      <>
        {this.props.permisoAccesoInicio && (
          <Menu.Item
            key={this.props.match.url + "/inicio"}
            icon={<HomeOutlined />}
          >
            <NavLink to={this.props.match.url + "/inicio"}>Inicio</NavLink>
          </Menu.Item>
        )}
        {(this.props.permisoAccesoBancos ||
          this.props.permisoAccesoCajaChica) && (
          <SubMenu
            key={
              this.props.match.url + "/bancos" ||
              this.props.match.url + "/cajaefectivo" ||
              this.props.match.url + "/creditos"
            }
            title="Tesorería"
            icon={<BankFilled />}
          >
            {this.props.permisoAccesoBancos && (
              <Menu.Item
                key={this.props.match.url + "/bancos"}
                icon={<DollarCircleFilled />}
              >
                <NavLink to={this.props.match.url + "/bancos"}>Bancos</NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoCajaChica && (
              <Menu.Item
                key={this.props.match.url + "/cajaefectivo"}
                icon={<WalletOutlined />}
              >
                <NavLink to={this.props.match.url + "/cajaefectivo"}>
                  Caja y Efectivo
                </NavLink>
              </Menu.Item>
            )}
            {this.props.creditos && this.props.permisoAccesoBancos && (
              <Menu.Item
                key={this.props.match.url + "/creditos"}
                icon={<DollarOutlined />}
              >
                <NavLink to={this.props.match.url + "/creditos"}>
                  Créditos
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        )}
        {this.props.permisoAccesoCuentasPorPagar && (
          <SubMenu
            key={
              this.props.match.url + "/cuentasporpagar" ||
              this.props.match.url + "/abonosProveedores" ||
              this.props.match.url + "/pagosCompras"
            }
            title="Pagos"
            icon={<IconCreditCard />}
          >
            <Menu.Item
              key={this.props.match.url + "/cuentasporpagar"}
              icon={<ReconciliationOutlined />}
            >
              <NavLink to={this.props.match.url + "/cuentasporpagar"}>
                Cuentas por Pagar
              </NavLink>
            </Menu.Item>
            {this.props.permisoAccesoProveedores && (
              <Menu.Item
                key={this.props.match.url + "/abonosProveedores"}
                icon={<IconInvoice />}
              >
                <NavLink to={this.props.match.url + "/abonosProveedores"}>
                  Abonos Proveedor
                </NavLink>
              </Menu.Item>
            )}
            <Menu.Item
              key={this.props.match.url + "/pagosCompras"}
              icon={<DollarOutlined />}
            >
              <NavLink to={this.props.match.url + "/PagosCompras"}>Pagos</NavLink>
            </Menu.Item>
          </SubMenu>
        )}
        {this.props.permisoAccesoCuentasPorCobrar && (
          <SubMenu
            key={
              this.props.match.url + "/cuentasporcobrar" ||
              this.props.match.url + "/abonosClientes" ||
              this.props.match.url + "/cobros" ||
              this.props.match.url + "/programarRecordatorios"
            }
            title="Cobranza"
            icon={<IconFileInvoice />}
          >
            <Menu.Item
              key={this.props.match.url + "/cuentasporcobrar"}
              icon={<ReadOutlined />}
            >
              <NavLink to={this.props.match.url + "/cuentasporcobrar"}>
                Cuentas por Cobrar
              </NavLink>
            </Menu.Item>
            {this.props.permisoAccesoClientes && (
              <Menu.Item
                key={this.props.match.url + "/abonosClientes"}
                icon={<IconReceiptDollar />}
              >
                <NavLink to={this.props.match.url + "/abonosClientes"}>
                  Abonos Cliente
                </NavLink>
              </Menu.Item>
            )}
            <Menu.Item
              key={this.props.match.url + "/cobros"}
              icon={<DollarOutlined />}
            >
              <NavLink to={this.props.match.url + "/cobros"}>Cobros</NavLink>
            </Menu.Item>
            {this.props.programarRecordatorioCxC && (
              <Menu.Item
                key={this.props.match.url + "/programarRecordatorios"}
                icon={<IconAlarm />}
              >
                <NavLink to={this.props.match.url + "/programarRecordatorios"}>
                  Programar recordatorios
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        )}
        {this.props.certificadaDM && this.props.permisoAccesoArchivosXML ? (
          <Menu.Item
            key={this.props.match.url + "/archivosXml"}
            icon={<CloudServerOutlined />}
          >
            <NavLink to={this.props.match.url + "/archivosXml"}>
              Archivos XML
            </NavLink>
          </Menu.Item>
        ) : null}
        {this.props.permisoAccesoOrdenesDeCompra ||
          this.props.permisoAccesoFacturasSinOrdenDeCompra ||
          this.props.permisoAccesoRemisiones ||
          this.props.permisoAccesoLeerXml ||
          this.props.permisoVerRequisiciones ||
          this.props.permisoAccesoFacturasCajaChica ||
          this.props.permisoAccesoComodato ? (
          <SubMenu
            key={
              this.props.match.url + "/facturassinordendecompra" ||
              this.props.match.url + "/facturascajachica" ||
              this.props.match.url + "/leerXml" ||
              this.props.match.url + "/ordenesdecompra"
            }
            title={
              <Badge
                style={{ boxShadow: "none" }}
                dot={this.props.cuentaSugerenciasPendientes > 0}
                offset={[20, 0]}
              >
                <span style={{ color: this.state.isMobile ? "black" : "rgba(255, 255, 255, 0.65)" }}>
                  Compras
                </span>
              </Badge>
            }
            icon={<ShoppingCartOutlined />}
          >
            {this.props.permisoVerRequisiciones && (
              <Menu.Item
                key={this.props.match.url + "/requisiciones"}
                icon={<BarsOutlined />}
              >
                <NavLink to={this.props.match.url + "/requisiciones"}>
                  Requisiciones
                </NavLink>
              </Menu.Item>
            )}
            {this.props.workbenchRequisiciones && (
              <Menu.Item
                key={this.props.match.url + "/workBenchRequisiciones"}
                icon={<IconListTree />}
              >
                <NavLink to={this.props.match.url + "/workBenchRequisiciones"}>
                  WorkBench Requisiciones
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoVerRequisiciones && this.props.mostrarSugerenciasRequisicion && (
              <Menu.Item
                key={this.props.match.url + "/sugerenciasRequisicion"}
                icon={<AlertOutlined />}
              >
                <NavLink to={this.props.match.url + "/sugerenciasRequisicion"}>
                  <Badge
                    count={this.props.cuentaSugerenciasPendientes}
                    offset={[0, -5]}
                    size="small"
                    style={{ boxShadow: "none" }}
                  >
                    <span style={{ color: this.state.isMobile ? "black" : "rgba(255, 255, 255, 0.65)" }}>
                      Sugerencias de Requisición
                    </span>
                  </Badge>
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoOrdenesDeCompra && (
              <Menu.Item
                key={this.props.match.url + "/ordenesdecompra"}
                icon={<ProfileOutlined />}
              >
                <NavLink to={this.props.match.url + "/ordenesdecompra"}>
                  Ordenes de Compra
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
              <Menu.Item
                key={this.props.match.url + "/facturassinordendecompra"}
                icon={<ContainerOutlined />}
              >
                <NavLink
                  to={this.props.match.url + "/facturassinordendecompra"}
                >
                  Facturas sin Orden de Compra
                </NavLink>
              </Menu.Item>
            )}
            {false && this.props.permisoAccesoRemisiones && (
              <Menu.Item
                key={this.props.match.url + "/remisiones"}
                icon={<ContainerOutlined />}
              >
                <NavLink to={this.props.match.url + "/remisiones"}>
                  Remisiones
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoFacturasCajaChica && (
              <Menu.Item
                key={this.props.match.url + "/facturascajachica"}
                icon={<FileDoneOutlined />}
              >
                <NavLink to={this.props.match.url + "/facturascajachica"}>
                  Facturas Caja Chica
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
              <Menu.Item
                key={this.props.match.url + "/facturas"}
                icon={<ContainerOutlined />}
              >
                <NavLink to={this.props.match.url + "/facturas"}>
                  Facturas
                </NavLink>
              </Menu.Item>
            )}
            {/* {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
              <Menu.Item
                key={this.props.match.url + "/remisionesCompra"}
                icon={<IconClipBoard />}
              >
                <NavLink
                  to={
                    this.props.match.url + "/remisionesCompra"
                  }
                >
                  Remisiones
                </NavLink>
              </Menu.Item>
            )} */}
            {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
              <Menu.Item
                key={this.props.match.url + "/notasDeCreditoCompra"}
                icon={<SnippetsFilled />}
              >
                <NavLink to={this.props.match.url + "/notasDeCreditoCompra"}>
                  Notas de Crédito Compra
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
              <Menu.Item
                key={this.props.match.url + "/devolucionesCompra"}
                icon={<SnippetsFilled />}
              >
                <NavLink to={this.props.match.url + "/devolucionesCompra"}>
                  Devoluciones Compra
                </NavLink>
              </Menu.Item>
            )}
            {this.props.moduloRMACompras && (
              <Menu.Item
                key={this.props.match.url + "/rmaCompras"}
                icon={<SnippetsOutlined />}
              >
                <NavLink to={this.props.match.url + "/rmaCompras"}>
                  RMA Compras
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoComodato && (
              <Menu.Item
                key={this.props.match.url + "/comodato"}
                icon={<IconAutofitLeft />}
              >
                <NavLink to={this.props.match.url + "/comodato"}>
                  Comodato
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoLeerXml && (
              <Menu.Item
                key={this.props.match.url + "/leerXml"}
                icon={<FileTextOutlined />}
              >
                <NavLink to={this.props.match.url + "/leerXml"}>
                  Leer Xml
                </NavLink>
              </Menu.Item>
            )}
            {this.props.prorrateoDesCostos && (
              <Menu.Item
                key={this.props.match.url + "/prorrateos"}
                icon={<IconArrowsSplit />}
              >
                <NavLink to={this.props.match.url + "/prorrateos"}>
                  Prorrateos
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {this.props.equipoMedico && (
          <SubMenu
            key={
              this.props.match.url + "/pacientes" ||
              this.props.match.url + "/doctores" ||
              this.props.match.url + "/cirugias" ||
              this.props.match.url + "/emergencias"
            }
            title="Medico"
            icon={<IconClipBoardHeart />}
          >
            <Menu.Item
              key={this.props.match.url + "/pacientes"}
              icon={<IconFriends />}
            >
              <NavLink to={this.props.match.url + "/pacientes"}>
                Pacientes
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/doctores"}
              icon={<IconStethoscope />}
            >
              <NavLink to={this.props.match.url + "/doctores"}>
                Doctores
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/cirugias"}
              icon={<IconBed />}
            >
              <NavLink to={this.props.match.url + "/cirugias"}>
                Cirugias
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/emergencias"}
              icon={<IconAmbulance />}
            >
              <NavLink to={this.props.match.url + "/emergencias"}>
                Emergencias
              </NavLink>
            </Menu.Item>
          </SubMenu>
        )}
        {this.props.permisoAccesoVentas && (
          <SubMenu
            key={
              this.props.match.url + "/ventas" ||
              this.props.match.url + "/cotizaciones"
            }
            title={
              <Badge
                style={{ boxShadow: "none" }}
                dot={this.props.cuentaVentasPendientes > 0}
                offset={[20, 0]}
              >
                <span style={{ color: this.state.isMobile ? "black" : "rgba(255, 255, 255, 0.65)" }}>
                  Ventas
                </span>
              </Badge>
            }
            icon={<TagsFilled />}
          >
            <Menu.Item
              key={this.props.match.url + "/ventas"}
              icon={<TagsOutlined />}
            >
              <NavLink to={this.props.match.url + "/ventas"}>Ventas</NavLink>
            </Menu.Item>
            {this.props.embarques && this.props.permisoAccesoEmbarques && (
              <Menu.Item
                key={this.props.match.url + "/embarques"}
                icon={<IconTruckDelivery />}
              >
                <NavLink to={this.props.match.url + "/embarques"}>
                  Embarques
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoPedidos && (
              <Menu.Item
                key={this.props.match.url + "/pedidos"}
                icon={<IconReceiptDollars />}
              >
                <NavLink to={this.props.match.url + "/pedidos"}>
                  Pedidos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoCotizaciones && (
              <Menu.Item
                key={this.props.match.url + "/cotizaciones"}
                icon={<TagsFilled />}
              >
                <NavLink to={this.props.match.url + "/cotizaciones"}>
                  Cotizaciones
                </NavLink>
              </Menu.Item>)}
            {this.props.permisoAccesoCotizaciones && this.props.cotizadorPorInsumo &&
              <Menu.Item
                key={this.props.match.url + "/cotizadorPorInsumo"}
                icon={<IconCalculator />}
              >
                <NavLink
                  to={this.props.match.url + "/cotizadorPorInsumo"}
                >
                  Cotizador por Insumo
                </NavLink>
              </Menu.Item>}
            {this.props.preCotizacionIngenieria && (
              <Menu.Item
                key={this.props.match.url + "/preCotizacionIngenieria"}
                icon={<FileTextOutlined />}
              >
                <NavLink to={this.props.match.url + "/preCotizacionIngenieria"}>
                  Pre Cotización
                </NavLink>
              </Menu.Item>
            )}
            <Menu.Item
              key={this.props.match.url + "/ventasEcommerce"}
              icon={<FundProjectionScreenOutlined />}
              disabled={!this.props.permisoAccesoEcommerce}
            >
              <NavLink to={this.props.match.url + "/ventasEcommerce"}>
                Ventas eCommerce
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/ventasProgramadas"}
              icon={<IconTagStarred />}
            >
              <NavLink to={this.props.match.url + "/ventasProgramadas"}>
                <Badge
                  count={this.props.cuentaVentasPendientes}
                  offset={[0, -5]}
                  size="small"
                  style={{ boxShadow: "none" }}
                >
                  <span style={{ color: this.state.isMobile ? "black" : "rgba(255, 255, 255, 0.65)" }}>
                    Ventas Programadas
                  </span>
                </Badge>
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/canalesVenta"}
              icon={<IconAfiliate />}
            >
              <NavLink to={this.props.match.url + "/canalesVenta"}>
                Canales
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/facturasGlobales"}
              icon={<ContainerOutlined />}
            >
              <NavLink to={this.props.match.url + "/facturasGlobales"}>
                Facturas Globales
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/notasDeCreditoVentas"}
              icon={<SnippetsOutlined />}
            >
              <NavLink to={this.props.match.url + "/notasDeCreditoVentas"}>
                Notas de Crédito Venta
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/devolucionesVentas"}
              icon={<SnippetsOutlined />}
            >
              <NavLink to={this.props.match.url + "/devolucionesVentas"}>
                Devoluciones Venta
              </NavLink>
            </Menu.Item>
            {this.props.moduloRMA && (
              <Menu.Item
                key={this.props.match.url + "/rma"}
                icon={<SnippetsOutlined />}
              >
                <NavLink to={this.props.match.url + "/rma"}>
                  RMA
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        )}
        {this.props.puntoDeVenta && (
          <SubMenu
            key={
              this.props.match.url + "/cajas" ||
              this.props.match.url + "/sesiones"
            }
            title="Punto de Venta"
            icon={<IconShoppingBag />}
          >
            <Menu.Item
              key={this.props.match.url + "/cajas"}
              icon={<IconShoppingCart />}
            >
              <NavLink to={this.props.match.url + "/cajas"}>Cajas</NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/sesiones"}
              icon={<IconCoins />}
            >
              <NavLink to={this.props.match.url + "/sesiones"}>
                Sesiones
              </NavLink>
            </Menu.Item>
          </SubMenu>
        )}
        {this.props.permisoAccesoInsumos ||
          this.props.permisoAccesoServicios ||
          this.props.permisoAccesoInsumosCompuetos ||
          this.props.permisoAccesoFamilias ? (
          <SubMenu
            key={
              this.props.match.url + "/insumos" ||
              this.props.match.url + "/tipodeinsumos"
            }
            title="Insumos"
            icon={<ShopOutlined />}
          >
            {this.props.permisoAccesoInsumos && (
              <Menu.Item
                key={this.props.match.url + "/insumos"}
                icon={<ShopOutlined />}
              >
                <NavLink to={this.props.match.url + "/insumos"}>
                  Insumos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoServicios ? (
              <Menu.Item
                key={this.props.match.url + "/servicios"}
                icon={<ToolOutlined />}
              >
                <NavLink to={this.props.match.url + "/servicios"}>
                  Servicios
                </NavLink>
              </Menu.Item>
            ) : null}
            {this.props.permisoAccesoInsumosCompuetos ? (
              <Menu.Item
                key={this.props.match.url + "/insumosCompuestos"}
                icon={<GroupOutlined />}
              >
                <NavLink to={this.props.match.url + "/insumosCompuestos"}>
                  Insumos Compuestos
                </NavLink>
              </Menu.Item>
            ) : null}
            {this.props.permisoAccesoInsumos && this.props.taxidermia && (
              <Menu.Item
                key={this.props.match.url + "/activos"}
                icon={
                  this.props.taxidermia ? (
                    <IconLayersIntersect />
                  ) : (
                    <IconBriefCase />
                  )
                }
              >
                <NavLink to={this.props.match.url + "/activos"}>
                  {this.props.taxidermia ? "Formas" : "Activos"}
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoFamilias && (
              <Menu.Item
                key={this.props.match.url + "/familias"}
                icon={<ShopFilled />}
              >
                <NavLink to={this.props.match.url + "/familias"}>
                  Familias
                </NavLink>
              </Menu.Item>
            )}
            <Menu.Item
              key={this.props.match.url + "/tiposDeInsumos"}
              icon={<IconBuildingWarehouse />}
            >
              <NavLink to={this.props.match.url + "/tiposDeInsumos"}>
                Tipos De Insumos
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/marcas"}
              icon={<IconBrand />}
            >
              <NavLink to={this.props.match.url + "/marcas"}>Marcas</NavLink>
            </Menu.Item>
            {this.props.permisoAccesoUnidades &&
              <Menu.Item
                key={this.props.match.url + "/unidades"}
                icon={<IconWeight />}
              >
                <NavLink to={this.props.match.url + "/unidades"}>Unidades</NavLink>
              </Menu.Item>
            }
            {this.props.permisoAccesoInsumos && (
              <Menu.Item
                key={this.props.match.url + "/listasDePrecios"}
                icon={<IconListDetails />}
              >
                <NavLink to={this.props.match.url + "/listasDePrecios"}>
                  Listas de Precios
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {this.props.moduloActivosFijos && this.props.permisoAlgunoActivosFijos && (
          <SubMenu
            key={this.props.match.url + "/tiposDeActivo"}
            title="Activos Fijos"
            icon={<IconBuildingWarehouse />}
          >
            <Menu.Item
              key={this.props.match.url + "/tiposDeActivo"}
              icon={<IconTiposDeActivo />}
            >
              <NavLink to={this.props.match.url + "/tiposDeActivo"}>
                Tipos de Activo
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/activosFijos"}
              icon={<IconActivos />}
            >
              <NavLink to={this.props.match.url + "/activosFijos"}>
                Activos
              </NavLink>
            </Menu.Item>
            {this.props.permisoAccesoInventarioActivos && (
              <Menu.Item
                key={this.props.match.url + "/inventarioActivos"}
                icon={<IconInventarioActivos />}
              >
                <NavLink to={this.props.match.url + "/inventarioActivos"}>
                  Inventario de Activos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoMovimientosActivos && (
              <Menu.Item
                key={this.props.match.url + "/movimientosActivos"}
                icon={<IconInventarioActivos />}
              >
                <NavLink to={this.props.match.url + "/movimientosActivos"}>
                  Movimientos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoDepreciaciones && (
              <Menu.Item
                key={this.props.match.url + "/correrDepreciacion"}
                icon={<IconDepreciaciones />}
              >
                <NavLink to={this.props.match.url + "/correrDepreciacion"}>
                  Depreciaciones
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        )}
        {/* Modulo CMMS. Por ahora sólo lo controla la bandera de la empresa; los
            permisos por acción se conectan cuando existan sus registros de Permiso. */}
        {this.props.moduloCMMS && (
          <SubMenu
            key={this.props.match.url + "/cmmsActivos"}
            title="CMMS"
            icon={<IconCMMS />}
          >
            <Menu.Item key={this.props.match.url + "/cmmsInicio"} icon={<IconInicioCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsInicio"}>Inicio</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsAgenda"} icon={<IconAgendaCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsAgenda"}>Agenda</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsViajes"} icon={<IconViajesCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsViajes"}>Viajes</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsServicios"} icon={<IconServiciosCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsServicios"}>Servicios</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsTickets"} icon={<IconTicketsCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsTickets"}>Tickets</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsContratos"} icon={<IconContratosCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsContratos"}>Contratos</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsActivos"} icon={<IconActivosCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsActivos"}>Activos</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsTiposActivo"} icon={<IconTiposActivoCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsTiposActivo"}>Tipos de Activo</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsRutinas"} icon={<IconRutinasCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsRutinas"}>Rutinas</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsCertificados"} icon={<IconCertificadosCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsCertificados"}>Certificados</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsReportes"} icon={<IconReportesCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsReportes"}>Reportes</NavLink>
            </Menu.Item>
            <Menu.Item key={this.props.match.url + "/cmmsConfiguracion"} icon={<IconConfiguracionCMMS />}>
              <NavLink to={this.props.match.url + "/cmmsConfiguracion"}>Configuración</NavLink>
            </Menu.Item>
          </SubMenu>
        )}
        {this.props.permisoAccesoInventario ||
          this.props.permisoAccesoAgregarInventario ||
          this.props.permisoAccesoTraspasoAlmacenes ||
          this.props.permisoAccesoProductosAlCosto ||
          this.props.permisoAccesoAlmacen ? (
          <SubMenu
            key={
              this.props.match.url + "/inventario" ||
              this.props.match.url + "/agregarInventario" ||
              this.props.match.url + "/productosAlCosto" ||
              this.props.match.url + "/traspasoEntreAlmacenes"
            }
            title="Inventario"
            icon={<DropboxSquareFilled />}
          >
            {this.props.permisoAccesoInventario && (
              <Menu.Item
                key={this.props.match.url + "/inventario"}
                icon={<DropboxOutlined />}
              >
                <NavLink exact to={this.props.match.url + "/inventario"}>
                  Inventario
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoAlmacen && (
              <Menu.Item
                key={this.props.match.url + "/almacen"}
                icon={<SendOutlined />}
              >
                <NavLink to={this.props.match.url + "/almacen"}>
                  Almacén: Material de Producción
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoInventario &&
              this.props.lotesCaducidades && (
                <Menu.Item
                  key={this.props.match.url + "/lotes"}
                  icon={this.props.taxidermia ? <IconPaw /> : <IconArchive />}
                >
                  <NavLink to={this.props.match.url + "/lotes"}>
                    {this.props.taxidermia ? "Animales" : "Lotes"}
                  </NavLink>
                </Menu.Item>
              )}
            {this.props.permisoAccesoInventario &&
              this.props.lotesCaducidades &&
              this.props.taxidermia && (
                <Menu.Item
                  key={this.props.match.url + "/agrupaciones"}
                  icon={
                    this.props.taxidermia ? <IconFeather /> : <IconArchive />
                  }
                >
                  <NavLink to={this.props.match.url + "/agrupaciones"}>
                    Agrupaciones
                  </NavLink>
                </Menu.Item>
              )}
            {this.props.permisoAccesoTraspasoAlmacenes ? (
              <Menu.Item
                key={this.props.match.url + "/traspasoEntreAlmacenes"}
                icon={<SwapOutlined />}
              >
                <NavLink to={this.props.match.url + "/traspasoEntreAlmacenes"}>
                  Traspaso Almacenes
                </NavLink>
              </Menu.Item>
            ) : null}

            {/*Activar en siguiente actualizacion*/}

            {this.props.permisoAccesoInventario && (
              <Menu.Item
                key={this.props.match.url + "/controlInventario"}
                icon={<ControlOutlined />}
              >
                <NavLink to={this.props.match.url + "/controlInventario"}>
                  Control Inventario
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoMovimientosInventario && (
              <Menu.Item
                key={this.props.match.url + "/movimientosInventario"}
                icon={<HistoryOutlined />}
              >
                <NavLink to={this.props.match.url + "/movimientosInventario"}>
                  Movimientos Inventario
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoAgregarInventario && (
              <Menu.Item
                key={this.props.match.url + "/agregarInventario"}
                icon={<DiffOutlined />}
              >
                <NavLink to={this.props.match.url + "/agregarInventario"}>
                  Agregar Inventario
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoProductosAlCosto && (
              <Menu.Item
                key={this.props.match.url + "/productosAlCosto"}
                icon={<DiffFilled />}
              >
                <NavLink to={this.props.match.url + "/productosAlCosto"}>
                  Productos Al Costo
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {this.props.permisoAccesoInventario && this.props.conteos ? (
          <SubMenu
            key={
              this.props.match.url + "/conteosCiclicos"
            }
            title="Conteos"
            icon={<IconChecklist />}
          >
            {this.props.permisoAccesoInventario && (
              <Menu.Item
                key={this.props.match.url + "/conteosCiclicos"}
                icon={<IconCalendarRepeat />}
              >
                <NavLink to={this.props.match.url + "/conteosCiclicos"}>
                  Conteos cíclicos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoInventario && (
              <Menu.Item
                key={this.props.match.url + "/conteos"}
                icon={<IconChecklist />}
              >
                <NavLink to={this.props.match.url + "/conteos"}>
                  Conteos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoInventario && (
              <Menu.Item
                key={this.props.match.url + "/ordenesDeConteo"}
                icon={<IconAbacus />}
              >
                <NavLink to={this.props.match.url + "/ordenesDeConteo"}>
                  Ordenes de Conteo
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {(this.props.permisoAccesoInventario ||
          this.props.permisoAccesoAgregarInventario ||
          this.props.permisoAccesoTraspasoAlmacenes ||
          this.props.permisoAccesoProductosAlCosto) &&
          this.props.modulosConsignaciones ? (
          <SubMenu
            key={this.props.match.url + "/consignaciones"}
            title="Consignaciones"
            icon={<SnippetsOutlined />}
          >
            <Menu.Item
              key={this.props.match.url + "/consignaciones"}
              icon={<SnippetsOutlined />}
            >
              <NavLink to={this.props.match.url + "/consignaciones"}>
                Consignaciones
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/inventarioConsignaciones"}
              icon={<SnippetsFilled />}
            >
              <NavLink to={this.props.match.url + "/inventarioConsignaciones"}>
                Inventario Consignaciones
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/ventasConsignacion"}
              icon={<TagsOutlined />}
            >
              <NavLink to={this.props.match.url + "/ventasConsignacion"}>
                Ventas
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/bajasConsignaciones"}
              icon={<DiffFilled />}
            >
              <NavLink to={this.props.match.url + "/bajasConsignaciones"}>
                Bajas Consignaciones
              </NavLink>
            </Menu.Item>
          </SubMenu>
        ) : null}
        {this.props.permisoAccesoProduccion ||
          this.props.permisoAccesoListaDeMateriales ||
          this.props.preCotizacionIngenieria ||
          (this.props.moduloProduccion && (this.props.permisoAccesoPreciosUnitarios || this.props.permisoAccesoOrdenesProduccionPU)) ? (
          <SubMenu
            key={
              this.props.match.url + "/produccion" ||
              this.props.match.url + "/listaDeMateriales"
            }
            title="Produccion"
            icon={<ToolFilled />}
          >
            {this.props.permisoAccesoProduccion && (
              <Menu.Item
                key={this.props.match.url + "/produccion"}
                icon={<ToolOutlined />}
              >
                <NavLink to={this.props.match.url + "/produccion"}>
                  Produccion
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoListaDeMateriales && (
              <Menu.Item
                key={this.props.match.url + "/listaDeMateriales"}
                icon={<OrderedListOutlined />}
              >
                <NavLink to={this.props.match.url + "/listaDeMateriales"}>
                  Lista de Materiales
                </NavLink>
              </Menu.Item>
            )}
            {this.props.preCotizacionIngenieria && (
              <Menu.Item
                key={this.props.match.url + "/ordenesDeMaquila"}
                icon={<NodeIndexOutlined />}
              >
                <NavLink to={this.props.match.url + "/ordenesDeMaquila"}>
                  Ordenes de Maquila
                </NavLink>
              </Menu.Item>
            )}
            {this.props.moduloProduccion && (this.props.permisoAccesoPreciosUnitarios || this.props.permisoAccesoOrdenesProduccionPU) && (
              <Menu.Item
                key={this.props.match.url + "/ordenesDeProduccion"}
                icon={<FileDoneOutlined />}
              >
                <NavLink to={this.props.match.url + "/ordenesDeProduccion"}>
                  Órdenes de Producción
                </NavLink>
              </Menu.Item>
            )}
            {this.props.moduloProduccion && this.props.permisoAccesoPreciosUnitarios && (
              <Menu.Item
                key={this.props.match.url + "/configuracionOrdenesDeProduccionPU"}
                icon={<SettingOutlined />}
              >
                <NavLink to={this.props.match.url + "/configuracionOrdenesDeProduccionPU"}>
                  Campos y plantilla de Órdenes de Producción
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {this.props.permisoAccesoProduccion && this.props.taxidermia ? (
          <SubMenu
            key={
              this.props.match.url + "/etapas" ||
              this.props.match.url + "/dashboard"
            }
            title={this.props.taxidermia ? "Taxidermia" : "Procesos"}
            icon={this.props.taxidermia ? <IconDeer /> : <IconAdjustmentsCog />}
          >
            <Menu.Item
              key={this.props.match.url + "/dashboard"}
              icon={<IconLayoutDashboard />}
            >
              <NavLink to={this.props.match.url + "/dashboard"}>
                Dashboard
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/etapas"}
              icon={<IconTimeline />}
            >
              <NavLink to={this.props.match.url + "/etapas"}>Etapas</NavLink>
            </Menu.Item>
          </SubMenu>
        ) : null}
        {this.props.moduloBOM && this.props.permisoAccesoPreciosUnitarios && <SubMenu
          key={
            this.props.match.url + "/matrices" ||
            this.props.match.url + "/presupuestosPU"
          }
          title="BOM"
          icon={<CalculatorOutlined />}
        >
          {this.props.permisoAccesoPreciosUnitarios && (
            <Menu.Item
              key={this.props.match.url + "/presupuestosPU"}
              icon={<CalculatorFilled />}
            >
              <NavLink to={this.props.match.url + "/presupuestosPU"}>
                Presupuestos
              </NavLink>
            </Menu.Item>
          )}
          {this.props.permisoAccesoPreciosUnitarios && this.props.permisoAccesoInsumosCompuetos ? (
            <Menu.Item
              key={this.props.match.url + "/matrices"}
              icon={<CalculatorOutlined />}
            >
              <NavLink to={this.props.match.url + "/matrices"}>
                Matrices
              </NavLink>
            </Menu.Item>
          ) : null}
          {this.props.permisoAccesoPreciosUnitarios && (
            <Menu.Item
              key={this.props.match.url + "/intangibles"}
              icon={<IconAirTable />}
            >
              <NavLink to={this.props.match.url + "/intangibles"}>
                Intangibles
              </NavLink>
            </Menu.Item>
          )}
          {(this.props.permisoAccesoPreciosUnitarios || this.props.permisoAccesoOrdenesProduccionPU) && (
            <Menu.Item
              key={this.props.match.url + "/ordenesDeProduccion"}
              icon={<FileDoneOutlined />}
            >
              <NavLink to={this.props.match.url + "/ordenesDeProduccion"}>
                Órdenes de Producción
              </NavLink>
            </Menu.Item>
          )}
          {this.props.permisoAccesoPreciosUnitarios && (
          <Menu.Item
            key={this.props.match.url + "/configuracionOrdenesDeProduccionPU"}
            icon={<SettingOutlined />}
          >
            <NavLink to={this.props.match.url + "/configuracionOrdenesDeProduccionPU"}>
              Campos y flujos de Órdenes de Producción
            </NavLink>
          </Menu.Item>
          )}
        </SubMenu>}
        {this.props.permisoAccesoClientes ||
          this.props.permisoAccesoTipoDeClientes ? (
          <SubMenu
            key={
              this.props.match.url + "/tipodeclientes" ||
              this.props.match.url + "/clientes" ||
              this.props.match.url + "/portalClientes"
            }
            title="Clientes"
            icon={<ContactsOutlined />}
          >
            {this.props.permisoAccesoClientes && (
              <Menu.Item
                key={this.props.match.url + "/clientes"}
                icon={<ContactsOutlined />}
              >
                <NavLink to={this.props.match.url + "/clientes"}>
                  Clientes
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoTipoDeClientes && (
              <Menu.Item
                key={this.props.match.url + "/tipodeclientes"}
                icon={<ReconciliationFilled />}
              >
                <NavLink to={this.props.match.url + "/tipodeclientes"}>
                  Tipo de Clientes
                </NavLink>
              </Menu.Item>
            )}
            {this.props.portalClientes && (
            <Menu.Item
              key={this.props.match.url + "/portalClientes"}
              icon={<IconWWW />}
            >
              <NavLink to={this.props.match.url + "/portalClientes"}>
                Portal Clientes
              </NavLink>
            </Menu.Item>
            )}
            {this.props.escuela && this.props.permisoAccesoEscuela && (
              <Menu.Item
                key={this.props.match.url + "/escuela"}
                icon={<ContactsOutlined />}
              >
                <NavLink to={this.props.match.url + "/escuela"}>
                  Escuela
                </NavLink>
              </Menu.Item>
            )}

          </SubMenu>
        ) : null}
        {(this.props.crm && this.props.permisoAccesoCRM) && (
          <SubMenu
            key={
              this.props.match.url + "/crmDashboard" ||
              this.props.match.url + "/crmCalendario"
            }
            title="CRM"
            icon={<UsergroupAddOutlined />}
          >
            <Menu.Item
              key={this.props.match.url + "/crmDashboard"}
              icon={<TableOutlined />}
            >
              <NavLink to={this.props.match.url + "/crmDashboard"}>
                Mi tablero
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/crmCalendario"}
              icon={<ScheduleOutlined />}
            >
              <NavLink to={this.props.match.url + "/crmCalendario"}>
                Mi Calendario
              </NavLink>
            </Menu.Item>
            {(this.props.permisoMasterCRM ||
              this.props.permisoReporteEmbudoCRM ||
              this.props.permisoReporteGanadasCRM ||
              this.props.permisoReportePipelineCRM ||
              this.props.permisoReporteLeadsCRM ||
              this.props.permisoReporteEquipoCRM) && (
              <Menu.Item
                key={this.props.match.url + "/crmReportes"}
                icon={<LineChartOutlined />}
              >
                <NavLink to={this.props.match.url + "/crmReportes"}>
                  Reportes
                </NavLink>
              </Menu.Item>
            )}

          </SubMenu>
        )}
        {this.props.permisoAccesoProveedores ||
          this.props.permisoAccesoTipoDeProveedores ||
          (this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores) ? (
          <SubMenu
            key={
              this.props.match.url + "/tipodeproveedores" ||
              this.props.match.url + "/proveedores"
            }
            title={
              <Badge
                style={{ boxShadow: "none" }}
                dot={this.props.cuentaEvaluacionesProveedorPendientes > 0}
                offset={[20, 0]}
              >
                <span style={{ color: this.state.isMobile ? "black" : "rgba(255, 255, 255, 0.65)" }}>
                  Proveedores
                </span>
              </Badge>
            }
            icon={<IdcardOutlined />}
          >
            {this.props.permisoAccesoProveedores && (
              <Menu.Item
                key={this.props.match.url + "/proveedores"}
                icon={<IdcardOutlined />}
              >
                <NavLink to={this.props.match.url + "/proveedores"}>
                  Proveedores
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoTipoDeProveedores && (
              <Menu.Item
                key={this.props.match.url + "/tipodeproveedores"}
                icon={<IdcardFilled />}
              >
                <NavLink to={this.props.match.url + "/tipodeproveedores"}>
                  Tipo de Proveedores
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoTipoDeProveedores && (
              <Menu.Item
                key={this.props.match.url + "/insumoProveedor"}
                icon={<InteractionFilled />}
              >
                <NavLink to={this.props.match.url + "/insumoProveedor"}>
                  Relación Insumo - Proveedor
                </NavLink>
              </Menu.Item>
            )}
            {(this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores) && (
              <Menu.Item
                key={this.props.match.url + "/evaluacionProveedores"}
                icon={<AuditOutlined />}
              >
                <NavLink to={this.props.match.url + "/evaluacionProveedores"}>
                  <Badge
                    count={this.props.cuentaEvaluacionesProveedorPendientes}
                    offset={[0, -5]}
                    size="small"
                    style={{ boxShadow: "none" }}
                  >
                    <span style={{ color: this.state.isMobile ? "black" : "rgba(255, 255, 255, 0.65)" }}>
                      Evaluación de Proveedores
                    </span>
                  </Badge>
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}

        {this.props.permisoAccesoCapitalHumano && <SubMenu
          key={
            this.props.match.url + "/empleados" ||
            this.props.match.url + "/departamentos" ||
            this.props.match.url + "/puestos" ||
            this.props.match.url + "/turnos" ||
            this.props.match.url + "/configuracionNomina" ||
            this.props.match.url + "/relojesChecadores" ||
            this.props.match.url + "/preNomina"
          }
          title="Capital Humano"
          icon={<TeamOutlined />}
        >
          <Menu.Item
            key={this.props.match.url + "/empleados"}
            icon={<UserOutlined />}
          >
            <NavLink to={this.props.match.url + "/empleados"}>
              Empleados
            </NavLink>
          </Menu.Item>
              {this.props.permisoAccesoDepartamentos && (
                <Menu.Item
                  key={this.props.match.url + "/departamentos"}
                  icon={<IconBuild />}
                >
                  <NavLink to={this.props.match.url + "/departamentos"}>
                    Departamentos
                  </NavLink>
                </Menu.Item>
              )}
              {this.props.permisoAccesoVacaciones && (
                <Menu.Item
                  key={this.props.match.url + "/vacaciones"}
                  icon={<ScheduleOutlined />}
                >
                  <NavLink to={this.props.match.url + "/vacaciones"}>
                    Vacaciones
                  </NavLink>
                </Menu.Item>
              )}
          {this.props.nomina && (
            <>
              {this.props.permisoAccesoPuestos && (
                <Menu.Item
                  key={this.props.match.url + "/puestos"}
                  icon={<UsergroupAddOutlined />}
                >
                  <NavLink to={this.props.match.url + "/puestos"}>
                    Puestos
                  </NavLink>
                </Menu.Item>
              )}
              {this.props.permisoAccesoPrenomina && (
                <Menu.Item
                  key={this.props.match.url + "/preNomina"}
                  icon={<FileChart />}
                >
                  <NavLink to={this.props.match.url + "/preNomina"}>
                    Pre-Nomina
                  </NavLink>
                </Menu.Item>
              )}
              {this.props.permisoAccesoCreditosMovimientos && (
                <Menu.Item
                  key={this.props.match.url + "/creditosMovimientos"}
                  icon={<IconFileInvoice />}
                >
                  <NavLink to={this.props.match.url + "/creditosMovimientos"}>
                    Creditos y Movimientos
                  </NavLink>
                </Menu.Item>
              )}
              {this.props.permisoAccesoRecibos && (
                <Menu.Item
                  key={this.props.match.url + "/recibos"}
                  icon={<IconFileInvoice />}
                >
                  <NavLink to={this.props.match.url + "/recibos"}>
                    Recibos
                  </NavLink>
                </Menu.Item>
              )}
              {this.props.permisoAccesoReportesNomina && (
                <Menu.Item
                  key={this.props.match.url + "/reportesNomina"}
                  icon={<FileChart />}
                >
                  <NavLink to={this.props.match.url + "/reportesNomina"}>
                    Reportes
                  </NavLink>
                </Menu.Item>
              )}
              <Menu.Item
                key={this.props.match.url + "/generarAguinaldo"}
                icon={<FileChart />}
              >
                <NavLink to={this.props.match.url + "/generarAguinaldo"}>
                  Generar Aguinaldo
                </NavLink>
              </Menu.Item>
              {this.props.permisoAccesoConfiguracionNomina && (
                <Menu.Item
                  key={this.props.match.url + "/configuracionNomina"}
                  icon={<SettingOutlined />}
                >
                  <NavLink to={this.props.match.url + "/configuracionNomina"}>
                    Configuración
                  </NavLink>
                </Menu.Item>
              )}
            </>
          )}
        </SubMenu>}
        {this.props.controlAsistencia && this.props.permisoAccesoControlAsistencia && (
          <SubMenu
            key={
              this.props.match.url + "/relojesChecadores" ||
              this.props.match.url + "/asignacionRelojes" ||
              this.props.match.url + "/asistencia"
            }
            title="Control Asis."
            icon={<IconCalendarCheck />}
          >
            {this.props.permisoAccesoRelojesChecadores && (
              <Menu.Item
                key={this.props.match.url + "/relojesChecadores"}
                icon={<IconClockPin />}
              >
                <NavLink to={this.props.match.url + "/relojesChecadores"}>
                  Relojes Checadores
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoAsignacionRelojes && (
              <Menu.Item
                key={this.props.match.url + "/asignacionRelojes"}
                icon={<IconClockCheck />}
              >
                <NavLink to={this.props.match.url + "/asignacionRelojes"}>
                  Asignación de Relojes
                </NavLink>
              </Menu.Item>
            )}
            {/* Mientras no haya permisos propios, usa el acceso a Relojes Checadores */}
            {this.props.appMovil && this.props.checadaRemota && this.props.permisoAccesoRelojesChecadores && (
              <Menu.Item
                key={this.props.match.url + "/perimetrosChecada"}
                icon={<EnvironmentOutlined />}
              >
                <NavLink to={this.props.match.url + "/perimetrosChecada"}>
                  Perímetros de Checada
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoAsistencia && (
              <Menu.Item
                key={this.props.match.url + "/asistencia"}
                icon={<IconCalendarTime />}
              >
                <NavLink to={this.props.match.url + "/asistencia"}>
                  Asistencia
                </NavLink>
              </Menu.Item>
            )}
            {/* Mientras no haya permisos propios, usa el acceso a Asistencia */}
            {this.props.appMovil && this.props.checadaRemota && this.props.permisoAccesoAsistencia && (
              <Menu.Item
                key={this.props.match.url + "/intentosChecadaRechazados"}
                icon={<WarningOutlined />}
              >
                <NavLink to={this.props.match.url + "/intentosChecadaRechazados"}>
                  Checadas Rechazadas
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoHorarios && (
              <Menu.Item
                key={this.props.match.url + "/horarios"}
                icon={<IconCalendarClock />}
              >
                <NavLink to={this.props.match.url + "/horarios"}>
                  Horarios
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoDescansos && (
              <Menu.Item
                key={this.props.match.url + "/descansos"}
                icon={<IconBedFlat />}
              >
                <NavLink to={this.props.match.url + "/descansos"}>
                  Descansos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoTurnos && (
              <Menu.Item
                key={this.props.match.url + "/turnos"}
                icon={<ClockCircleOutlined />}
              >
                <NavLink to={this.props.match.url + "/turnos"}>
                  Turnos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoAsignacionTurnos && (
              <Menu.Item
                key={this.props.match.url + "/asignacionTurnos"}
                icon={<IconCalendarClock24 />}
              >
                <NavLink to={this.props.match.url + "/asignacionTurnos"}>
                  Asignación de Turnos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoCalendarioEmpleado && (
              <Menu.Item
                key={this.props.match.url + "/calendarioEmpleado"}
                icon={<IconCalendarMonth />}
              >
                <NavLink to={this.props.match.url + "/calendarioEmpleado"}>
                  Calendario Empleado
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoPrimeroUltimo && (
              <Menu.Item
                key={this.props.match.url + "/primeroUltimo"}
                icon={<IconCalendarMonth />}
              >
                <NavLink to={this.props.match.url + "/primeroUltimo"}>
                  Primero & Ultimo
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoAsistenciaDiaria && (
              <Menu.Item
                key={this.props.match.url + "/asistenciaDiaria"}
                icon={<IconCalendarMonth />}
              >
                <NavLink to={this.props.match.url + "/asistenciaDiaria"}>
                  Asistencia Diaria
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoEmpleadosSitio && (
              <Menu.Item
                key={this.props.match.url + "/empleadosEnSitio"}
                icon={<TeamOutlined />}
              >
                <NavLink to={this.props.match.url + "/empleadosEnSitio"}>
                  Emp. en Sitio
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoTotalAsistencia && (
              <Menu.Item
                key={this.props.match.url + "/totalAsistencia"}
                icon={<IconCalendarMonth />}
              >
                <NavLink to={this.props.match.url + "/totalAsistencia"}>
                  Total Asistencia
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoConfiguracionAsistencia && (
              <Menu.Item
                key={this.props.match.url + "/configuracionAsistencia"}
                icon={<IconClockCog />}
              >
                <NavLink to={this.props.match.url + "/configuracionAsistencia"}>
                  Configuración Asis.
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        )}
        {this.props.moduloCalidad && this.props.permisoAccesoCalidad && (
          <Menu.Item
              key={this.props.match.url + "/calidad"}
              icon={<CheckCircleFilled/>}
            >
              <NavLink to={this.props.match.url + "/calidad"}>Calidad</NavLink>
            </Menu.Item>
        )}
        {/*{this.props.permisoAccesoReportes ? (
          null
        ) : null}*/}
        {this.props.permisoAccesoCuentasContables ||
          this.props.permisoAccesoTipoDePolizas ||
          this.props.permisoAccesoTipoDeFlujos ||
          this.props.permisoAccesoImpuestos ||
          this.props.permisoAccesoRetenciones ? (
          <SubMenu
            key={
              this.props.match.url + "/cuentascontables" ||
              this.props.match.url + "/tipodeflujos" ||
              this.props.match.url + "/impuestos" ||
              this.props.match.url + "/retenciones" ||
              this.props.match.url + "/tipodepolizas"
            }
            title="Contabilidad"
            icon={<BankFilled />}
          >
            {this.props.permisoAccesoCuentasContables && (
              <Menu.Item
                key={this.props.match.url + "/cuentascontables"}
                icon={<BankOutlined />}
              >
                <NavLink to={this.props.match.url + "/cuentascontables"}>
                  Cuentas Contables
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoTipoDePolizas && (
              <Menu.Item
                key={this.props.match.url + "/tipodepolizas"}
                icon={<BookOutlined />}
              >
                <NavLink to={this.props.match.url + "/tipodepolizas"}>
                  Tipo de Polizas
                </NavLink>
              </Menu.Item>
            )}
            {/* <Menu.Item
          key={this.props.match.url + "/tipodeegresos"}
          icon={<WalletOutlined />}
        >
          <NavLink to={this.props.match.url + "/tipodeegresos"}>
            Tipo de Egresos
          </NavLink>
        </Menu.Item> */}
            {this.props.permisoAccesoTipoDeFlujos && (
              <Menu.Item
                key={this.props.match.url + "/tipodeflujos"}
                icon={<InteractionOutlined />}
              >
                <NavLink to={this.props.match.url + "/tipodeflujos"}>
                  Tipo de Flujos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoImpuestos && (
              <Menu.Item
                key={this.props.match.url + "/impuestos"}
                icon={<DollarOutlined />}
              >
                <NavLink to={this.props.match.url + "/impuestos"}>
                  Impuestos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoRetenciones && (
              <Menu.Item
                key={this.props.match.url + "/retenciones"}
                icon={<DollarCircleFilled />}
              >
                <NavLink to={this.props.match.url + "/retenciones"}>
                  Retenciones
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {this.props.permisoAccesoPolizas ||
          this.props.permisoAccesoCargosAbonos ||
          this.props.permisoAccesoReclasificacionCargosAbonos ? (
          <SubMenu
            key={
              this.props.match.url + "/polizas" ||
              this.props.match.url + "/plantillasPolizas" ||
              this.props.match.url + "/presupuestos" ||
              this.props.match.url + "/cargosabonos" ||
              this.props.match.url + "/reclasificacionCargosAbonos"
            }
            title="Finanzas"
            icon={<FundProjectionScreenOutlined />}
          >
            <Menu.Item
              key={this.props.match.url + "/presupuestos"}
              icon={<FundFilled />}
            >
              <NavLink to={this.props.match.url + "/presupuestos"}>
                Presupuestos
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/subProyectos"}
              icon={<IconChartDots />}
            >
              <NavLink to={this.props.match.url + "/subProyectos"}>
                SubProyectos
              </NavLink>
            </Menu.Item>
            {this.props.permisoAccesoPolizas && (
              <Menu.Item
                key={this.props.match.url + "/polizas"}
                icon={<BookFilled />}
              >
                <NavLink to={this.props.match.url + "/polizas"}>
                  Polizas
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoPolizas && (
              <Menu.Item
                key={this.props.match.url + "/plantillasPolizas"}
                icon={<IconCone />}
              >
                <NavLink to={this.props.match.url + "/plantillasPolizas"}>
                  Plantillas Polizas
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoCargosAbonos && (
              <Menu.Item
                key={this.props.match.url + "/cargosabonos"}
                icon={<ClusterOutlined />}
              >
                <NavLink to={this.props.match.url + "/cargosabonos"}>
                  Cargo Abonos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoReclasificacionCargosAbonos && (
              <Menu.Item
                key={this.props.match.url + "/reclasificacionCargosAbonos"}
                icon={<ClusterOutlined />}
              >
                <NavLink to={this.props.match.url + "/reclasificacionCargosAbonos"}>
                  Reclasificar Movimientos
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {this.props.permisoAccesoUnidadesDeNegocio ||
          this.props.permisoAccesoProyectos ? (
          <SubMenu
            key={
              this.props.match.url + "/unidadesdenegocio" ||
              this.props.match.url + "/proyectos"
            }
            title="Negocio"
            icon={<ExpandOutlined />}
          >
            {this.props.permisoAccesoUnidadesDeNegocio && (
              <Menu.Item
                key={this.props.match.url + "/unidadesdenegocio"}
                icon={<LayoutOutlined />}
              >
                <NavLink to={this.props.match.url + "/unidadesdenegocio"}>
                  Unidades de Negocio
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoAccesoProyectos && (
              <Menu.Item
                key={this.props.match.url + "/proyectos"}
                icon={<ProjectOutlined />}
              >
                <NavLink to={this.props.match.url + "/proyectos"}>
                  Proyectos / Almacenes
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {this.props.permisoAccesoUbicaciones && this.props.moduloWms ? (
          <SubMenu
            key={this.props.match.url + "/wms"}
            title="WMS"
            icon={<EnvironmentOutlined />}
          >
            <Menu.Item
              key={this.props.match.url + "/ubicaciones"}
              icon={<TableOutlined />}
            >
              <NavLink to={this.props.match.url + "/ubicaciones"}>
                Ubicaciones
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/mapa"}
              icon={<ClusterOutlined />}
            >
              <NavLink to={this.props.match.url + "/mapa"}>
                Mapa
              </NavLink>
            </Menu.Item>
          </SubMenu>
        ) : null}
        {this.props.moduloHoteleria ? (
          <SubMenu
            key={this.props.match.url + "/hotel"}
            title="Hotel"
            icon={<IconBed />}
          >
            <Menu.Item
              key={this.props.match.url + "/mapaHotel"}
              icon={<ClusterOutlined />}
            >
              <NavLink to={this.props.match.url + "/mapaHotel"}>
                Mapa de Hotel
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/ocupacionFuturoHotel"}
              icon={<CalendarOutlined />}
            >
              <NavLink to={this.props.match.url + "/ocupacionFuturoHotel"}>
                Ocupacion a Futuro
              </NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/agendaHotel"}
              icon={<ScheduleOutlined />}
            >
              <NavLink to={this.props.match.url + "/agendaHotel"}>
                Agenda
              </NavLink>
            </Menu.Item>
          </SubMenu>
        ) : null}
        {this.props.transporte && (this.props.permisoAccesoVehiculos ||
          this.props.permisoRendimientoVehiculos ||
          this.props.permisoHabilitarPolizasSeguro ||
          this.props.permisoEditarPolizasSeguro ||
          this.props.permisoAgregarPolizasSeguro
        ) ? (
          <SubMenu
            key={
              this.props.match.url + "/vehiculos" ||
              this.props.match.url + "/polizasSeguro" ||
              this.props.match.url + "/remolques"
            }
            title="Transporte "
            icon={<IconCartGarage />}
          >
            {this.props.permisoAccesoVehiculos && (
              <Menu.Item
                key={this.props.match.url + "/vehiculos"}
                icon={<IconCartCrane />}
              >
                <NavLink to={this.props.match.url + "/vehiculos"}>
                  Vehículos
                </NavLink>
              </Menu.Item>
            )}
            {this.props.permisoRendimientoVehiculos && (
              <Menu.Item
                key={this.props.match.url + "/consumoCombustible"}
                icon={<LineChartOutlined />}
              >
                <NavLink to={this.props.match.url + "/consumoCombustible"}>
                  Rendimiento Vehículos
                </NavLink>
              </Menu.Item>
            )}
            {(this.props.permisoAgregarPolizasSeguro || this.props.permisoEditarPolizasSeguro || this.props.permisoHabilitarPolizasSeguro) && (
              <Menu.Item
                key={this.props.match.url + "/polizasSeguro"}
                icon={<FileProtectOutlined />}
              >
                <NavLink to={this.props.match.url + "/polizasSeguro"}>
                  Polizas de Seguro
                </NavLink>
              </Menu.Item>
            )
            }
            {this.props.permisoAccesoProyectos && this.props.envios && (
              <Menu.Item
                key={this.props.match.url + "/remolques"}
                icon={<CarOutlined />}
              >
                <NavLink to={this.props.match.url + "/remolques"}>
                  Remolques
                </NavLink>
              </Menu.Item>
            )}
          </SubMenu>
        ) : null}
        {/*
      <SubMenu
        key={
          this.props.match.url + "/RegistroDeLotes" ||
          this.props.match.url + "/CorteDePinas"
        }
        title="Mezcal"
        icon={<ShoppingCartOutlined />}
      >
        <Menu.Item
          key={this.props.match.url + "/RegistroDeLotes"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/RegistroDeLotes"}>
            Registro de Lotes
          </NavLink>
        </Menu.Item>
        <Menu.Item
          key={this.props.match.url + "/CorteDePiñas"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/CorteDePiñas"}>
            Corte de Piñas
          </NavLink>
        </Menu.Item>
        <Menu.Item
          key={this.props.match.url + "/Horneado"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/Horneado"}>
            Horneado
          </NavLink>
        </Menu.Item>
        <Menu.Item
          key={this.props.match.url + "/Fermentacion"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/Fermentacion"}>
            Fermentacion
          </NavLink>
        </Menu.Item>
        <Menu.Item
          key={this.props.match.url + "/PrimeraDestilacion"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/PrimeraDestilacion"}>
            Primera Destilacion
          </NavLink>
        </Menu.Item>
        <Menu.Item
          key={this.props.match.url + "/SegundaDestilacion"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/SegundaDestilacion"}>
            Segunda Destilacion
          </NavLink>
        </Menu.Item>
        <Menu.Item
          key={this.props.match.url + "/TerceraDestilacion"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/TerceraDestilacion"}>
            Tercera Destilacion
          </NavLink>
        </Menu.Item>
        <Menu.Item
          key={this.props.match.url + "/TanquesLlenado"}
          icon={<BarsOutlined />}
        >
          <NavLink to={this.props.match.url + "/TanquesLlenado"}>
            Tanques de Llenado
          </NavLink>
        </Menu.Item>
      </SubMenu>*/}

        {this.props.permisoAccesoReportes ? (
          <Menu.Item
            key={this.props.match.url + "/reportes"}
            icon={<LineChartOutlined />}
          >
            <NavLink to={this.props.match.url + "/reportes"}>Reportes</NavLink>
          </Menu.Item>
        ) : null}


        {this.props.permisoVerBitacora ? (
          <SubMenu
            key={
              this.props.match.url + "/bitacora" ||
              this.props.match.url + "/historialCorreos"
            }
            title="Auditoría"
            icon={<AuditOutlined />}
          >
            <Menu.Item
              key={this.props.match.url + "/bitacora"}
              icon={<HistoryOutlined />}
            >
              <NavLink to={this.props.match.url + "/bitacora"}>Bitácora de Actividad</NavLink>
            </Menu.Item>
            <Menu.Item
              key={this.props.match.url + "/historialCorreos"}
              icon={<SendOutlined />}
            >
              <NavLink to={this.props.match.url + "/historialCorreos"}>Historial de Correos</NavLink>
            </Menu.Item>
          </SubMenu>
        ) : null}
        {this.props.autorizacionesRapidas && (this.state.esAutorizadorRapidas || this.props.permisoAccesoAutorizaciones) ? (
          <Menu.Item
            key={this.props.match.url + "/autorizaciones"}
            icon={<FileProtectOutlined />}
          >
            <NavLink to={this.props.match.url + "/autorizaciones"}>
              Autorizaciones
            </NavLink>
          </Menu.Item>
        ) : null}
        {this.props.permisoAccesoConfiguracion && (
          <Menu.Item
            key={this.props.match.url + "/configuracion"}
            icon={<SettingOutlined />}
          >
            <NavLink to={this.props.match.url + "/configuracion"}>
              Configuración
            </NavLink>
          </Menu.Item>
        )}
        {(!this.props.ventaOnline || (this.props.ventaOnline && this.props.permisoAccesoEcommerce)) && (
          <Menu.Item
            key={this.props.match.url + "/configuracionecommerce"}
            icon={<IconShoppingCartConfig />}
            className="menu-item-soporte-animado"

          >
            <NavLink to={this.props.match.url + "/configuracionecommerce"}>

              <span className="menu-title-soporte">E-Commerce</span>
            </NavLink>
          </Menu.Item>
        )}

        {(this.props.whatsapp && this.props.permisoAccesoWhatsapp) && (
          <Menu.Item
            key={this.props.match.url + "/whatsapp"}
            icon={<WhatsAppOutlined className="icon-soporte" />}
            className="menu-item-soporte-animado menu-item-whatsapp-animado"
          >
            <NavLink to={this.props.match.url + "/whatsapp"}>
              <span className="menu-title-soporte">Whatsapp</span>
            </NavLink>
          </Menu.Item>
        )}

        {/* <Menu.Item
          key={this.props.match.url + "/configuracionclaude"}
          icon={<IconBiwo />}
          className="menu-item-claude-animado"
        >
          <NavLink to={this.props.match.url + "/configuracionclaude"}>
            <span className="menu-title-claude">BIWO IA</span>
          </NavLink>
        </Menu.Item> */}

        <Menu.Item
          key={this.props.match.url + "/soporte"}
          className="menu-item-soporte-animado"
          icon={<IconSupport className="icon-soporte" />}
        >
          <NavLink to={this.props.match.url + "/soporte"}>
            <span className="menu-title-soporte">Soporte</span>
          </NavLink>
        </Menu.Item>
        {this.state.permisoSoporte && (
          <Menu.Item
            key={this.props.match.url + "/ticketsSoporte"}
            icon={<CustomerServiceOutlined />}
          >
            <NavLink to={this.props.match.url + "/ticketsSoporte"}>
              Tickets de Soporte
            </NavLink>
          </Menu.Item>
        )}
      </>
    );

    const buscadorMenuHabilitado = true;

    return (
      <Layout id="sinfondo">
        <Header id="header-fixed">
          <Menu
            mode="horizontal"
            selectedKeys={[current]}
            style={{ height: "100%" }}
            id="menu-centered"
          >
            {this.state.isMobile && (
              <Menu.Item
                key={10}
                icon={
                  <Badge count={this.state.unreadCount}>
                    <BellOutlined style={{ fontSize: 20 }} />
                  </Badge>
                }
                onClick={() => this.abrirNotificaciones(true)}
              />
            )}
            {this.state.isMobile && this.mostrarBotonSoporte() && (
              <Menu.Item
                key="soporteBarra"
                icon={
                  <Badge count={this.state.soporteNoLeidos} overflowCount={99}>
                    <CustomerServiceOutlined style={{ fontSize: 20 }} />
                  </Badge>
                }
                onClick={this.alternarBurbujaSoporte}
              />
            )}
            <Menu.Item key={"/login"} id="menuitem-izquierda">
              <img src={logoHorizontal} alt="Logo" id="img-logo" />
            </Menu.Item>
            {this.state.isMobile ? (
              <Menu.Item
                key={0}
                icon={<MenuOutlined style={{ fontSize: 20 }} />}
                onClick={this.toggleDrawer.bind(this)}
              />
            ) : (
              <>
                <Menu.Item disabled id="menuitem-izquierda">
                  {this.props.empresa ? <h1>{this.props.empresa}</h1> : null}
                </Menu.Item>
                <Menu.Item
                  id="menuitem"
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  onClick={() => this.abrirNotificaciones(true)}
                >
                  <Badge count={this.state.unreadCount}>
                    <BellOutlined style={{ fontSize: "17px" }} />
                  </Badge>
                </Menu.Item>
                <Menu.Item
                  key="3"
                  id="menuitem"
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  icon={<LogoutOutlined />}
                  onClick={this.abrirModalLogout}
                >
                  Cerrar Sesión
                </Menu.Item>
                {this.mostrarBotonSoporte() && (
                  <Menu.Item
                    key="soporteBarra"
                    id="menuitem"
                    style={{ paddingLeft: "20px", paddingRight: "20px" }}
                    icon={<CustomerServiceOutlined />}
                    onClick={this.alternarBurbujaSoporte}
                  >
                    <Badge count={this.state.soporteNoLeidos} overflowCount={99} offset={[10, 0]}>
                      Soporte
                    </Badge>
                  </Menu.Item>
                )}
                <Menu.Item
                  key="2"
                  id="menuitem"
                  style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  icon={<RollbackOutlined />}
                  onClick={this.deseleccionarEmpresa.bind(this)}
                >
                  Panel Principal
                </Menu.Item>
              </>
            )}
          </Menu>
        </Header>
        <Layout>
          {this.state.isMobile ? (
            <Drawer
              title="Menu"
              placement="left"
              rootClassName="ant-drawer-left"
              onClose={this.toggleDrawer}
              open={this.state.drawerVisible}
              bodyStyle={{ padding: 0 }}
              width={Math.min(300, window.innerWidth - 10)}
            >
              <BuscadorMenuInput
                menuItems={menuItems}
                habilitado={buscadorMenuHabilitado}
              >
                {(itemsAMostrar) => (
                  <Menu
                    mode="inline"
                    theme="light"
                    openKeys={this.state.openKeys}
                    selectedKeys={[current]}
                    onOpenChange={this.onOpenChange.bind(this)}
                  >
                    <Menu.Item disabled>
                      {this.props.empresa ? (
                        <h1 style={{ fontSize: 10 }}>{this.props.empresa}</h1>
                      ) : null}
                    </Menu.Item>
                    {itemsAMostrar}
                    <Menu.Item
                      icon={<RollbackOutlined />}
                      style={{ marginTop: 20, color: "blue" }}
                      key="2"
                      onClick={this.deseleccionarEmpresa.bind(this)}
                    >
                      Panel Principal
                    </Menu.Item>
                    <Menu.Item
                      icon={<LogoutOutlined />}
                      style={{ color: "red" }}
                      key="3"
                      onClick={this.abrirModalLogout}
                    >
                      Cerrar Sesion
                    </Menu.Item>
                  </Menu>
                )}
              </BuscadorMenuInput>
            </Drawer>
          ) : (
            <Sider
              collapsible={window.innerWidth > 1000 ? true : false}
              collapsed={window.innerWidth > 1000 ? this.state.collapsed : true}
              onCollapse={window.innerWidth > 1000 ? this.onCollapse : () => { }}
              style={{ marginTop: "64px", minHeight: window.innerHeight - 64 }}
            >
              <div
                style={{
                  overflowY: "scroll",
                  height: window.innerHeight - 64 - 48,
                  position: "sticky",
                  zIndex: 1,
                  top: "64px",
                }}
                className="hide-scrollbar"
              >
                {/*
                  En mode="vertical" los submenús son popups por hover y rc-menu
                  ya los administra solo. NO controlar openKeys aquí: hacerlo
                  obligaba a un setState de Panel por cada abrir/cerrar, y cada
                  setState vuelve a construir todo el árbol de este render
                  (menú completo + las ~477 <Route> del Switch) de forma
                  síncrona, lo que producía el lag y perdía el hover del
                  siguiente submenú. Sin la prop, rc-menu solo actualiza su
                  mini-store y únicamente se repintan los SubMenu afectados.
                  El openKeys controlado se sigue usando en el Drawer móvil,
                  que sí es mode="inline" (acordeón).
                */}
                <BuscadorMenuInput
                  menuItems={menuItems}
                  habilitado={buscadorMenuHabilitado && !this.state.collapsed}
                  oscuro
                >
                  {(itemsAMostrar) => (
                    <Menu
                      selectedKeys={[current]}
                      mode="vertical"
                      theme="dark"
                    >
                      {itemsAMostrar}
                    </Menu>
                  )}
                </BuscadorMenuInput>
              </div>
            </Sider>
          )}
          <Layout
            style={{
              marginRight:
                (this.state.whatsappBurbujaAbierta &&
                  !this.state.isMobile &&
                  !this.props.history.location.pathname.endsWith("/whatsapp")) ||
                (this.state.soporteBurbujaAbierta &&
                  !this.state.isMobile &&
                  !this.props.history.location.pathname.endsWith("/ticketsSoporte"))
                  ? 380
                  : 0,
              transition: "margin-right 0.25s ease",
            }}
          >
            <Content id="content">
              <ScrollToTopItem />
              <Switch>
                {this.props.permisoAccesoInicio && (
                  <Route
                    path={this.props.match.url + "/inicio"}
                    component={Inicio}
                  />
                )}
                {this.props.permisoAccesoLeerXml && (
                  <Route
                    path={this.props.match.url + "/leerXml"}
                    component={LeerXml}
                  />
                )}
                <Route
                  path={this.props.match.url + "/pagosCompras"}
                  component={PagosCompras}
                />
                <Route
                  path={this.props.match.url + "/polizaManual"}
                  component={PolizaManual}
                />
                <Route
                  path={this.props.match.url + "/editarPolizaManual"}
                  component={EditarPolizaManual}
                />
                {this.props.permisoAccesoBancos && (
                  <Route
                    path={this.props.match.url + "/bancos"}
                    component={Bancos}
                  />
                )}
                {this.props.permisoAccesoBancos && (
                  <Route
                    path={this.props.match.url + "/conciliarCuenta"}
                    component={ConciliacionesCuenta}
                  />
                )}
                {this.props.permisoAccesoBancos && (
                  <Route
                    path={this.props.match.url + "/conciliacion"}
                    component={Conciliacion}
                  />
                )}
                {this.props.permisoAccesoBancos && (
                  <Route
                    path={this.props.match.url + "/verConciliacion"}
                    component={VerConciliacion}
                  />
                )}
                {this.props.permisoAccesoCajaChica && (
                  <Route
                    path={this.props.match.url + "/cajaefectivo"}
                    component={CajaEfectivo}
                  />
                )}
                {this.props.permisoAccesoBancos && (
                  <Route
                    path={this.props.match.url + "/creditos"}
                    component={Creditos}
                  />
                )}
                {this.props.permisoAccesoBancos && (
                  <Route
                    path={this.props.match.url + "/verCredito"}
                    component={VerCredito}
                  />
                )}
                {this.props.permisoAccesoVentas && (
                  <Route
                    path={this.props.match.url + "/ventas"}
                    component={Ventas}
                  />
                )}
                {this.props.permisoAccesoVentas && (
                  <Route
                    path={this.props.match.url + "/ventasProgramadas"}
                    component={VentasProgramadas}
                  />
                )}
                {this.props.permisoAccesoEcommerce && (
                  <Route
                    path={this.props.match.url + "/ventasEcommerce"}
                    component={VentasEcommerce}
                  />
                )}
                {this.props.permisoAccesoVentas && (
                  <Route
                    path={this.props.match.url + "/agregarVentaProgramada"}
                    component={AgregarVentaProgramada}
                  />
                )}
                {this.props.permisoAccesoVentas && (
                  <Route
                    path={this.props.match.url + "/editarVentaProgramada"}
                    component={EditarVentaProgramada}
                  />
                )}
                {this.props.permisoAccesoVentas && (
                  <Route
                    path={this.props.match.url + "/pendientesVentasProgramadas"}
                    component={PendientesVentasProgramadas}
                  />
                )}
                {this.props.permisoAccesoCotizaciones && (
                  <Route
                    path={this.props.match.url + "/cotizaciones"}
                    component={Cotizaciones}
                  />)}
                {this.props.permisoAccesoCotizaciones &&
                  <Route
                    path={this.props.match.url + "/cotizadorPorInsumo"}
                    component={CotizadorPorInsumo}
                  />}
                {this.props.permisoAccesoAgregarCotizaciones &&
                  <Route
                    path={this.props.match.url + "/agregarCotizacion"}
                    component={AgregarCotizacion}
                  />
                }
                {this.props.permisoAccesoAgregarCotizaciones && (
                  <Route
                    path={this.props.match.url + "/agregarCotizacionConLotes"}
                    component={AgregarCotizacionConLotes}
                  />
                )}
                {this.props.permisoAccesoAgregarCotizaciones && (
                  <Route
                    path={this.props.match.url + "/editarCotizacion"}
                    component={EditarCotizacion}
                  />
                )}
                {this.props.permisoAccesoVerCotizaciones && (
                  <Route
                    path={this.props.match.url + "/verCotizacion"}
                    component={VerCotizacion}
                  />
                )}
                {this.props.preCotizacionIngenieria && (
                  <Route
                    exact
                    path={this.props.match.url + "/preCotizacionIngenieria"}
                    component={PreCotizacionIngenieria}
                  />
                )}
                {this.props.preCotizacionIngenieria && (
                  <Route
                    exact
                    path={this.props.match.url + "/vistaPreCotizacionIngenieria"}
                    component={VistaPreCotizacionIngenieria}
                  />
                )}

                {this.props.permisoAccesoPedidos && (
                  <Route
                    path={this.props.match.url + "/pedidos"}
                    component={Pedidos}
                  />
                )}
                {this.props.permisoAgregarPedidos && (
                  <Route
                    path={this.props.match.url + "/agregarPedido"}
                    component={AgregarPedido}
                  />
                )}
                {this.props.permisoEditarPedidos && (
                  <Route
                    path={this.props.match.url + "/editarPedido"}
                    component={EditarPedido}
                  />
                )}
                {this.props.permisoVerPedidos && (
                  <Route
                    path={this.props.match.url + "/verPedido"}
                    component={VerPedido}
                  />
                )}
                {this.props.permisoAgregarPedidos && this.props.importarPedidosIMSS && (
                  <Route
                    path={this.props.match.url + "/importarPedidosIMSS"}
                    component={ImportarPedidosIMSS}
                  />
                )}

                {this.props.embarques && this.props.permisoAccesoEmbarques && (
                  <Route
                    path={this.props.match.url + "/embarques"}
                    component={Embarques}
                  />
                )}
                {this.props.embarques && this.props.permisoAgregarEmbarques && (
                  <Route
                    path={this.props.match.url + "/agregarEmbarque"}
                    component={AgregarEmbarque}
                  />
                )}
                {this.props.embarques && this.props.permisoEditarEmbarques && (
                  <Route
                    path={this.props.match.url + "/editarEmbarque"}
                    component={EditarEmbarque}
                  />
                )}
                {this.props.embarques && this.props.permisoVerEmbarques && (
                  <Route
                    path={this.props.match.url + "/verEmbarque"}
                    component={VerEmbarque}
                  />
                )}
                {this.props.embarques && this.props.permisoEntregarEmbarques && (
                  <Route
                    path={this.props.match.url + "/entregarInsumosEmbarque"}
                    component={EntregarInsumosEmbarque}
                  />
                )}

                {this.props.permisoAccesoVentas && (
                  <Route
                    path={this.props.match.url + "/canalesVenta"}
                    component={CanalesVenta}
                  />
                )}
                <Route
                  path={this.props.match.url + "/abonosClientes"}
                  component={AbonosClientes}
                />
                <Route
                  path={this.props.match.url + "/agregarAbonoCliente"}
                  component={AgregarAbonoCliente}
                />
                <Route
                  path={this.props.match.url + "/editarAbonoCliente"}
                  component={EditarAbonoCliente}
                />
                <Route
                  path={this.props.match.url + "/editarAbonoProveedor"}
                  component={EditarAbonoProveedor}
                />
                <Route
                  path={this.props.match.url + "/abonosProveedores"}
                  component={AbonosProveedores}
                />
                <Route
                  path={this.props.match.url + "/agregarAbonoProveedor"}
                  component={AgregarAbonoProveedor}
                />
                <Route
                  path={this.props.match.url + "/facturasGlobales"}
                  component={FacturasGlobales}
                />
                <Route
                  path={this.props.match.url + "/notasDeCreditoVentas"}
                  component={NotasDeCreditoVenta}
                />
                <Route
                  path={this.props.match.url + "/devolucionesVentas"}
                  component={Devoluciones}
                />
                {this.props.moduloRMA && (
                  <Route exact path={this.props.match.url + "/rma"} component={RMAs} />
                )}
                {this.props.moduloRMA && (
                  <Route exact path={this.props.match.url + "/vistaRMA"} component={VistaRMA} />
                )}
                {this.props.moduloRMA && (
                  <Route exact path={this.props.match.url + "/configuracionRMA"} component={ConfiguracionRMA} />
                )}
                {this.props.moduloRMACompras && (
                  <Route exact path={this.props.match.url + "/rmaCompras"} component={RMAsCompra} />
                )}
                {this.props.moduloRMACompras && (
                  <Route exact path={this.props.match.url + "/vistaRMACompra"} component={VistaRMACompra} />
                )}
                {this.props.moduloRMACompras && (
                  <Route exact path={this.props.match.url + "/configuracionRMACompra"} component={ConfiguracionRMACompra} />
                )}
                <Route
                  path={this.props.match.url + "/notasDeCreditoCompra"}
                  component={NotasDeCreditoCompra}
                />
                <Route
                  path={this.props.match.url + "/devolucionesCompra"}
                  component={DevolucionesCompra}
                />
                <Route
                  path={this.props.match.url + "/cobros"}
                  component={PagosVentas}
                />
                <Route
                  path={this.props.match.url + "/agregarVenta"}
                  component={AgregarVenta}
                />
                <Route
                  path={this.props.match.url + "/puntoDeVenta"}
                  component={PuntoDeVenta}
                />
                <Route
                  path={this.props.match.url + "/verVenta"}
                  component={VerVenta}
                />
                {this.props.permisoAccesoCuentasPorPagar && (
                  <Route
                    path={this.props.match.url + "/cuentasporpagar"}
                    component={CuentasPorPagar}
                  />
                )}
                {this.props.permisoAccesoCuentasPorCobrar && (
                  <Route
                    path={this.props.match.url + "/cuentasporcobrar"}
                    component={CuentasPorCobrar}
                  />
                )}
                {true && (
                  <Route
                    path={this.props.match.url + "/programarRecordatorios"}
                    component={ProgramarRecordatorios}
                  />
                )}
                {this.props.permisoCobrar && (
                  <Route
                    path={this.props.match.url + "/verVentasCliente"}
                    component={VerVentasCliente}
                  />
                )}
                {this.props.permisoCobrar && (
                  <Route
                    path={this.props.match.url + "/cobrarVenta"}
                    component={CobrarVenta}
                  />
                )}
                <Route
                  path={this.props.match.url + "/pagarFactura"}
                  component={PagarFactura}
                />
                <Route
                  path={this.props.match.url + "/verFacturasProveedor"}
                  component={VerFacturasProveedor}
                />
                {this.props.permisoAccesoClientes && (
                  <Route
                    path={this.props.match.url + "/clientes"}
                    component={Clientes}
                  />
                )}
                {this.props.permisoAccesoConfiguracionClientes && (
                  <Route
                    path={this.props.match.url + "/configuracionClientes"}
                    component={ConfiguracionClientes}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/escuela"}
                    component={Escuela}
                  />
                )}
                {this.props.permisoAccesoCRM && (
                  <Route
                    path={this.props.match.url + "/crmDashboard"}
                    component={CRMDashboard}
                  />
                )}
                {this.props.permisoAccesoCRM && (
                  <Route
                    path={this.props.match.url + "/crmContactos"}
                    component={ContactosCRM}
                  />
                )}
                {(this.props.permisoAccesoCRM && this.props.permisoAccesoConfiguracionCRM) && (
                  <Route
                    exact
                    path={this.props.match.url + "/crmConfiguracion"}
                    component={ConfiguracionCRM}
                  />
                )}
                {(this.props.permisoAccesoCRM && this.props.permisoAccesoConfiguracionCRM) && (
                  <Route
                    path={this.props.match.url + "/crmConfiguracion/embudo/:id"}
                    component={VistaEmbudo}
                  />
                )}
                {this.props.permisoAccesoCRM && (
                  <Route
                    exact
                    path={this.props.match.url + "/crmCalendario"}
                    component={CalendarioRecordatorios}
                  />
                )}
                {this.props.permisoAccesoCRM && (
                  <Route
                    exact
                    path={this.props.match.url + "/crmReportes"}
                    component={ReportesCRM}
                  />
                )}
                {(this.props.permisoAccesoCRM && (this.props.permisoMasterCRM || this.props.permisoReporteEmbudoCRM)) && (
                  <Route
                    path={this.props.match.url + "/crmReportes/embudo"}
                    component={ReporteEmbudo}
                  />
                )}
                {(this.props.permisoAccesoCRM && (this.props.permisoMasterCRM || this.props.permisoReporteGanadasCRM)) && (
                  <Route
                    path={this.props.match.url + "/crmReportes/ganadas"}
                    component={ReporteOportunidadesGanadas}
                  />
                )}
                {(this.props.permisoAccesoCRM && (this.props.permisoMasterCRM || this.props.permisoReportePipelineCRM)) && (
                  <Route
                    path={this.props.match.url + "/crmReportes/pipeline"}
                    component={ReportePipelineCRM}
                  />
                )}
                {(this.props.permisoAccesoCRM && (this.props.permisoMasterCRM || this.props.permisoReporteLeadsCRM)) && (
                  <Route
                    path={this.props.match.url + "/crmReportes/leads"}
                    component={ReporteLeadsCRM}
                  />
                )}
                {(this.props.permisoAccesoCRM && (this.props.permisoMasterCRM || this.props.permisoReporteEquipoCRM)) && (
                  <Route
                    path={this.props.match.url + "/crmReportes/equipo"}
                    component={ReporteEquipoCRM}
                  />
                )}
                {(this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores) && (
                  <Route
                    exact
                    path={this.props.match.url + "/evaluacionProveedores"}
                    component={EvaluacionProveedores}
                  />
                )}
                {(this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores && this.props.permisoConfigurarPlantillasEvaluacion) && (
                  <Route
                    exact
                    path={this.props.match.url + "/evaluacionProveedoresConfiguracion"}
                    component={ConfiguracionEvaluacionProveedores}
                  />
                )}
                {(this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores && this.props.permisoConfigurarPlantillasEvaluacion) && (
                  <Route
                    path={this.props.match.url + "/evaluacionProveedoresConfiguracion/plantilla/:id"}
                    component={VistaPlantillaEvaluacion}
                  />
                )}
                {(this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores && this.props.permisoVerReportesEvaluacion) && (
                  <Route
                    exact
                    path={this.props.match.url + "/evaluacionProveedoresReportes"}
                    component={ReporteEvaluacionProveedores}
                  />
                )}
                <Route
                  path={this.props.match.url + "/importarClientes"}
                  component={ImportarClientes}
                />
                {this.props.permisoAccesoProveedores && (
                  <Route
                    path={this.props.match.url + "/proveedores"}
                    component={Proveedores}
                  />
                )}
                <Route
                  path={this.props.match.url + "/empleados"}
                  component={Empleados}
                />
                <Route
                  path={this.props.match.url + "/agregarEmpleado"}
                  component={AgregarEmpleado}
                />
                <Route
                  path={this.props.match.url + "/editarEmpleado"}
                  component={EditarEmpleado}
                />
                {/* Sin el gate del complemento a propósito: si se apaga con fichas a medias,
                    esas fichas se tienen que poder terminar. El complemento sólo decide si el
                    listado ofrece empezar una nueva. */}
                <Route
                  path={this.props.match.url + "/altaEmpleadoPorPasos"}
                  component={AltaEmpleadoPorPasos}
                />
                {/* El empleado va en la URL y no sólo en el state del router: sin él, recargar
                    la página o pegar el enlace dejaba la pantalla muerta con "No se recibió el
                    empleado". El parámetro es opcional para no romper los enlaces que ya navegan
                    con state. */}
                <Route
                  path={this.props.match.url + "/finiquito/:empleadoId?"}
                  component={Finiquito}
                />
                <Route
                  path={this.props.match.url + "/aumentoSueldo"}
                  component={AumentoSueldo}
                />
                <Route
                  path={this.props.match.url + "/importarEmpleados"}
                  component={ImportarEmpleados}
                />
                <Route
                  path={this.props.match.url + "/importarEmpleadosExterno"}
                  component={ImportarEmpleadosExterno}
                />
                <Route
                  path={this.props.match.url + "/edicionMasivaEmpleados"}
                  component={EdicionMasivaEmpleados}
                />
                <Route
                  path={this.props.match.url + "/edicionMasivaEmpleadosExterno"}
                  component={EdicionMasivaEmpleadosExterno}
                />
                <Route
                  path={this.props.match.url + "/relojesChecadores"}
                  component={RelojesChecadores}
                />
                <Route
                  path={this.props.match.url + "/asignacionRelojes"}
                  component={AsignacionRelojes}
                />
                <Route
                  path={this.props.match.url + "/importarAsignacionRelojes"}
                  component={ImportarAsignacionRelojes}
                />
                <Route
                  path={this.props.match.url + "/asignacionTurnos"}
                  component={AsignacionTurnos}
                />
                <Route
                  path={this.props.match.url + "/importarAsignacionTurnos"}
                  component={ImportarAsignacionTurnos}
                />
                <Route
                  path={this.props.match.url + "/calendarioEmpleado"}
                  component={CalendarioEmpleado}
                />
                <Route
                  path={this.props.match.url + "/empleadosEnSitio"}
                  component={EmpleadosEnSitio}
                />
                <Route
                  path={this.props.match.url + "/primeroUltimo"}
                  component={PrimeroUltimo}
                />
                <Route
                  path={this.props.match.url + "/totalAsistencia"}
                  component={TotalAsistencia}
                />
                <Route
                  path={this.props.match.url + "/asistenciaDiaria"}
                  component={AsistenciaDiaria}
                />
                <Route
                  path={this.props.match.url + "/asistencia"}
                  component={Asistencia}
                />
                <Route
                  path={this.props.match.url + "/perimetrosChecada"}
                  component={PerimetrosChecada}
                />
                <Route
                  path={this.props.match.url + "/intentosChecadaRechazados"}
                  component={IntentosChecadaRechazados}
                />
                <Route
                  path={this.props.match.url + "/descansos"}
                  component={Descansos}
                />
                <Route
                  path={this.props.match.url + "/horarios"}
                  component={Horarios}
                />
                <Route
                  path={this.props.match.url + "/configuracionAsistencia"}
                  component={ConfiguracionAsistencia}
                />
                <Route
                  path={this.props.match.url + "/importarProveedores"}
                  component={ImportarProveedores}
                />
                <Route
                  path={this.props.match.url + "/etapas"}
                  component={Etapas}
                />
                <Route
                  path={this.props.match.url + "/dashboard"}
                  component={Dashboard}
                />
                {this.props.permisoAccesoTipoDeProveedores && (
                  <Route
                    path={this.props.match.url + "/tipodeproveedores"}
                    component={TiposDeProveedores}
                  />
                )}
                {this.props.permisoAccesoTipoDeProveedores && (
                  <Route
                    path={this.props.match.url + "/insumoProveedor"}
                    component={InsumoProveedor}
                  />
                )}
                {this.props.permisoAccesoTipoDeClientes && (
                  <Route
                    path={this.props.match.url + "/tipodeclientes"}
                    component={TiposDeClientes}
                  />
                )}
                {this.props.permisoAccesoTipoDeClientes && (
                  <Route
                    path={this.props.match.url + "/portalClientes"}
                    component={PortalClientes}
                  />
                )}
                {this.props.permisoAccesoInsumos && (
                  <Route
                    path={this.props.match.url + "/insumos"}
                    component={Insumos}
                  />
                )}
                {this.props.permisoAccesoInsumos && this.props.filtrosAvanzadosInsumos && this.props.permisoAccesoFiltrosAvanzados && (
                  <Route
                    path={this.props.match.url + "/configuracionCategoriasInsumos"}
                    component={ConfiguracionCategoriasInsumos}
                  />
                )}
                {this.props.permisoAccesoInsumos && (
                  <Route
                    path={this.props.match.url + "/activos"}
                    component={Activos}
                  />
                )}
                {this.props.permisoAccesoInsumosCompuetos ? (
                  <Route
                    path={this.props.match.url + "/insumosCompuestos"}
                    component={InsumosCompuestos}
                  />
                ) : null}
                {this.props.permisoAccesoServicios ? (
                  <Route
                    path={this.props.match.url + "/servicios"}
                    component={Servicios}
                  />
                ) : null}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/inventarioInsumo"}
                    component={InventarioProducto}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/inventario"}
                    component={Inventario}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/ControlInventario"}
                    component={ControlInventario}
                  />
                )}
                {this.props.permisoAccesoAlmacen && (
                  <Route
                    path={this.props.match.url + "/almacen"}
                    component={Almacen}
                  />
                )}
                {this.props.permisoAccesoAlmacen && (
                  <Route
                    path={this.props.match.url + "/detalleOrdenAlmacen"}
                    component={DetalleOrdenAlmacen}
                  />
                )}
                {this.props.permisoRequerirMaterialAlmacen && (
                  <Route
                    path={this.props.match.url + "/requerirMaterialOrden"}
                    component={RequerirMaterialOrden}
                  />
                )}
                {this.props.permisoRequerirMaterialAlmacen && (
                  <Route
                    path={this.props.match.url + "/requerirMaterialOrdenes"}
                    component={RequerirMaterialOrdenes}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/importarControlInventario"}
                    component={ImportarControlInventario}
                  />
                )}
                {this.props.permisoAccesoMovimientosInventario && (
                  <Route
                    path={this.props.match.url + "/movimientosInventario"}
                    component={MovimientosInventario}
                  />
                )}
                {this.props.permisoAccesoMovimientosInventario &&
                  this.props.permisoVerMovimientosInventario && (
                  <Route
                    path={this.props.match.url + "/verMovimientoInventario/:id"}
                    component={VerMovimientoInventario}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/lotes"}
                    component={Lotes}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/lotesInsumo"}
                    component={LotesProducto}
                  />
                )}
                {this.props.permisoAccesoInventario &&
                  this.props.lotesCaducidades &&
                  this.props.taxidermia && (
                    <Route
                      path={this.props.match.url + "/archivosLotes"}
                      component={ArchivosLotes}
                    />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/agrupaciones"}
                    component={Agrupaciones}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/conteosCiclicos"}
                    component={ConteosCiclicos}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/agregarConteoCiclico"}
                    component={AgregarConteoCiclico}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/editarConteoCiclico"}
                    component={EditarConteoCiclico}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/conteos"}
                    component={Conteos}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/agregarConteo"}
                    component={AgregarConteo}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/detalleConteo/:id"}
                    component={DetalleConteo}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/verConteo/:id"}
                    component={VerConteo}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/verConfigConteo/:id"}
                    component={VerConfigConteo}
                  />
                )}
                {this.props.permisoAccesoInventario && (
                  <Route
                    path={this.props.match.url + "/ordenesDeConteo"}
                    component={OrdenesDeConteo}
                  />
                )}
                <Route
                  path={this.props.match.url + "/contarOrdenDeConteo/:id"}
                  component={ContarOrdenDeConteo}
                />
                <Route
                  path={this.props.match.url + "/verOrdenDeConteo/:id"}
                  component={VerOrdenDeConteo}
                />
                {this.props.permisoAccesoProduccion && (
                  <Route
                    path={this.props.match.url + "/produccion"}
                    component={Produccion}
                  />
                )}
                {this.props.permisoAccesoListaDeMateriales && (
                  <Route
                    path={this.props.match.url + "/listaDeMateriales"}
                    component={ListaDeMateriales}
                  />
                )}
                <Route
                  path={this.props.match.url + "/agregarOrdenDeProduccion"}
                  component={AgregarOrdenDeProduccion}
                />
                <Route
                  path={
                    this.props.match.url + "/agregarOrdenDeProduccionConLista"
                  }
                  component={AgregarOrdenDeProduccionConLista}
                />
                <Route
                  path={this.props.match.url + "/verOrdenDeProduccion"}
                  component={VerOrdenDeProduccion}
                />
                {this.props.preCotizacionIngenieria && (
                  <Route
                    exact
                    path={this.props.match.url + "/ordenesDeMaquila"}
                    component={OrdenesDeMaquila}
                  />
                )}
                {this.props.preCotizacionIngenieria && (
                  <Route
                    exact
                    path={this.props.match.url + "/vistaOrdenDeMaquila"}
                    component={VistaOrdenDeMaquila}
                  />
                )}
                <Route
                  path={this.props.match.url + "/agregarListaDeMateriales"}
                  component={AgregarListaDeMateriales}
                />
                <Route
                  path={this.props.match.url + "/editarListaDeMateriales"}
                  component={EditarListaDeMateriales}
                />
                {this.props.permisoAccesoTraspasoAlmacenes && (
                  <Route
                    path={this.props.match.url + "/traspasoEntreAlmacenes"}
                    component={TraspasoEntreAlmacenes}
                  />
                )}
                {this.props.permisoAccesoTraspasoAlmacenes && (
                  <Route
                    path={
                      this.props.match.url +
                      "/agregarOrdenDeTraspasoEntreAlmacenes"
                    }
                    component={AgregarTraspasoEntreAlmacenes}
                  />
                )}
                {this.props.permisoAccesoAgregarInventario && (
                  <Route
                    path={this.props.match.url + "/agregarInventario"}
                    component={AgregarInventario}
                  />
                )}
                <Route
                  path={this.props.match.url + "/agregarOrdenAgregarInventario"}
                  component={AgregarOrdenAgregarInventario}
                />
                <Route
                  path={this.props.match.url + "/verOrdenAgregarInventario"}
                  component={VerOrdenAgregarInventario}
                />
                <Route
                  path={this.props.match.url + "/editarOrdenAgregarInventario"}
                  component={EditarOrdenAgregarInventario}
                />
                {this.props.permisoAccesoProductosAlCosto && (
                  <Route
                    path={this.props.match.url + "/productosAlCosto"}
                    component={ProductosAlCosto}
                  />
                )}
                <Route
                  path={this.props.match.url + "/agregarOrdenProductosAlCosto"}
                  component={AgregarOrdenProductosAlCosto}
                />
                <Route
                  path={this.props.match.url + "/verOrdenProductosAlCosto"}
                  component={VerOrdenProductosAlCosto}
                />
                <Route
                  path={this.props.match.url + "/editarOrdenProductosAlCosto"}
                  component={EditarOrdenProductosAlCosto}
                />
                {this.props.permisoAccesoFamilias && (
                  <Route
                    path={this.props.match.url + "/familias"}
                    component={Familias}
                  />
                )}
                {this.props.moduloActivosFijos && this.props.permisoAlgunoActivosFijos && (
                  <Route
                    path={this.props.match.url + "/tiposDeActivo"}
                    component={TiposDeActivo}
                  />
                )}
                {this.props.moduloActivosFijos && this.props.permisoAlgunoActivosFijos && (
                  <Route
                    path={this.props.match.url + "/activosFijos"}
                    component={ActivosFijos}
                  />
                )}
                {this.props.permisoAccesoInventarioActivos && this.props.moduloActivosFijos && (
                  <Route
                    path={this.props.match.url + "/inventarioActivos"}
                    component={InventarioActivos}
                  />
                )}
                {this.props.permisoAccesoInventarioActivos && this.props.moduloActivosFijos && (
                  <Route
                    path={this.props.match.url + "/unidadesActivoFijo"}
                    component={UnidadesActivoFijo}
                  />
                )}
                {this.props.permisoAccesoMovimientosActivos && this.props.moduloActivosFijos && (
                  <Route
                    path={this.props.match.url + "/movimientosActivos"}
                    component={MovimientosActivos}
                  />
                )}
                {this.props.permisoAccesoDepreciaciones && this.props.moduloActivosFijos && (
                  <Route
                    path={this.props.match.url + "/correrDepreciacion"}
                    component={CorrerDepreciacion}
                  />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsActivos"} component={ActivosCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsFichaActivo"} component={FichaActivoCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsTiposActivo"} component={TiposActivoCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsConfiguracion"} component={ConfiguracionCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsImportarActivos"} component={ImportarActivosCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsServicios"} component={ServiciosCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsServicio"} component={ServicioCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsTickets"} component={TicketsCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsRutinas"} component={RutinasCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsContratos"} component={ContratosCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsContrato"} component={ContratoCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsImportarProgramaContrato"} component={ImportarProgramaContratoCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsAgenda"} component={AgendaCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsInicio"} component={InicioCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsViajes"} component={ViajesCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsReportes/:reporte"} component={ReporteCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route exact path={this.props.match.url + "/cmmsReportes"} component={ReportesCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsCertificados"} component={CertificadosCMMS} />
                )}
                {this.props.moduloCMMS && (
                  <Route path={this.props.match.url + "/cmmsPlantillaCertificado"} component={PlantillaCertificadoCMMS} />
                )}
                {this.props.permisoAccesoImpuestos && (
                  <Route
                    path={this.props.match.url + "/impuestos"}
                    component={Impuestos}
                  />
                )}
                {this.props.permisoAccesoRetenciones && (
                  <Route
                    path={this.props.match.url + "/retenciones"}
                    component={Retenciones}
                  />
                )}
                <Route
                  path={this.props.match.url + "/agregarRetencion"}
                  component={AgregarRetencion}
                />
                <Route
                  path={this.props.match.url + "/editarRetencion"}
                  component={EditarRetencion}
                />
                {this.props.permisoAccesoCargosAbonos && (
                  <Route
                    path={this.props.match.url + "/cargosabonos"}
                    component={CargosAbonos}
                  />
                )}
                {this.props.permisoAccesoReclasificacionCargosAbonos && (
                  <Route
                    path={this.props.match.url + "/reclasificacionCargosAbonos"}
                    component={ReclasificacionCargosAbonos}
                  />
                )}
                {this.props.permisoAccesoPolizas && (
                  <Route
                    path={this.props.match.url + "/polizas"}
                    component={Polizas}
                  />
                )}
                {this.props.permisoAccesoPolizas && (
                  <Route
                    path={this.props.match.url + "/importarPolizas"}
                    component={ImportarPolizas}
                  />
                )}
                {this.props.permisoAccesoPolizas && (
                  <Route
                    path={this.props.match.url + "/plantillasPolizas"}
                    component={PlantillasPolizas}
                  />
                )}
                <Route
                  path={this.props.match.url + "/agregarPlantillaPoliza"}
                  component={AgregarPlantillaPoliza}
                />
                <Route
                  path={this.props.match.url + "/editarPlantillaPoliza"}
                  component={EditarPlantillaPoliza}
                />
                <Route
                  path={this.props.match.url + "/presupuestos"}
                  component={Presupuestos}
                />
                <Route
                  path={this.props.match.url + "/subProyectos"}
                  component={SubProyectos}
                />
                <Route
                  path={this.props.match.url + "/agregarPresupuesto"}
                  component={AgregarPresupuesto}
                />
                <Route
                  path={this.props.match.url + "/editarPresupuesto"}
                  component={EditarPresupuesto}
                />
                <Route
                  path={this.props.match.url + "/verPolizasFactura"}
                  component={VerPolizasFactura}
                />
                <Route
                  path={this.props.match.url + "/verPoliza"}
                  component={VerPoliza}
                />
                {this.props.permisoAccesoCuentasContables && (
                  <Route
                    path={this.props.match.url + "/cuentascontables"}
                    component={CuentasContables}
                  />
                )}
                <Route
                  path={this.props.match.url + "/importarCuentasContables"}
                  component={ImportarCuentasContables}
                />
                <Route
                  path={this.props.match.url + "/descargaMasiva"}
                  component={DescargaMasiva}
                />
                {this.props.permisoAccesoTipoDePolizas && (
                  <Route
                    path={this.props.match.url + "/tipodepolizas"}
                    component={TiposDePolizas}
                  />
                )}
                {/* <Route
                  path={this.props.match.url + "/tipodeegresos"}
                  component={TiposDeEgresos}
                /> */}
                {this.props.permisoAccesoTipoDeFlujos && (
                  <Route
                    path={this.props.match.url + "/tipodeflujos"}
                    component={TiposDeFlujos}
                  />
                )}
                {this.props.permisoAccesoOrdenesDeCompra && (
                  <Route
                    path={this.props.match.url + "/ordenesdecompra"}
                    component={OrdenesDeCompras}
                  />
                )}
                <Route
                  path={this.props.match.url + "/requisiciones"}
                  component={Requisiciones}
                />
                <Route
                  path={this.props.match.url + "/sugerenciasRequisicion"}
                  component={SugerenciasRequisicion}
                />
                <Route
                  path={this.props.match.url + "/workBenchRequisiciones"}
                  component={WorkBenchRequisiciones}
                />
                <Route
                  path={this.props.match.url + "/agregarRequisicion"}
                  component={AgregarRequisicion}
                />
                <Route
                  path={this.props.match.url + "/editarRequisicion"}
                  component={EditarRequisicion}
                />
                <Route
                  path={this.props.match.url + "/verRequisicion"}
                  component={VerRequisicion}
                />
                <Route
                  path={this.props.match.url + "/mandarWorkBench"}
                  component={MandarWorkBench}
                />
                <Route
                  path={this.props.match.url + "/cotizacionesRequisicion"}
                  component={CotizacionesRequisicion}
                />
                <Route
                  path={
                    this.props.match.url + "/generarOrdenDeCompraConRequisicion"
                  }
                  component={GenerarOrdenDeCompra}
                />
                {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
                  <Route
                    path={this.props.match.url + "/facturassinordendecompra"}
                    component={FacturasSinOrdenDeCompra}
                  />
                )}
                {this.props.permisoAccesoRemisiones && (
                  <Route
                    path={this.props.match.url + "/remisiones"}
                    component={Remisiones}
                  />
                )}
                <Route
                  path={this.props.match.url + "/agregarRemision"}
                  component={AgregarRemision}
                />
                <Route
                  path={this.props.match.url + "/verRemision"}
                  component={VerRemision}
                />
                <Route
                  path={this.props.match.url + "/recibirInsumosRemision"}
                  component={RecibirInsumosRemision}
                />
                {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
                  <Route
                    path={this.props.match.url + "/facturas"}
                    component={Facturas}
                  />
                )}
                {this.props.permisoAccesoFacturasCajaChica && (
                  <Route
                    path={this.props.match.url + "/facturascajachica"}
                    component={FacturasCajaChica}
                  />
                )}
                {this.props.permisoAccesoComodato && (
                  <Route
                    path={this.props.match.url + "/comodato"}
                    component={Comodato}
                  />
                )}
                {this.props.permisoAccesoComodato && (
                  <Route
                    path={this.props.match.url + "/agregarOrdenComodato"}
                    component={AgregarOrdenComodato}
                  />
                )}
                {this.props.permisoAccesoComodato && (
                  <Route
                    path={this.props.match.url + "/verOrdenComodato"}
                    component={VerOrdenComodato}
                  />
                )}
                {this.props.permisoAccesoComodato && (
                  <Route
                    path={this.props.match.url + "/importarComodato"}
                    component={ImportarComodato}
                  />
                )}
                <Route
                  path={this.props.match.url + "/reponerCajaChica"}
                  component={ReponerCajaChica}
                />
                <Route
                  path={this.props.match.url + "/pagarCxpCajaChica"}
                  component={PagarCxpCajaChica}
                />
                <Route
                  path={this.props.match.url + "/traspasoEntreCuentas"}
                  component={TraspasoEntreCuentas}
                />
                {this.props.permisoAccesoFacturasSinOrdenDeCompra && (
                  <Route
                    path={this.props.match.url + "/remisionesCompra"}
                    component={RemisionesCompra}
                  />
                )}
                <Route
                  path={
                    this.props.match.url + "/agregarFacturaSinOrdenDeCompra"
                  }
                  component={AgregarFactura}
                />
                <Route
                  path={this.props.match.url + "/importarFacturasXmlMasivo"}
                  component={ImportarFacturasXmlMasivo}
                />
                <Route
                  path={this.props.match.url + "/importarGastosXml"}
                  component={ImportarGastosXml}
                />
                {/* Misma pantalla: la ruta es la que decide que se guarde en Caja Chica */}
                <Route
                  path={this.props.match.url + "/importarGastosXmlCajaChica"}
                  component={ImportarGastosXml}
                />
                <Route
                  path={this.props.match.url + "/verFacturaSinOrdenDeCompra"}
                  component={VerFacturaSinOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/agregarFacturaCajaChica"}
                  component={AgregarFacturaCajaChica}
                />
                <Route
                  path={this.props.match.url + "/verFacturaCajaChica"}
                  component={VerFacturaCajaChica}
                />
                <Route
                  path={this.props.match.url + "/recibirInsumosFactura"}
                  component={RecibirInsumosFactura}
                />
                <Route
                  path={this.props.match.url + "/prorratearFacturaSinOrdenDeCompra"}
                  component={ProrratearFactura}
                />
                <Route
                  path={this.props.match.url + "/prorratearOrdenDeCompra"}
                  component={ProrratearOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/prorrateos"}
                  component={Prorrateos}
                />
                <Route
                  path={this.props.match.url + "/verProrrateo"}
                  component={VerProrrateo}
                />
                <Route
                  path={this.props.match.url + "/entregarInsumosVenta"}
                  component={EntregarInsumosVenta}
                />
                <Route
                  path={this.props.match.url + "/requerirInsumosVenta"}
                  component={RequerirInsumosVenta}
                />
                <Route
                  path={this.props.match.url + "/requerirInsumosPedido"}
                  component={RequerirInsumosPedido}
                />
                <Route
                  path={this.props.match.url + "/apartarInsumosPedido"}
                  component={ApartarInsumosPedido}
                />
                <Route
                  path={this.props.match.url + "/entregarInsumosPedido"}
                  component={EntregarInsumosPedido}
                />
                <Route
                  path={this.props.match.url + "/apartarInsumosVenta"}
                  component={ApartarInsumosVenta}
                />
                <Route
                  path={this.props.match.url + "/costearVenta"}
                  component={CostearVenta}
                />
                <Route
                  path={this.props.match.url + "/generarFacturaVenta"}
                  component={GenerarFactura}
                />
                {this.props.permisoAccesoUnidadesDeNegocio && (
                  <Route
                    path={this.props.match.url + "/unidadesdenegocio"}
                    component={UnidadesDeNegocio}
                  />
                )}
                {this.props.permisoAccesoProyectos && (
                  <Route
                    path={this.props.match.url + "/proyectos"}
                    component={Proyectos}
                  />
                )}
                {this.props.permisoAccesoUbicaciones && this.props.moduloWms && (
                  <Route
                    path={this.props.match.url + "/ubicaciones"}
                    component={Ubicaciones}
                  />
                )}
                {this.props.permisoAgregarUbicacion && this.props.moduloWms && (
                  <Route
                    path={this.props.match.url + "/importarUbicaciones"}
                    component={ImportarUbicaciones}
                  />
                )}
                {this.props.permisoAccesoUbicaciones && this.props.moduloWms && (
                  <Route
                    path={this.props.match.url + "/mapa"}
                    component={MapaWms}
                  />
                )}
                {this.props.permisoAccesoUbicaciones && this.props.moduloWms && (
                  <Route
                    path={this.props.match.url + "/mapaAlmacenEditor"}
                    component={MapaAlmacenEditor}
                  />
                )}
                {this.props.permisoAccesoUbicaciones && this.props.moduloWms && (
                  <Route
                    path={this.props.match.url + "/acomodoRack"}
                    component={AcomodoRackPagina}
                  />
                )}
                {this.props.moduloHoteleria && (
                  <Route
                    path={this.props.match.url + "/mapaHotel"}
                    component={MapaHotel}
                  />
                )}
                {this.props.moduloHoteleria && (
                  <Route
                    path={this.props.match.url + "/mapaHotelEditor"}
                    component={MapaHotelEditor}
                  />
                )}
                {this.props.moduloHoteleria && (
                  <Route
                    path={this.props.match.url + "/ocupacionFuturoHotel"}
                    component={OcupacionFuturo}
                  />
                )}
                {this.props.moduloHoteleria && (
                  <Route
                    path={this.props.match.url + "/agendaHotel"}
                    component={AgendaHotel}
                  />
                )}
                {this.props.permisoAccesoProyectos && (
                  <Route
                    path={this.props.match.url + "/vehiculos"}
                    component={Vehiculos}
                  />
                )}
                {this.props.permisoRendimientoVehiculos && (
                  <Route
                    path={this.props.match.url + "/consumoCombustible"}
                    component={ConsumoCombustible}
                  />
                )}
                {this.props.permisoAccesoProyectos && (
                  <Route
                    path={this.props.match.url + "/polizasSeguro"}
                    component={PolizasSeguro}
                  />
                )}
                {this.props.permisoAccesoConfiguracion && (
                  <Route
                    path={this.props.match.url + "/configuracion"}
                    component={Configuracion}
                  />
                )}
                {this.props.permisoAccesoConfiguracion && (
                  <Route
                    path={this.props.match.url + "/configuracionecommerce"}
                    component={ConfiguracionEcommerce}
                  />
                )}
                {(this.props.whatsapp && this.props.permisoAccesoWhatsapp) && (
                  <Route
                    path={this.props.match.url + "/whatsapp"}
                    component={Whatsapp}
                  />
                )}
                <Route
                  path={this.props.match.url + "/configuracionclaude"}
                  component={ConfiguracionClaude}
                />
                <Route
                  path={this.props.match.url + "/agregarProveedor"}
                  component={AgregarProveedor}
                />
                <Route
                  path={this.props.match.url + "/editarProveedor"}
                  component={EditarProveedor}
                />
                <Route
                  path={this.props.match.url + "/agregarCliente"}
                  component={AgregarCliente}
                />
                <Route
                  path={this.props.match.url + "/editarCliente"}
                  component={EditarCliente}
                />
                <Route
                  path={this.props.match.url + "/edicionMasivaInsumosCliente"}
                  component={EdicionMasivaInsumosCliente}
                />
                <Route
                  path={this.props.match.url + "/capturaInsumosCliente"}
                  component={CapturaInsumosCliente}
                />
                <Route
                  path={this.props.match.url + "/agregarOrdenDeCompra"}
                  component={AgregarOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/editarOrdenDeCompra"}
                  component={EditarOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/verOrdenDeCompra"}
                  component={VerOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/insumosPendientesOrdenDeCompra"}
                  component={InsumosPendientesOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/verFacturaOrdenDeCompra"}
                  component={VerFacturaOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/recibirInsumosOrdenDeCompra"}
                  component={RecibirInsumos}
                />
                <Route
                  path={this.props.match.url + "/recibirFacturaOrdenDeCompra"}
                  component={RecibirFactura}
                />
                <Route
                  path={this.props.match.url + "/recibirFacturaOrdenesDeCompra"}
                  component={RecibirFacturaMultiple}
                />
                <Route
                  path={this.props.match.url + "/agregarInsumo"}
                  component={AgregarInsumo}
                />
                <Route
                  path={this.props.match.url + "/importarInsumos"}
                  component={ImportarInsumos}
                />
                <Route
                  path={this.props.match.url + "/subirImagenesInsumos"}
                  component={SubirImagenesInsumos}
                />
                <Route
                  path={this.props.match.url + "/subirFichasTecnicasInsumos"}
                  component={SubirFichasTecnicasInsumos}
                />
                <Route
                  path={this.props.match.url + "/edicionMasivaInsumos"}
                  component={EdicionMasivaInsumos}
                />
                <Route
                  path={this.props.match.url + "/edicionMasivaEquivalencias"}
                  component={EdicionMasivaEquivalencias}
                />
                <Route
                  path={this.props.match.url + "/edicionMasivaClientes"}
                  component={EdicionMasivaClientes}
                />
                <Route
                  path={this.props.match.url + "/edicionMasivaProveedores"}
                  component={EdicionMasivaProveedores}
                />
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/importarNivelesEducativos"}
                    component={ImportarNivelesEducativos}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/importarProgramasEducativos"}
                    component={ImportarProgramasEducativos}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/importarEscuelas"}
                    component={ImportarEscuelas}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/importarListas"}
                    component={ImportarListas}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/exportarListas"}
                    component={ExportarListas}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/importarGrupos"}
                    component={ImportarGrupos}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/importarAlumnos"}
                    component={ImportarAlumnos}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/importarVentasLibros"}
                    component={ImportarVentasLibros}
                  />
                )}
                {this.props.escuela && this.props.permisoAccesoEscuela && (
                  <Route
                    path={this.props.match.url + "/generarFichasPago"}
                    component={GenerarFichasPago}
                  />
                )}
                {/* Se entra desde la lista de Ventas, no desde Escuela, y tiene permiso
                    propio: no va con permisoAccesoEscuela como el resto de este bloque.

                    La ruta es "/importarLibrosDigitales" y NO "/importarVentasLibrosDigitales"
                    a proposito: estos <Route> no llevan `exact` y dentro de un Switch gana el
                    primero que haga match por PREFIJO, asi que "/importarVentasLibros" (de
                    arriba) se habria quedado con esta ruta y habria abierto la pantalla
                    equivocada. */}
                {this.props.escuela && this.props.permisoImportarVentasLibrosDigitales && (
                  <Route
                    path={this.props.match.url + "/importarLibrosDigitales"}
                    component={ImportarVentasLibrosDigitales}
                  />
                )}
                <Route
                  path={this.props.match.url + "/editarInsumo"}
                  component={EditarInsumo}
                />
                <Route
                  path={this.props.match.url + "/listasDePrecios"}
                  component={ListasDePrecios}
                />
                <Route
                  path={this.props.match.url + "/marcas"}
                  component={Marcas}
                />
                <Route
                  path={this.props.match.url + "/importarMarcas"}
                  component={ImportarMarcas}
                />
                <Route
                  path={this.props.match.url + "/unidades"}
                  component={Unidades}
                />
                <Route
                  path={this.props.match.url + "/importarUnidades"}
                  component={ImportarUnidades}
                />
                <Route
                  path={this.props.match.url + "/modificarPrecios"}
                  component={ModificarPrecios}
                />
                <Route
                  path={this.props.match.url + "/fijarPorcentajesPrecios"}
                  component={FijarPorcentajes}
                />
                <Route
                  path={this.props.match.url + "/analizarDiferenciasPrecios"}
                  component={AnalizarDiferenciasPrecios}
                />
                <Route
                  path={this.props.match.url + "/reglasListasDePrecios"}
                  component={ReglasListasDePrecios}
                />
                <Route
                  path={this.props.match.url + "/agregarInsumoCompuesto"}
                  component={AgregarInsumoCompuesto}
                />
                <Route
                  path={this.props.match.url + "/editarInsumoCompuesto"}
                  component={EditarInsumoCompuesto}
                />
                <Route
                  path={this.props.match.url + "/agregarServicio"}
                  component={AgregarServicio}
                />
                <Route
                  path={this.props.match.url + "/editarServicio"}
                  component={EditarServicio}
                />
                <Route
                  path={this.props.match.url + "/agregarTipoDeProveedor"}
                  component={AgregarTipoDeProveedor}
                />
                <Route
                  path={this.props.match.url + "/editarTipoDeProveedor"}
                  component={EditarTipoDeProveedor}
                />
                <Route
                  path={this.props.match.url + "/agregarTipoDeCliente"}
                  component={AgregarTipoDeCliente}
                />
                <Route
                  path={this.props.match.url + "/editarTipoDeCliente"}
                  component={EditarTipoDeCliente}
                />
                <Route
                  path={this.props.match.url + "/agregarImpuesto"}
                  component={AgregarImpuesto}
                />
                <Route
                  path={this.props.match.url + "/editarImpuesto"}
                  component={EditarImpuesto}
                />
                <Route
                  path={this.props.match.url + "/agregarNotaDeCredito"}
                  component={AgregarNotaDeCredito}
                />
                <Route
                  path={this.props.match.url + "/importarNotasDeCreditoXml"}
                  component={ImportarNotasDeCreditoXml}
                />
                <Route
                  path={this.props.match.url + "/verNotaDeCreditoCompra"}
                  component={VerNotaDeCredito}
                />
                <Route
                  path={this.props.match.url + "/agregarDevolucionCompra"}
                  component={AgregarDevolucionCompra}
                />
                <Route
                  path={this.props.match.url + "/soporte"}
                  component={Soporte}
                />
                {this.state.permisoSoporte && (
                  <Route
                    path={this.props.match.url + "/ticketsSoporte"}
                    component={TicketsSoporte}
                  />
                )}
                {/* Reporte entregable de soporte: solo el máster de la empresa. */}
                {this.props.tipoUsuario === 0 && (
                  <Route
                    path={this.props.match.url + "/reporteSoporte"}
                    component={ReporteSoporteEmpresa}
                  />
                )}
                <Route
                  path={this.props.match.url + "/verDevolucionCompra"}
                  component={VerDevolucionCompra}
                />
                <Route
                  path={this.props.match.url + "/tablas"}
                  component={Tablas}
                />
                <Route
                  path={this.props.match.url + "/tipoPrestaciones"}
                  component={TipoPrestaciones}
                />

                {this.props.permisoAccesoPrenomina && (
                  <Route
                    path={this.props.match.url + "/preNomina"}
                    component={PreNomina}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoCreditosMovimientos && (
                  <Route
                    path={this.props.match.url + "/creditosMovimientos"}
                    component={CreditosMovimientos}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoRecibos && (
                  <Route
                    path={this.props.match.url + "/recibos"}
                    component={Recibos}
                  />
                )}

                {/* Las rutas hijas van ANTES de la del hub, que es `exact`:
                    con react-router v5 el orden manda dentro de un Switch. */}
                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/repse"}
                    component={ReporteRepse}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/xmlEmitidos"}
                    component={ReporteXmlEmitidos}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/listaRaya"}
                    component={ReporteListaRaya}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/comparativoPeriodos"}
                    component={ReporteComparativoPeriodos}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/acumulados"}
                    component={ReporteAcumulados}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/layoutEmpleados"}
                    component={ReporteLayoutEmpleados}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/personal"}
                    component={ReportePersonal}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/percepcionesPorPeriodo"}
                    component={ReportePercepcionesPorPeriodo}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    path={this.props.match.url + "/reportesNomina/incidencias"}
                    component={ReporteIncidencias}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoReportesNomina && (
                  <Route
                    exact
                    path={this.props.match.url + "/reportesNomina"}
                    component={ReportesNomina}
                  />
                )}

                {this.props.nomina && (
                  <Route
                    path={this.props.match.url + "/generarAguinaldo"}
                    component={GenerarAguinaldo}
                  />
                )}

                {this.props.nomina && this.props.permisoAccesoConfiguracionNomina && (
                  <Route
                    path={this.props.match.url + "/configuracionNomina"}
                    component={ConfiguracionNomina}
                  />
                )}

                {this.props.permisoAccesoVacaciones && (
                  <Route
                    path={this.props.match.url + "/vacaciones"}
                    component={Vacaciones}
                  />
                )}

                {this.props.permisoAccesoReporteVentasGenerales && (
                  <Route
                    path={this.props.match.url + "/reporteVentasGenerales"}
                    component={ReporteVentas}
                  />
                )}
                {this.props.permisoAccesoReporteVentasGenerales && (
                  <Route
                    path={this.props.match.url + "/reporteNotasDeCreditoVenta"}
                    component={ReporteNotasDeCreditoVenta}
                  />
                )}
                {this.props.permisoAccesoReporteVentasGenerales && (
                  <Route
                    path={this.props.match.url + "/reporteVentasFiscales"}
                    component={ReporteVentasFiscales}
                  />
                )}
                {this.props.permisoAccesoReporteInsumosMasVendidos && (
                  <Route
                    path={this.props.match.url + "/reporteInsumosMasVendidos"}
                    component={ReporteInsumosMasVendidos}
                  />
                )}
                {this.props.permisoAccesoReporteMargenVentas && (
                  <Route
                    path={this.props.match.url + "/reporteMargenDeVentas"}
                    component={ReporteMargenVentas}
                  />
                )}
                {this.props.permisoAccesoReporteVentasPorLote && (
                  <Route
                    path={this.props.match.url + "/reporteVentasPorLote"}
                    component={ReporteVentasPorLote}
                  />
                )}
                {this.props.permisoAccesoReporteCotizacionVsVentas && (
                  <Route
                    path={this.props.match.url + "/reporteCotizacionVsVentas"}
                    component={ReporteCotizacionVsVentas}
                  />
                )}
                {this.props.permisoAccesoReportePedidoVsVentas && (
                  <Route
                    path={this.props.match.url + "/reportePedidoVsVentas"}
                    component={ReportePedidoVsVentas}
                  />
                )}
                {this.props.permisoAccesoReporteVentasGenerales && (
                  <Route
                    path={this.props.match.url + "/reportePedidos"}
                    component={ReportePedidos}
                  />
                )}
                {this.props.permisoAccesoReporteVentasGenerales && (
                  <Route
                    path={this.props.match.url + "/reporteCotizaciones"}
                    component={ReporteCotizaciones}
                  />
                )}
                <Route
                  path={this.props.match.url + "/reporteDIOT"}
                  component={ReporteDIOT}
                />
                <Route
                  path={this.props.match.url + "/reporteIVA"}
                  component={ReporteIVA}
                />
                <Route
                  path={this.props.match.url + "/reporteRetencionesDeCompras"}
                  component={ReporteRetencionesCompras}
                />
                <Route
                  path={this.props.match.url + "/reporteRetencionesDeVentas"}
                  component={ReporteRetencionesVentas}
                />
                <Route
                  path={this.props.match.url + "/reporteConciliacionFacturasPagos"}
                  component={ReporteConciliacionFacturasPagos}
                />
                <Route
                  path={this.props.match.url + "/reporteFacturasGlobales"}
                  component={ReporteFacturasGlobales}
                />
                <Route
                  path={this.props.match.url + "/reporteXml"}
                  component={ReporteXml}
                />
                {this.props.permisoAccesoReporteComprasGenerales && (
                  <Route
                    path={this.props.match.url + "/reporteComprasGenerales"}
                    component={ReporteCompras}
                  />
                )}
                <Route
                  path={this.props.match.url + "/ReporteOrdenesDeCompra"}
                  component={ReporteOrdenesDeCompra}
                />
                <Route
                  path={this.props.match.url + "/reporteRecepcionesOrdenDeCompra"}
                  component={ReporteRecepcionesOrdenDeCompra}
                />
                <Route
                  path={this.props.match.url + "/ReporteRequisiciones"}
                  component={ReporteRequisiciones}
                />
                {this.props.permisoAccesoReporteEmpleados && (
                  <Route
                    path={this.props.match.url + "/reporteEmpleados"}
                    component={ReporteEmpleados}
                  />
                )}
                {this.props.permisoAccesoReporteRegistroEmpleados && (
                  <Route
                    path={this.props.match.url + "/reporteRegistroEmpleados"}
                    component={ReporteRegistroEmpleados}
                  />
                )}
                {this.props.permisoAccesoReporteInsumosMasComprados && (
                  <Route
                    path={this.props.match.url + "/reporteInsumosMasComprados"}
                    component={ReporteInsumosMasComprados}
                  />
                )}
                <Route
                  path={this.props.match.url + "/reporteTraspasoEntreAlmacenes"}
                  component={ReporteTraspasoEntreAlmacenes}
                />
                {this.props.permisoAccesoReporteComprasGenerales && (
                  <Route
                    path={this.props.match.url + "/reporteComprasGenerales2"}
                    component={ReporteCompras2}
                  />
                )}
                {this.props.permisoAccesoReporteCostosInternos && (
                  <Route
                    path={this.props.match.url + "/reporteCostosInternos"}
                    component={ReporteCostosInternos}
                  />
                )}
                {this.props.permisoAccesoReporteCostosInternos && (
                  <Route
                    path={this.props.match.url + "/reporteConciliacionCostosInternos"}
                    component={ReporteConciliacionCostosInternos}
                  />
                )}
                {this.props.permisoAccesoReporteComodatos && (
                  <Route
                    path={this.props.match.url + "/reporteComodatos"}
                    component={ReporteComodatos}
                  />
                )}
                {this.props.permisoAccesoReporteNotasDeCreditoCompra && (
                  <Route
                    path={this.props.match.url + "/reporteNotasDeCreditoCompra"}
                    component={ReporteNotasDeCreditoCompra}
                  />
                )}
                {this.props.permisoAccesoReporteInsumosYProveedores && (
                  <Route
                    path={this.props.match.url + "/reporteInsumosYProveedores"}
                    component={ReporteInsumosYProveedores}
                  />
                )}
                {this.props.permisoAccesoReporteInventarioTotal && (
                  <Route
                    path={this.props.match.url + "/reporteInventarioTotal"}
                    component={ReporteInventario}
                  />
                )}
                {this.props.permisoAccesoReporteCostoInventario && (
                  <Route
                    path={this.props.match.url + "/reporteCostoInventario"}
                    component={ReporteCostoInventario}
                  />
                )}
                {this.props.permisoAccesoReporteCostoVsUltimaCompra && (
                  <Route
                    path={this.props.match.url + "/reporteCostoVsUltimaCompra"}
                    component={ReporteCostoVsUltimaCompra}
                  />
                )}
                {this.props.permisoAccesoReporteCostosPorInsumo && (
                  <Route
                    path={this.props.match.url + "/reporteCostosPorInsumo"}
                    component={ReporteCostosPorInsumo}
                  />
                )}
                {this.props.permisoAccesoReporteInsumosYEquivalencias && (
                  <Route
                    path={this.props.match.url + "/reporteInsumosYEquivalencias"}
                    component={ReporteInsumosYEquivalencias}
                  />
                )}
                {this.props.permisoAccesoReporteLotes && (
                  <Route
                    path={this.props.match.url + "/reporteLotes"}
                    component={ReporteLotes}
                  />
                )}
                {this.props.permisoAccesoReporteCuentasPorCobrar && (
                  <Route
                    path={this.props.match.url + "/reporteCuentasPorCobrar"}
                    component={ReporteCuentasPorCobrar}
                  />
                )}
                {this.props.permisoAccesoReporteCuentasPorCobrar && (
                  <Route
                    path={
                      this.props.match.url + "/reporteCuentasPorCobrarAgrupado"
                    }
                    component={ReporteCuentasPorCobrarAgrupado}
                  />
                )}
                <Route
                  path={
                    this.props.match.url + "/reporteCuentasPorPagarAgrupado"
                  }
                  component={ReporteCuentasPorPagarAgrupado}
                />
                {this.props.permisoAccesoReporteCuentasPorCobrar && (
                  <Route
                    path={this.props.match.url + "/reporteCuentasCliente"}
                    component={ReporteEstadoCuentaCliente}
                  />
                )}
                <Route
                  path={this.props.match.url + "/reporteCostoTotalProyecto"}
                  component={ReporteCostoTotalProyecto}
                />
                <Route
                  path={this.props.match.url + "/reporteFacturacion/integracionClientes"}
                  component={ReporteIntegracionClientes}
                />
                <Route
                  path={this.props.match.url + "/reporteFacturacion/consecutivo"}
                  component={ReporteConsecutivoFacturacion}
                />
                <Route
                  exact
                  path={this.props.match.url + "/reporteFacturacion"}
                  component={ReporteFacturacion}
                />
                {this.props.escuela && (
                  <Route
                    path={this.props.match.url + "/reporteAlumnosYVentas"}
                    component={ReporteAlumnosYVentas}
                  />
                )}
                {this.props.escuela && (
                  <Route
                    path={this.props.match.url + "/reporteReferenciasDePago"}
                    component={ReporteReferenciasPago}
                  />
                )}
                {this.props.permisoAccesoReporteCuentasPorPagar && (
                  <Route
                    path={this.props.match.url + "/reporteCuentasPorPagar"}
                    component={ReporteCuentasPorPagar}
                  />
                )}
                {this.props.permisoAccesoReporteEstadoDePosicionFinanciera && (
                  <Route
                    path={
                      this.props.match.url +
                      "/reporteEstadoDePosicionFinanciera"
                    }
                    component={ReporteEstadoDePosicionFinanciera}
                  />
                )}
                {this.props.permisoAccesoReporteEstadoDeResultadosPorPeriodo && (
                  <Route
                    path={
                      this.props.match.url + "/reporteEstadoDeResultadosPorPeriodo"
                    }
                    component={ReporteEstadoDeResultadosPorPeriodo}
                  />
                )}
                {this.props.permisoAccesoReporteEstadoDeResultados && (
                  <Route
                    path={this.props.match.url + "/reporteEstadoDeResultados"}
                    component={ReporteEstadoDeResultados}
                  />
                )}
                {this.props.permisoAccesoReporteEstadoDeCuenta && (
                  <Route
                    path={this.props.match.url + "/reporteEstadoDeCuenta"}
                    component={ReporteEstadoDeCuenta}
                  />
                )}
                {this.props.permisoAccesoReporteBalanzaDeComprabacion && (
                  <Route
                    path={
                      this.props.match.url + "/reporteBalanzaDeComprobacion"
                    }
                    component={ReporteBalanzaDeComprobacion}
                  />
                )}
                {this.props.permisoAccesoReporteBalanzaDeComprabacion && (
                  <Route
                    path={
                      this.props.match.url + "/reporteBalanzaDeComprobacionContabilidadElectronica"
                    }
                    component={ReporteBalanzaDeComprobacionContabilidadElectronica}
                  />
                )}
                {this.props.permisoAccesoReporteFlujoDeEfectivo && (
                  <Route
                    path={this.props.match.url + "/reporteFlujoDeEfectivo"}
                    component={ReporteFlujoDeEfectivo}
                  />
                )}
                {this.props.permisoAccesoReporteFlujoDeEfectivo && (
                  <Route
                    path={
                      this.props.match.url +
                      "/reporteFlujoDeEfectivoPresupuestado"
                    }
                    component={ReporteFlujoDeEfectivoPresupuestado}
                  />
                )}
                {this.props.permisoAccesoReporteFlujoDeTesorefia && (
                  <Route
                    path={this.props.match.url + "/reporteFlujoDeTesorefia"}
                    component={ReporteFlujoDeTesorefia}
                  />
                )}
                {this.props.permisoAccesoReporteFlujoDeEfectivoDiario && (
                  <Route
                    path={this.props.match.url + "/reporteFlujoDeEfectivoDiario"}
                    component={ReporteFlujoDeEfectivoDiario}
                  />
                )}
                <Route
                  path={this.props.match.url + "/reporteLibroDiario"}
                  component={ReporteLibroDiario}
                />
                <Route
                  path={this.props.match.url + "/reporteLibroMayor"}
                  component={ReporteLibroMayor}
                />
                <Route
                  path={this.props.match.url + "/reportePresupuestos"}
                  component={ReportePresupuestos}
                />
                <Route
                  path={this.props.match.url + "/reportePagos"}
                  component={ReportePagos}
                />
                <Route
                  path={this.props.match.url + "/reporteCobranzaPorSemana/realizada"}
                  component={ReporteCobranzaRealizada}
                />
                <Route
                  path={this.props.match.url + "/reporteCobranzaPorSemana/proyectada"}
                  component={ReporteCobranzaProyectada}
                />
                <Route
                  path={this.props.match.url + "/reporteCobranzaPorSemana/comparativo"}
                  component={ReporteCobranzaProyectadoVsReal}
                />
                <Route
                  exact
                  path={this.props.match.url + "/reporteCobranzaPorSemana"}
                  component={ReporteCobranzaPorSemana}
                />
                <Route
                  path={this.props.match.url + "/reporteInsumosPendientes/ventasPendientesEntregar"}
                  component={ReporteVentasPendientesEntregar}
                />
                <Route
                  path={this.props.match.url + "/reporteInsumosPendientes/pedidosPendientesApartar"}
                  component={ReportePedidosPendientesApartar}
                />
                <Route
                  exact
                  path={this.props.match.url + "/reporteInsumosPendientes"}
                  component={ReporteInsumosPendientes}
                />
                <Route
                  path={this.props.match.url + "/reportePagosAProveedores"}
                  component={ReportePagosAProveedores}
                />
                <Route
                  path={this.props.match.url + "/reporteReposicionCajaChica"}
                  component={ReporteReposicionCajaChica}
                />
                <Route
                  path={this.props.match.url + "/reporteIngresos"}
                  component={ReporteIngresos}
                />
                <Route
                  path={this.props.match.url + "/reporteCostoProduccion"}
                  component={ReporteCostoProduccion}
                />
                <Route
                  path={this.props.match.url + "/reporteActividadEtapas"}
                  component={ReporteActividadEtapas}
                />
                <Route
                  path={
                    this.props.match.url + "/reporteResumenEntradasYSalidas"
                  }
                  component={ReporteResumenEntradasSalidas}
                />
                <Route
                  path={this.props.match.url + "/reporteEntradasSalidas"}
                  component={ReporteEntradasSalidas}
                />
                <Route
                  path={this.props.match.url + "/reporteEntradasSalidasDetallado"}
                  component={ReporteEntradasSalidasDetallado}
                />
                <Route
                  path={this.props.match.url + "/reporteInsumosNoInventariables"}
                  component={ReporteInsumosNoInventariables}
                />
                {this.props.permisoAccesoReportes ? (
                  <Route
                    path={this.props.match.url + "/reportes"}
                    component={Reportes}
                  />
                ) : null}
                {this.props.permisoAccesoReporteCreadorDeReportes ? (
                  <Route
                    path={this.props.match.url + "/creadorDeReportes"}
                    component={CreadorDeReportes}
                  />
                ) : null}
                {this.props.permisoVerBitacora ? (
                  <Route
                    path={this.props.match.url + "/bitacora"}
                    component={Bitacora}
                  />
                ) : null
                }
                {this.props.autorizacionesRapidas && (
                  <Route
                    path={this.props.match.url + "/autorizaciones"}
                    component={Autorizaciones}
                  />
                )}
                {this.props.permisoVerBitacora ? (
                  <Route
                    path={this.props.match.url + "/historialCorreos"}
                    component={HistorialCorreos}
                  />
                ) : null
                }

                {this.props.certificadaDM &&
                  this.props.permisoAccesoArchivosXML ? (
                  <Route
                    path={this.props.match.url + "/archivosXml"}
                    component={ArchivosXml}
                  />
                ) : null}
                {this.props.envios && (
                  <Route
                    path={this.props.match.url + "/generarEnvioVenta"}
                    component={GenerarEnvio}
                  />
                )}
                <Route
                  path={this.props.match.url + "/reporteTaxidermia"}
                  component={ReporteTaxidermia}
                />
                {/* {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/RegistroDeLotes"}
                    component={RegistroDeLotes}
                  />
                }
                {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/CorteDePiñas"}
                    component={CorteDePiñas}
                  />
                }
                {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/Horneado"}
                    component={Horneado}
                  />
                }
                {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/Fermentacion"}
                    component={Fermentacion}
                  />
                }
                {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/PrimeraDestilacion"}
                    component={PrimeraDestilacion}
                  />
                }
                {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/SegundaDestilacion"}
                    component={SegundaDestilacion}
                  />
                }
                {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/TerceraDestilacion"}
                    component={TerceraDestilacion}
                  />
                }
                {this.props.envios &&
                  <Route
                    path={this.props.match.url + "/TanquesLlenado"}
                    component={TanquesLlenado}
                  />
                } */}
                {this.props.permisoAccesoDepartamentos && (
                  <Route
                    path={this.props.match.url + "/departamentos"}
                    component={Departamentos}
                  />
                )}
                {this.props.permisoAccesoPuestos && (
                  <Route
                    path={this.props.match.url + "/puestos"}
                    component={Puestos}
                  />
                )}
                <Route
                  path={this.props.match.url + "/turnos"}
                  component={Turnos}
                />
                {this.props.envios && (
                  <Route
                    path={this.props.match.url + "/tiposAcumulados"}
                    component={TiposAcumulados}
                  />
                )}
                {this.props.envios && (
                  <Route
                    path={this.props.match.url + "/tiposIncidencias"}
                    component={TiposIncidencias}
                  />
                )}
                {this.props.envios && (
                  <Route
                    path={this.props.match.url + "/tiposPeriodos"}
                    component={TipoPeriodo}
                  />
                )}
                {this.props.envios && (
                  <Route
                    path={this.props.match.url + "/conceptos"}
                    component={Conceptos}
                  />
                )}
                {this.props.envios && (
                  <Route
                    path={this.props.match.url + "/registroPatronal"}
                    component={RegistroPatronal}
                  />
                )}
                <Route
                  path={this.props.match.url + "/periodos"}
                  component={Periodos}
                />
                <Route
                  path={this.props.match.url + "/verEnvio"}
                  component={VerEnvio}
                />
                <Route
                  path={this.props.match.url + "/verPagosCajaChica"}
                  component={VerPagosCajaChica}
                />
                <Route
                  path={this.props.match.url + "/matrices"}
                  component={Matrices}
                />
                {this.props.permisoAgregarMatriz && (
                  <Route
                    path={this.props.match.url + "/agregarMatriz"}
                    component={MatrizForm}
                  />
                )}
                {this.props.permisoAgregarMatriz && (
                  <Route
                    path={this.props.match.url + "/importarMatrices"}
                    component={ImportarMatrices}
                  />
                )}
                <Route
                  path={this.props.match.url + "/editarMatriz"}
                  component={MatrizForm}
                />
                <Route
                  path={this.props.match.url + "/presupuestosPU"}
                  component={PresupuestosPU}
                />
                <Route
                  path={this.props.match.url + "/presupuestoPU"}
                  component={PresupuestoPU}
                />
                {(this.props.permisoAccesoPreciosUnitarios || this.props.permisoAccesoOrdenesProduccionPU) && (
                  <Route
                    path={this.props.match.url + "/ordenesDeProduccion"}
                    component={OrdenesDeProduccionPU}
                  />
                )}
                <Route
                  path={this.props.match.url + "/configuracionOrdenesDeProduccionPU"}
                  component={ConfiguracionOrdenesDeProduccionPU}
                />
                {(this.props.permisoAccesoPreciosUnitarios || this.props.permisoAccesoOrdenesProduccionPU) && (
                  <Route
                    path={this.props.match.url + "/verOrdenDeProduccionPU"}
                    component={VistaOrdenDeProduccionPU}
                  />
                )}
                {(this.props.permisoAccesoPreciosUnitarios || this.props.permisoAccesoOrdenesProduccionPU) && (
                  <Route
                    path={this.props.match.url + "/ordenDeProduccionPU"}
                    component={OrdenDeProduccionPU}
                  />
                )}
                <Route
                  path={this.props.match.url + "/facturaGlobal"}
                  component={FacturaGlobal}
                />
                <Route
                  path={this.props.match.url + "/facturarVariasRemisiones"}
                  component={FacturarVariasRemisiones}
                />
                <Route
                  path={this.props.match.url + "/consignaciones"}
                  component={Consignaciones}
                />
                {this.props.permisoAgregarConsignacion && (
                  <Route
                    path={this.props.match.url + "/agregarConsignacion"}
                    component={AgregarConsignacion}
                  />
                )}
                <Route
                  path={this.props.match.url + "/verConsignacion"}
                  component={VerConsignacion}
                />
                <Route
                  path={this.props.match.url + "/inventarioConsignaciones"}
                  component={InventarioConsignaciones}
                />
                <Route
                  path={this.props.match.url + "/ventasConsignacion"}
                  component={VentasConsignacion}
                />
                <Route
                  path={this.props.match.url + "/agregarVentaConsignacion"}
                  component={AgregarVentaConsignacion}
                />
                <Route
                  path={this.props.match.url + "/verVentaConsignacion"}
                  component={VerVentaConsignacion}
                />
                <Route
                  path={this.props.match.url + "/facturaGlobalConsignacion"}
                  component={FacturaGlobalConsignacion}
                />
                <Route
                  path={
                    this.props.match.url + "/entregarInsumosVentaConsignacion"
                  }
                  component={EntregarInsumosVentaConsignacion}
                />
                <Route
                  path={
                    this.props.match.url + "/generarFacturaVentaConsignacion"
                  }
                  component={GenerarFacturaConsignacion}
                />
                {this.props.permisoDarBajaConsignacion && (
                  <Route
                    path={this.props.match.url + "/bajasConsignaciones"}
                    component={BajasConsignaciones}
                  />
                )}
                {this.props.permisoDarBajaConsignacion && (
                  <Route
                    path={this.props.match.url + "/agregarBajaConsignacion"}
                    component={BajaConsignacion}
                  />
                )}
                <Route
                  path={this.props.match.url + "/bajasConsignaciones"}
                  component={BajasConsignaciones}
                />
                <Route
                  path={this.props.match.url + "/agregarBajaConsignacion"}
                  component={BajaConsignacion}
                />
                <Route
                  path={this.props.match.url + "/remolques"}
                  component={Remolques}
                />
                {/* <Route
                  path={this.props.match.url + "/agregarTipoDeEgreso"}
                  component={AgregarTipoDeEgreso}
                /> */}
                <Route
                  path={this.props.match.url + "/tiposDeInsumos"}
                  component={TiposDeInsumos}
                />
                <Route
                  path={this.props.match.url + "/importarTiposDeInsumo"}
                  component={ImportarTiposDeInsumo}
                />
                <Route
                  path={this.props.match.url + "/regularizarInventarioVentas"}
                  component={RegularizarInventarioVentas}
                />
                <Route
                  path={this.props.match.url + "/agregarNotaDeCreditoVenta"}
                  component={AgregarNotaDeCreditoVenta}
                />
                <Route
                  path={this.props.match.url + "/agregarNotaDeCreditoVentaGeneral"}
                  component={AgregarNotaDeCreditoVentaGeneral}
                />
                <Route
                  path={this.props.match.url + "/verNotaDeCreditoVenta"}
                  component={VerNotaDeCreditoVenta}
                />
                <Route
                  path={this.props.match.url + "/agregarDevolucion"}
                  component={AgregarDevolucion}
                />
                <Route
                  path={this.props.match.url + "/verDevolucion"}
                  component={VerDevolucion}
                />
                <Route
                  path={this.props.match.url + "/remolques"}
                  component={Remolques}
                />
                <Route
                  path={this.props.match.url + "/intangibles"}
                  component={Indirectos}
                />
                <Route
                  path={this.props.match.url + "/agregarIntangible"}
                  component={AgregarIndirecto}
                />
                <Route
                  path={this.props.match.url + "/editarIntangible"}
                  component={EditarIndirecto}
                />
                <Route
                  path={this.props.match.url + "/doctores"}
                  component={Doctores}
                />
                <Route
                  path={this.props.match.url + "/pacientes"}
                  component={Pacientes}
                />
                <Route
                  path={this.props.match.url + "/cirugias"}
                  component={Cirugias}
                />
                <Route
                  path={this.props.match.url + "/emergencias"}
                  component={Emergencias}
                />
                <Route
                  path={this.props.match.url + "/llenarFormulario"}
                  component={LlenarFormulario}
                />
                <Route
                  path={this.props.match.url + "/editarFormulario"}
                  component={EditarFormulario}
                />
                <Route
                  path={this.props.match.url + "/cajas"}
                  component={Cajas}
                />
                <Route
                  path={this.props.match.url + "/sesiones"}
                  component={Sesiones}
                />
                <Route
                  path={this.props.match.url + "/verSesion/:id"}
                  component={VerSesion}
                />
                {this.props.moduloCalidad && this.props.permisoAccesoCalidad && (
                  <Route
                    path={this.props.match.url + "/calidad"}
                    component={Calidad}
                  />
                )}
                {this.props.moduloCalidad && this.props.permisoAccesoCalidad && (
                  <Route
                    path={this.props.match.url + "/reporteCalidad"}
                    component={ReporteCalidad}
                  />
                )}
                <Route
                  path={this.props.match.url + "/programa"}
                  component={VistaPrograma}
                />
                <Route
                  path={this.props.match.url + "/proceso"}
                  component={VistaProceso}
                />
                <Route>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "60vh" }}>
                    <SearchOutlined style={{ fontSize: 48, color: "#8c8c8c" }} />
                    <span style={{ fontSize: 22, marginTop: 16, color: "#595959", fontWeight: 600 }}>Ups, no hemos encontrado nada</span>
                    <span style={{ fontSize: 15, marginTop: 8, color: "#8c8c8c" }}>Selecciona una opción en el menú para navegar</span>
                  </div>
                </Route>
              </Switch>
            </Content>
            {/* <Footer style={{ textAlign: "center" }}>Biwo ©2026</Footer> */}
          </Layout>
        </Layout>
        {!this.state.isMobile &&
          this.props.whatsapp &&
          this.props.permisoAccesoWhatsapp &&
          !this.props.history.location.pathname.endsWith("/whatsapp") && (
          <BurbujaWhatsappGlobal
            headersToken={this.props.headersToken}
            empresaId={this.props.empresaId}
            permisoElementosWhatsapp={this.props.permisoElementosWhatsapp}
            permisoGuardarImagenInsumo={this.props.permisoGuardarImagenInsumo}
            permisoMensajeMasivo={this.props.permisoMensajeMasivo}
            abierto={this.state.whatsappBurbujaAbierta}
            onAbrir={() => this.setState({ whatsappBurbujaAbierta: true })}
            onCerrar={() => this.setState({ whatsappBurbujaAbierta: false })}
            onAbrirVistaCompleta={() => {
              this.setState({ whatsappBurbujaAbierta: false });
              this.props.history.push(this.props.match.url + "/whatsapp");
            }}
          />
        )}
        {this.mostrarBotonSoporte() && (
          <BurbujaSoporteGlobal
            headersToken={this.props.headersToken}
            usuarioId={this.props.usuarioId}
            esMaster={this.props.tipoUsuario === 0}
            puedeRevisar={this.state.puedeRevisarSoporte}
            abierto={this.state.soporteBurbujaAbierta}
            onCerrar={() => this.setState({ soporteBurbujaAbierta: false })}
            onNoLeidos={this.actualizarNoLeidosSoporte}
            onAbrirVistaCompleta={(ticketId) => {
              this.setState({ soporteBurbujaAbierta: false });
              this.props.history.push(this.props.match.url + "/ticketsSoporte", { ticketId });
            }}
          />
        )}
        <ModalSubidosSoporte
          visible={this.state.soporteSubidos.length > 0}
          tickets={this.state.soporteSubidos}
          onCerrar={this.cerrarModalSubidosSoporte}
          onResponder={this.responderSubidoSoporte}
          respondiendoId={this.state.soporteRespondiendoId}
          onVerReportes={() => {
            this.cerrarModalSubidosSoporte();
            this.props.history.push(this.props.match.url + "/ticketsSoporte");
          }}
        />
        <ModalPolizasDocumento
          visible={!!this.state.polizasMovimientoIds}
          polizasId={this.state.polizasMovimientoIds}
          titulo="Pólizas del Movimiento"
          onCancel={() => this.setState({ polizasMovimientoIds: null })}
        />
        <Drawer
          title="Notificaciones"
          placement="right"
          rootClassName="ant-drawer-right"
          closable
          onClose={() => this.abrirNotificaciones(false)}
          open={this.state.openNotificaciones}
          destroyOnClose
          width={Math.min(400, window.innerWidth - 10)}
        >
          <Tabs5
            activeKey={this.state.tabActiva}
            onChange={this.cambiarTab}
            items={[
              {
                key: 'notificaciones',
                label: (
                  <span>
                    Notificaciones
                    {this.state.unreadCount > 0 && (
                      <Badge
                        count={this.state.unreadCount}
                        style={{ marginLeft: 8 }}
                      />
                    )}
                  </span>
                ),
                children: (
                  <Spin spinning={this.state.loading}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: 16,
                      }}
                    >
                      <Button type="link" onClick={this.onMarkAllAsRead}>
                        Marcar todas como leídas
                      </Button>
                    </div>
                    <List
                      dataSource={this.state.notifications}
                      locale={{ emptyText: 'Ups, no hemos encontrado nada' }}
                      renderItem={(item) => (
                        <List.Item
                          style={{
                            padding: "10px 0",
                            cursor: "pointer",
                            backgroundColor: item.read
                              ? undefined
                              : "rgba(24, 144, 255, 0.1)",
                            borderBottom: "1px solid rgba(13, 71, 126, 0.25)",
                          }}
                          onClick={() => {
                            if (!item.read) {
                              this.noLeidasaLeidas(item.id);
                            }
                            this.onMarkAsRead(item.id, item.ruta, item.estadoRuta);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ marginRight: 15, marginLeft: 10, fontSize: 17 }}
                            >
                              {item.icon}
                            </div>
                            <div style={{ width: "100%", paddingRight: 10 }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <span style={{ fontWeight: "bold" }}>{item.title}</span>
                                <span style={{ fontSize: "12px", color: "#888" }}>
                                  {item.fecha}
                                </span>
                              </div>
                              <div
                                style={{ fontWeight: item.read ? "normal" : "bold" }}
                              >
                                {item.message}
                              </div>
                            </div>
                          </div>
                        </List.Item>
                      )}
                    />
                    <div style={{ textAlign: "center", marginTop: 16 }}>
                      {this.state.button && (
                        <ButtonItem
                          type="primary"
                          block
                          blanco
                          loading={this.state.loadingTodas}
                          onClick={() => {
                            this.consultaTodasNotificaciones();
                          }}
                        >
                          Mostrar todas
                        </ButtonItem>
                      )}
                    </div>
                  </Spin>
                ),
              },
              {
                key: 'movimientos',
                label: (
                  <span>
                    Movimientos
                    {this.state.unreadMovimientosCount > 0 && (
                      <Badge
                        count={this.state.unreadMovimientosCount}
                        style={{ marginLeft: 8 }}
                      />
                    )}
                  </span>
                ),
                children: (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: 16,
                      }}
                    >
                      <Button type="link" onClick={this.marcarTodosMovimientosComoLeidos}>
                        Marcar todos como leídos
                      </Button>
                    </div>
                    <List
                      dataSource={this.state.movimientos}
                      locale={{ emptyText: 'No hay movimientos registrados' }}
                      renderItem={(item) => (
                        <List.Item
                          style={{
                            padding: "10px 0",
                            cursor: item.onClick ? "pointer" : "default",
                            backgroundColor: item.read
                              ? undefined
                              : "rgba(82, 196, 26, 0.1)",
                            borderBottom: "1px solid rgba(13, 71, 126, 0.25)",
                          }}
                          onClick={() => {
                            this.marcarMovimientoComoLeido(item.id);
                            if (item.onClick) {
                              item.onClick();
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{ marginRight: 15, marginLeft: 10, fontSize: 17 }}
                            >
                              {this.getIconByNumber(item.icono)}
                            </div>
                            <div style={{ width: "100%", paddingRight: 10 }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <span style={{ fontWeight: "bold" }}>{item.titulo}</span>
                                <span style={{ fontSize: "12px", color: "#888" }}>
                                  {item.fecha}
                                </span>
                              </div>
                              <div
                                style={{ fontWeight: item.read ? "normal" : "bold" }}
                              >
                                {item.mensaje}
                              </div>
                            </div>
                          </div>
                        </List.Item>
                      )}
                    />
                  </>
                ),
              },
            ]}
          />
        </Drawer>
        <ModalAdvertenciaPago
          visible={this.state.modalAdvertenciaPago}
          cerrarModal={this.cerrarModalAdvertenciaPago}
          diasFaltantes={this.state.diasAdvertencia}
        />
        <ModalNotificacionMovimientosInventarioGlobal />

        <ModalNotificacionesOrdenPU
          visible={this.state.modalNotificacionesOrdenPUVisible}
          notificaciones={this.state.notificacionesOrdenPU}
          onClose={this.cerrarModalNotificacionesOrdenPU}
          onMarcarLeida={this.marcarLeidaNotifOrdenPU}
          onVer={this.verNotifOrdenPU}
        />

        <ModalItem
          visible={this.state.modalLogout}
          onCancel={this.cerrarModalLogout}
          onOk={this.logout}
          width={400}
          footer
          okText="Cerrar Sesión"
          cancelText="Cancelar"
          centered
          spinning={false}
        >
          <div style={{ padding: "20px 0", textAlign: "center" }}>
            <h3>¿Deseas cerrar sesión?</h3>
          </div>
        </ModalItem>
        {/* {this.state.chatVisible && <ChatbotWidget/>}
        <>
          <FloatButton  onClick={this.toggleChat} className="boton-flotante-custom" />

          <style>
            {`
              .boton-flotante-custom .ant-float-btn-body {
                background-color: #CCDE47 !important;
                color: #ffffff !important;
                border: none;
              }
            `}
          </style>
        </>  */}
      </Layout>
    );
  }
}

// Todos los permisos del modulo de Activos Fijos. Se usan en conjunto para decidir si
// el SubMenu "Activos Fijos" se muestra: si el usuario no tiene ninguno activado, el
// modulo entero desaparece del panel (Tipos de Activo y Activos no tienen permiso de
// Acceso propio, asi que sin esta lista se verian siempre).
const permisosModuloActivosFijos = [
  "6a6952af49a8383de2bd70ad", // Tipos de Activos - Agregar
  "6a6952f049a8383de2bd712a", // Tipos de Activos - Editar
  "6a69530249a8383de2bd712b", // Tipos de Activos - Deshabilitar
  "6a69531e49a8383de2bd712c", // Activos - Agregar
  "6a69532949a8383de2bd712d", // Activos - Editar
  "6a69533c49a8383de2bd7131", // Activos - Deshabilitar
  "6a69542549a8383de2bd7892", // Inventario de Activos - Acceso
  "6a69540249a8383de2bd7878", // Inventario de Activos - Agregar Unidad
  "6a69544249a8383de2bd78a3", // Movimientos - Acceso
  "6a69546849a8383de2bd78bb", // Depreciaciones - Acceso
  "6a69548a49a8383de2bd78ca", // Depreciaciones - Ver candidatos
];

const mapStateToProps = (state) => {
  // Mismas reglas que `permWithFallback` en Reportes/Reportes.js: si el permiso
  // nuevo ya existe en el usuario manda su valor; si todavia no existe se usa el
  // permiso viejo del que cuelga, para que nadie pierda accesos.
  const permisoConFallback = (permisoId, permisoFallbackId) => {
    if (state.user.tipo === 0) return true;
    const encontrado = state.user.permisos.find(
      (valueTodos) => valueTodos.permisoId.toString() === permisoId
    );
    if (encontrado !== undefined) return !!encontrado.activado;
    return !!state.user.permisos.find(
      (valueTodos) => valueTodos.permisoId.toString() === permisoFallbackId
    )?.activado;
  };

  return {
    empresa: state.empresa.nombre,
    empresaId: state.empresa.id,
    headersToken: state.user.headersToken,
    empresaAutomatica: state.empresa.automatica,
    certificadaDM: state.empresa.certificadaDM,
    envios: state.empresa.envios,
    embarques: state.empresa.embarques,
    importarPedidosIMSS: state.empresa.importarPedidosIMSS,
    modulosConsignaciones: state.empresa.modulosConsignaciones,
    equipoMedico: state.empresa.equipoMedico,
    usuarioId: state.user.usuarioId,
    tipoUsuario: state.user.tipo,
    cuentaVentasPendientes: state.empresa.cuentaVentasPendientes,
    cuentaSugerenciasPendientes: state.empresa.cuentaSugerenciasPendientes,
    cuentaEvaluacionesProveedorPendientes: state.empresa.cuentaEvaluacionesProveedorPendientes,
    conteos: state.empresa.conteos,
    lotesCaducidades: state.empresa.lotesCaducidades,
    puntoDeVenta: state.empresa.puntoDeVenta,
    programarRecordatorioCxC: state.empresa.programarRecordatorioCxC,
    cotizadorPorInsumo: state.empresa.cotizadorPorInsumo,
    ventaOnline: state.empresa.ventaOnline,
    nomina: state.empresa.nomina,
    controlAsistencia: state.empresa.controlAsistencia,
    appMovil: state.empresa.appMovil,
    checadaRemota: state.empresa.checadaRemota,
    workbenchRequisiciones: state.empresa.workbenchRequisiciones,
    mostrarSugerenciasRequisicion: state.empresa.mostrarSugerenciasRequisicion,
    prorrateoDesCostos: state.empresa.prorrateoDesCostos,
    moduloCalidad: state.empresa.moduloCalidad,
    autorizacionesRapidas: state.empresa.autorizacionesRapidas,
    whatsapp: state.empresa.whatsapp,
    buscadorMenu: state.empresa.buscadorMenu,
    permisoAccesoCalidad:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a1090392a586012f03f5b1a"
      )?.activado,
    permisoAccesoControlAsistencia:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a1091cd2a586012f03f5e3c"
      )?.activado,
    crm: state.empresa.crm,
    evaluacionProveedores: state.empresa.evaluacionProveedores,
    preCotizacionIngenieria: state.empresa.preCotizacionIngenieria,
    escuela: state.empresa.escuela,
    permisoAccesoEscuela:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a1e39c18958639144057450"
      )?.activado,
    //Importar Ventas de Libros Digitales: se entra desde la lista de Ventas y tiene permiso
    //propio, independiente del acceso al modulo Escuela.
    permisoImportarVentasLibrosDigitales:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ab9b55abc2e8e8899c085f1"
      )?.activado,
    permisoAccesoBancos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615c96325a335e58746d240e"
      )?.activado,
    permisoAccesoCajaChica:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ca6b1f30e81b54183cf4f"
      )?.activado,
    permisoAccesoCuentasPorCobrar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cbb4ff30e81b54183cf56"
      )?.activado,
    permisoAccesoOrdenesDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cbd84f30e81b54183cf5d"
      )?.activado,
    permisoAccesoFacturasSinOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cbec7f30e81b54183cf5f"
      )?.activado,
    permisoAccesoRemisiones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "000000000000000000000001"
      )?.activado,
    permisoAccesoComodato:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a03f6ad92846884441258f8"
      )?.activado,
    permisoAccesoFacturasCajaChica:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cc550f30e81b54183cf65"
      )?.activado,
    permisoAccesoVentas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccb1cf30e81b54183cf6f"
      )?.activado,
    permisoAccesoInsumos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccce4f30e81b54183cf74"
      )?.activado,
    permisoAccesoFiltrosAvanzados:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a0c8e5895cdbbe290cdf782"
      )?.activado,
    filtrosAvanzadosInsumos: state.empresa.filtrosAvanzadosInsumos,
    permisoAccesoFamilias:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cceadf30e81b54183cf78"
      )?.activado,
    permisoAlgunoActivosFijos:
      state.user.tipo === 0 ||
      state.user.permisos.some(
        (valueTodos) =>
          permisosModuloActivosFijos.includes(
            valueTodos.permisoId.toString()
          ) && valueTodos.activado
      ),
    permisoAccesoInventarioActivos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a69542549a8383de2bd7892"
      )?.activado,
    permisoAccesoMovimientosActivos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a69544249a8383de2bd78a3"
      )?.activado,
    permisoAccesoDepreciaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a69546849a8383de2bd78bb"
      )?.activado,
    permisoAccesoClientes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cd417f30e81b54183cf87"
      )?.activado,
    permisoAccesoConfiguracionClientes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a4595a1d14cbe49dcfc6283"
      )?.activado,
    permisoAccesoTipoDeClientes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cd4e4f30e81b54183cf8a"
      )?.activado,
    permisoAccesoProveedores:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cd6c4f30e81b54183cf90"
      )?.activado,
    permisoAccesoTipoDeProveedores:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cd77cf30e81b54183cf93"
      )?.activado,
    permisoAccesoCuentasContables:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cda3ef30e81b54183cf9c"
      )?.activado,
    permisoAccesoTipoDePolizas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cdbaaf30e81b54183cf9f"
      )?.activado,
    permisoAccesoTipoDeFlujos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cdce1f30e81b54183cfa2"
      )?.activado,
    permisoAccesoImpuestos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cddf1f30e81b54183cfa5"
      )?.activado,
    permisoAccesoRetenciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cde9af30e81b54183cfa8"
      )?.activado,
    permisoAccesoCuentasPorPagar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ce296f30e81b54183cfad"
      )?.activado,
    permisoAccesoPolizas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cea60f30e81b54183cfbe"
      )?.activado,
    permisoAccesoCargosAbonos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ceb36f30e81b54183cfc1"
      )?.activado,
    permisoAccesoReclasificacionCargosAbonos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a6d4eb37a97b0650e12665a"
      )?.activado,
    permisoAccesoUnidadesDeNegocio:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cecdbf30e81b54183cfc6"
      )?.activado,
    permisoAccesoProyectos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ced40f30e81b54183cfc8"
      )?.activado,
    permisoAccesoUbicaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a5408cee00cff7ab4c38915"
      )?.activado,
    permisoAgregarUbicacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a5408afe00cff7ab4c38913"
      )?.activado,
    moduloWms: state.empresa.moduloWms,
    moduloActivosFijos: state.empresa.moduloActivosFijos,
    moduloCMMS: state.empresa.moduloCMMS,
    moduloHoteleria: state.empresa.moduloHoteleria,
    moduloRMA: state.empresa.moduloRMA,
    moduloProduccion: state.empresa.moduloProduccion,
    moduloBOM: state.empresa.moduloBOM,
    transporte: state.empresa.transporte,
    portalClientes: state.empresa.portalClientes,
    creditos: state.empresa.creditos,
    moduloRMACompras: state.empresa.moduloRMACompras,
    permisoAccesoConfiguracion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ceea4f30e81b54183cfcf"
      )?.activado,
    permisoAccesoInicio:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615dd9e78b9901c35431f498"
      )?.activado,
    permisoCobrar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cbbc8f30e81b54183cf57"
      )?.activado,
    permisoAccesoReportes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "64908a33ce82367cc8068c2b"
      )?.activado,
    permisoAccesoReporteCreadorDeReportes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (v) => v.permisoId.toString() === "6a74d41feed3067780a5add6"
      )?.activado,
    permisoAccesoReporteVentasGenerales:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ee6f6ebb47b9440df7b0"
      )?.activado,
    permisoAccesoReporteComprasGenerales:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ef026ebb47b9440df7b1"
      )?.activado,
    permisoAccesoReporteCostosInternos:
      state.user.tipo === 0 || true,
    permisoAccesoReporteComodatos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a624ed2f04f1ced48a77414"
      )?.activado,
    permisoAccesoReporteNotasDeCreditoCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a62ab9cf04f1ced48a85550"
      )?.activado,
    // Permiso "Reporte Insumos - proveedores" (numero 70). El fallback a
    // Compras Generales cubre a los usuarios a los que todavia no se les
    // asigno el permiso nuevo, para que no pierdan el acceso a la seccion.
    // Este id tiene que ser IDENTICO al de Reportes/Reportes.js: si divergen,
    // un usuario puede no ver la tarjeta pero si entrar por la URL.
    permisoAccesoReporteInsumosYProveedores: permisoConFallback(
      "6ab095a134110875ce269c73",
      "6489ef026ebb47b9440df7b1"
    ),
    permisoAccesoReporteInventarioTotal:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ef186ebb47b9440df7b2"
      )?.activado,
    permisoAccesoReporteCostoInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ef3a6ebb47b9440df7b3"
      )?.activado,
    // Mientras no exista el documento Permiso propio, el id placeholder nunca
    // hace match y manda el permiso de Costo Inventario. Al crearlo, sustituir
    // los 24 ceros aqui y en Reportes/Reportes.js.
    permisoAccesoReporteCostoVsUltimaCompra: permisoConFallback(
      "000000000000000000000000",
      "6489ef3a6ebb47b9440df7b3"
    ),
    // Permiso "Reporte Insumos" (numero 120). Ya existe en la BD, asi que no
    // lleva fallback: sin el permiso no se ve el reporte.
    permisoAccesoReporteInsumosYEquivalencias: permisoConFallback(
      "6aa34afa3d2dd25d76ad48a2"
    ),
    // Permiso "Costos Por Insumo" (numero 130). Ya existe en la BD, asi que no
    // lleva fallback: sin el permiso no se ve el reporte. El mismo id literal
    // va en Reportes/Reportes.js.
    permisoAccesoReporteCostosPorInsumo: permisoConFallback(
      "6ab3ee2de5f258ab475da861"
    ),
    permisoAccesoReporteLotes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a75229ca0ca425474d8ca8d"
      )?.activado,
    permisoAccesoReporteCuentasPorCobrar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ef556ebb47b9440df7b4"
      )?.activado,
    permisoAccesoReporteCuentasPorPagar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ef796ebb47b9440df7b5"
      )?.activado,
    permisoAccesoReporteEstadoDePosicionFinanciera:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ef8f6ebb47b9440df7b6"
      )?.activado,
    permisoAccesoReporteEstadoDeResultados:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489efb16ebb47b9440df7b7"
      )?.activado,
    // Mientras no exista el documento Permiso propio, el id placeholder nunca
    // hace match y manda el permiso del Estado de Resultados. Al crearlo,
    // sustituir los 24 ceros aqui y en Reportes/Reportes.js.
    permisoAccesoReporteEstadoDeResultadosPorPeriodo: permisoConFallback(
      "000000000000000000000000",
      "6489efb16ebb47b9440df7b7"
    ),
    // Mismo placeholder que en Reportes/Reportes.js: mientras no exista el Permiso
    // propio manda el del Flujo De Efectivo.
    permisoAccesoReporteFlujoDeEfectivoDiario: permisoConFallback(
      "000000000000000000000000",
      "6489f00b6ebb47b9440df7ba"
    ),
    permisoAccesoReporteEstadoDeCuenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489efd56ebb47b9440df7b8"
      )?.activado,
    permisoAccesoReporteBalanzaDeComprabacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489efeb6ebb47b9440df7b9"
      )?.activado,
    permisoAccesoReporteFlujoDeEfectivo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489f00b6ebb47b9440df7ba"
      )?.activado,
    permisoAccesoReporteFlujoDeTesorefia:
      state.user.tipo === 0 ||
      (state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2241c081aa896b004c9bf4"
      )?.activado ?? true),
    permisoAccesoServicios:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472d53f4b2da7c85c1a8d01"
      )?.activado,
    permisoAccesoInsumosCompuetos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472d63b4b2da7c85c1a8d05"
      )?.activado,
    permisoAccesoTraspasoAlmacenes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6478f25a0d24b4b09c994351"
      )?.activado,
    permisoAccesoProduccion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472de194b2da7c85c1a8d10"
      )?.activado,
    permisoAccesoListaDeMateriales:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472df204b2da7c85c1a8d13"
      )?.activado,
    permisoAccesoLeerXml:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647a1df7bd6a695a9801702f"
      )?.activado,
    permisoAccesoInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cd133f30e81b54183cf80"
      )?.activado,
    permisoAccesoAlmacen:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9f15463a05033a32675803"
      )?.activado,
    permisoRequerirMaterialAlmacen:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9f1563b517fea9fcacaf7f"
      )?.activado,
    permisoAccesoOrdenesProduccionPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9f15873a05033a32675a48"
      )?.activado,
    permisoAccesoMovimientosInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69fe8ef5d4eff74041f388f0"
      )?.activado,
    permisoVerMovimientosInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69fe8f1bd4eff74041f388f1"
      )?.activado,
    permisoMostrarCostosMovimientosInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69fe8f69d4eff74041f388f2"
      )?.activado,
    permisoAccesoAgregarInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472dc304b2da7c85c1a8d0e"
      )?.activado,
    permisoAccesoProductosAlCosto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647fc47d9dc9c6543b161b89"
      )?.activado,
    permisoAccesoArchivosXML:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "67508ec3798d4e0043687238"
      )?.activado,
    permisoAccesoCotizaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675091fa798d4e0043687241"
      )?.activado,
    permisoAccesoAgregarCotizaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750922d798d4e0043687242"
      )?.activado,
    permisoAccesoVerCotizaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750925b798d4e0043687244"
      )?.activado,
    permisoAgregarConsignacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675092cc798d4e0043687246"
      )?.activado,
    permisoDarBajaConsignacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750933f798d4e0043687247"
      )?.activado,
    permisoAgregarConsignacionInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750938e798d4e0043687248"
      )?.activado,
    permisoDarBajaConsignacionInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675093ca798d4e0043687249"
      )?.activado,
    permisoAgregarMatriz:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750960a798d4e0043687252"
      )?.activado,
    taxidermia: state.empresa.taxidermia,
    permisoAccesoPedidos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "689fd3bc7ec315a681480e98"
      )?.activado,
    permisoAgregarPedidos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "689fd5677ec315a681480e9a"
      )?.activado,
    permisoEditarPedidos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69025d9e665a8b9d4efb4eb0"
      )?.activado,
    permisoVerPedidos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69025dbc665a8b9d4efb4eb1"
      )?.activado,
    permisoAccesoEmbarques:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f9436a54f5250e669a4a74"
      )?.activado,
    permisoAgregarEmbarques:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f9435654f5250e669a4a6f"
      )?.activado,
    permisoEditarEmbarques:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f9439954f5250e669a4a8c"
      )?.activado,
    permisoVerEmbarques:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f943c654f5250e669a4a95"
      )?.activado,
    permisoEntregarEmbarques:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f943ac54f5250e669a4a8d"
      )?.activado,
    permisoVerBitacora:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69348e92517edec9f036d770"
      )?.activado,
    permisoAccesoAutorizaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a4e7aa9c1cbb316e2e6f94e"
      )?.activado,
    permisoAccesoEcommerce:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "697e2c2db47586150a762dc9"
      )?.activado,
    permisoVerRequisiciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647a1664bd6a695a9801702a"
      )?.activado,
    permisoAccesoUnidades:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "698f5f3e668f5467a18e72f9"
      )?.activado,
    permisoAccesoVehiculos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6998f4aea42a498a7a6cac30"
      )?.activado,
    permisoRendimientoVehiculos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a430b6a101fa825078813bc"
      )?.activado,
    permisoAgregarPolizasSeguro:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6998f52ba42a498a7a6cac31"
      )?.activado,
    permisoEditarPolizasSeguro:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6998f53da42a498a7a6cac32"
      )?.activado,
    permisoHabilitarPolizasSeguro:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6998f579a42a498a7a6cac33"
      )?.activado,
    permisoAccesoReporteInsumosMasComprados:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69d443d0d1cda4af6dfca7c9"
      )?.activado,
    permisoAccesoReporteEmpleados:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a695ae449a8383de2bd9857"
      )?.activado,
    permisoAccesoReporteRegistroEmpleados:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a695b0549a8383de2bd9858"
      )?.activado,
    permisoAccesoReporteInsumosMasVendidos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69d44413d1cda4af6dfca7fa"
      )?.activado,
    permisoAccesoReporteMargenVentas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a750cb96dd22e624b4b6f53"
      )?.activado,
    // Ventas Por Lote no tiene Permiso propio en la base: se rige por Ventas Generales
    // ("6489ee6f6ebb47b9440df7b0"), igual que en el mapStateToProps de Reportes.js.
    permisoAccesoReporteVentasPorLote:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6489ee6f6ebb47b9440df7b0"
      )?.activado,
    // Los dos reportes de conversion si tienen Permiso propio. El `??` replica el
    // `permWithFallback` de Reportes.js: si el documento Permiso todavia no existe en la base,
    // el `find` devuelve undefined y manda Ventas Generales. Sin ese fallback la tarjeta se
    // veria (Reportes.js si lo hace) pero la ruta no existiria.
    permisoAccesoReporteCotizacionVsVentas:
      state.user.tipo === 0 ||
      (state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ab095ee7a54c4287414586d"
      )?.activado ??
        state.user.permisos.find(
          (valueTodos) =>
            valueTodos.permisoId.toString() === "6489ee6f6ebb47b9440df7b0"
        )?.activado),
    permisoAccesoReportePedidoVsVentas:
      state.user.tipo === 0 ||
      (state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ab095fb34110875ce269c74"
      )?.activado ??
        state.user.permisos.find(
          (valueTodos) =>
            valueTodos.permisoId.toString() === "6489ee6f6ebb47b9440df7b0"
        )?.activado),
    permisoAccesoCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69e24beaa41f0d3de8e55c40"
      )?.activado,
    permisoMasterCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a170cabe0d8ec48005e197f"
      )?.activado,
    permisoAccesoWhatsapp:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2d92c46b6fbe4192c21cd0"
      )?.activado,
    permisoConfiguracionWhatsapp:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2d92d76b6fbe4192c21d05"
      )?.activado,
    permisoElementosWhatsapp:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a319b93047d1278102f2636"
      )?.activado,
    permisoGuardarImagenInsumo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a342cafe0b60690857dde2b"
      )?.activado,
    permisoMensajeMasivo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a3afc9965cffab7b63b9b12"
      )?.activado,
    permisoReporteEmbudoCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a170d05e0d8ec48005e1a2b"
      )?.activado,
    permisoReporteGanadasCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a170d1fe0d8ec48005e1a8d"
      )?.activado,
    permisoReportePipelineCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a170d5de0d8ec48005e1a95"
      )?.activado,
    permisoReporteLeadsCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a170d7de0d8ec48005e1ad8"
      )?.activado,
    permisoReporteEquipoCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a170d9ae0d8ec48005e1ae6"
      )?.activado,
    permisoAccesoConfiguracionCRM:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69e9994e200bae6f82429037",
      )?.activado,
    // Permisos de Evaluación de Proveedores, definidos manualmente en Permisos.js
    permisoAccesoEvaluacionProveedores:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a726d2e84bfe1e26a3e4c65",
      )?.activado,
    permisoConfigurarPlantillasEvaluacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a726d3e84bfe1e26a3e4c6a",
      )?.activado,
    permisoVerReportesEvaluacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a726d5a84bfe1e26a3e4cfc",
      )?.activado,
    permisoAccesoRelojesChecadores:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02b837899dda241377d1d"
      )?.activado,
    permisoAccesoAsignacionRelojes:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02b8c7899dda241377d1e"
      )?.activado,
    permisoAccesoAsistencia:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02b957899dda241377d1f"
      )?.activado,
    permisoAccesoHorarios:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02ba07899dda241377d20"
      )?.activado,
    permisoAccesoDescansos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02ba77899dda241377d21"
      )?.activado,
    permisoAccesoTurnos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02baf7899dda241377d22"
      )?.activado,
    permisoAccesoAsignacionTurnos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02bb77899dda241377d23"
      )?.activado,
    permisoAccesoCalendarioEmpleado:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02bc07899dda241377d24"
      )?.activado,
    permisoAccesoPrimeroUltimo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02bde7899dda241377d25"
      )?.activado,
    permisoAccesoAsistenciaDiaria:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02bf47899dda241377d26"
      )?.activado,
    permisoEmpleadosSitio:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a0158d90e27975d5aae7105"
      )?.activado,
    permisoAccesoTotalAsistencia:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02c097899dda241377d27"
      )?.activado,
    permisoAccesoConfiguracionAsistencia:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "69f02e9a7899dda241377e46"
      )?.activado,
    permisoAccesoCapitalHumano:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0c2882da30a9d46cbf1ad"
      )?.activado,
    permisoAccesoPreciosUnitarios:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0ccfc2da30a9d46cbf1af"
      )?.activado,
    permisoAgregarCreditos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207315cd914b37f4b03307"
      )?.activado,
    permisoEditarCreditos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207327cd914b37f4b03308"
      )?.activado,
    permisoCancelarCredito:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207331cd914b37f4b03309"
      )?.activado,

    // ── Capital Humano: acceso por pantalla ──────────────────────────────
    // Van ADEMÁS de permisoAccesoCapitalHumano, que sigue controlando el
    // submenú completo. Un usuario no-master que hoy ve estas pantallas dejará
    // de verlas hasta que se le active el permiso en su perfil.
    permisoAccesoDepartamentos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a96034b8b7c192b16f8abd1"
      )?.activado,
    permisoAccesoVacaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9603c06102bd5076d2a3e3"
      )?.activado,
    permisoAccesoPuestos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9603ce8b7c192b16f8acb6"
      )?.activado,
    permisoAccesoPrenomina:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a96041e6102bd5076d2a3ec"
      )?.activado,
    permisoAccesoCreditosMovimientos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a96042d6102bd5076d2a3ee"
      )?.activado,
    permisoAccesoRecibos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9604388b7c192b16f8ad20"
      )?.activado,
    permisoAccesoReportesNomina:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a96044a6102bd5076d2a3ef"
      )?.activado,
    permisoAccesoConfiguracionNomina:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a96045e6102bd5076d2a3f8"
      )?.activado,
  };
};

export default connect(mapStateToProps, {
  logout,
  deseleccionarEmpresa,
  contarVentasPPendientes,
  contarSugerenciasPendientes,
  contarEvaluacionesProveedorPendientes,
})(Panel);
